var _style, _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _polygon, _path111, _polygon2, _path112, _polygon3, _path113, _polygon4, _path114, _path115, _polygon5, _path116, _path117, _polygon6, _path118, _path119, _polygon7, _path120, _polygon8, _path121, _polygon9, _path122, _polygon10, _path123, _path124, _polygon11, _path125, _polygon12, _path126, _path127, _polygon13, _path128, _polygon14, _path129, _polygon15, _path130, _path131, _polygon16, _path132, _path133, _polygon17, _path134, _polygon18, _polygon19, _polygon20, _path135, _polygon21, _g, _polygon22, _polygon23, _polygon24, _polygon25, _g2, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNitaLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1769 145.1",
    style: {
      enableBackground: "new 0 0 1769 145.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0.7;clip-path:url(#SVGID_2_);}\n\t.st1{fill:url(#SVGID_3_);}\n\t.st2{fill:url(#SVGID_4_);}\n\t.st3{fill:url(#SVGID_5_);}\n\t.st4{fill:url(#SVGID_6_);}\n\t.st5{fill:url(#SVGID_7_);}\n\t.st6{fill:url(#SVGID_8_);}\n\t.st7{fill:url(#SVGID_9_);}\n\t.st8{fill:url(#SVGID_10_);}\n\t.st9{fill:url(#SVGID_11_);}\n\t.st10{fill:url(#SVGID_12_);}\n\t.st11{fill:url(#SVGID_13_);}\n\t.st12{fill:url(#SVGID_14_);}\n\t.st13{fill:url(#SVGID_15_);}\n\t.st14{fill:url(#SVGID_16_);}\n\t.st15{fill:url(#SVGID_17_);}\n\t.st16{fill:url(#SVGID_18_);}\n\t.st17{fill:url(#SVGID_19_);}\n\t.st18{fill:url(#SVGID_20_);}\n\t.st19{fill:url(#SVGID_21_);}\n\t.st20{fill:url(#SVGID_22_);}\n\t.st21{fill:url(#SVGID_23_);}\n\t.st22{fill:url(#SVGID_24_);}\n\t.st23{fill:url(#SVGID_25_);}\n\t.st24{fill:url(#SVGID_26_);}\n\t.st25{fill:url(#SVGID_27_);}\n\t.st26{fill:url(#SVGID_28_);}\n\t.st27{fill:url(#SVGID_29_);}\n\t.st28{fill:url(#SVGID_30_);}\n\t.st29{fill:url(#SVGID_31_);}\n\t.st30{fill:url(#SVGID_32_);}\n\t.st31{fill:url(#SVGID_33_);}\n\t.st32{fill:url(#SVGID_34_);}\n\t.st33{fill:url(#SVGID_35_);}\n\t.st34{fill:url(#SVGID_36_);}\n\t.st35{fill:url(#SVGID_37_);}\n\t.st36{fill:url(#SVGID_38_);}\n\t.st37{fill:url(#SVGID_39_);}\n\t.st38{fill:url(#SVGID_40_);}\n\t.st39{fill:url(#SVGID_41_);}\n\t.st40{fill:url(#SVGID_42_);}\n\t.st41{fill:url(#SVGID_43_);}\n\t.st42{fill:url(#SVGID_44_);}\n\t.st43{fill:url(#SVGID_45_);}\n\t.st44{fill:url(#SVGID_46_);}\n\t.st45{fill:url(#SVGID_47_);}\n\t.st46{fill:url(#SVGID_48_);}\n\t.st47{fill:url(#SVGID_49_);}\n\t.st48{fill:url(#SVGID_50_);}\n\t.st49{fill:url(#SVGID_51_);}\n\t.st50{fill:url(#SVGID_52_);}\n\t.st51{fill:url(#SVGID_53_);}\n\t.st52{fill:url(#SVGID_54_);}\n\t.st53{fill:url(#SVGID_55_);}\n\t.st54{fill:url(#SVGID_56_);}\n\t.st55{fill:url(#SVGID_57_);}\n\t.st56{fill:url(#SVGID_58_);}\n\t.st57{fill:url(#SVGID_59_);}\n\t.st58{fill:url(#SVGID_60_);}\n\t.st59{fill:url(#SVGID_61_);}\n\t.st60{fill:url(#SVGID_62_);}\n\t.st61{fill:url(#SVGID_63_);}\n\t.st62{fill:url(#SVGID_64_);}\n\t.st63{fill:url(#SVGID_65_);}\n\t.st64{fill:url(#SVGID_66_);}\n\t.st65{fill:url(#SVGID_67_);}\n\t.st66{fill:url(#SVGID_68_);}\n\t.st67{fill:url(#SVGID_69_);}\n\t.st68{fill:url(#SVGID_70_);}\n\t.st69{fill:url(#SVGID_71_);}\n\t.st70{fill:url(#SVGID_72_);}\n\t.st71{fill:url(#SVGID_73_);}\n\t.st72{fill:url(#SVGID_74_);}\n\t.st73{fill:url(#SVGID_75_);}\n\t.st74{fill:url(#SVGID_76_);}\n\t.st75{fill:url(#SVGID_77_);}\n\t.st76{fill:url(#SVGID_78_);}\n\t.st77{fill:url(#SVGID_79_);}\n\t.st78{fill:url(#SVGID_80_);}\n\t.st79{fill:url(#SVGID_81_);}\n\t.st80{fill:url(#SVGID_82_);}\n\t.st81{fill:url(#SVGID_83_);}\n\t.st82{fill:url(#SVGID_84_);}\n\t.st83{fill:url(#SVGID_85_);}\n\t.st84{fill:url(#SVGID_86_);}\n\t.st85{fill:url(#SVGID_87_);}\n\t.st86{fill:url(#SVGID_88_);}\n\t.st87{fill:url(#SVGID_89_);}\n\t.st88{fill:url(#SVGID_90_);}\n\t.st89{fill:url(#SVGID_91_);}\n\t.st90{fill:url(#SVGID_92_);}\n\t.st91{fill:url(#SVGID_93_);}\n\t.st92{fill:url(#SVGID_94_);}\n\t.st93{fill:url(#SVGID_95_);}\n\t.st94{fill:url(#SVGID_96_);}\n\t.st95{fill:url(#SVGID_97_);}\n\t.st96{fill:url(#SVGID_98_);}\n\t.st97{fill:url(#SVGID_99_);}\n\t.st98{fill:url(#SVGID_100_);}\n\t.st99{fill:url(#SVGID_101_);}\n\t.st100{fill:url(#SVGID_102_);}\n\t.st101{fill:url(#SVGID_103_);}\n\t.st102{fill:url(#SVGID_104_);}\n\t.st103{fill:url(#SVGID_105_);}\n\t.st104{fill:url(#SVGID_106_);}\n\t.st105{fill:url(#SVGID_107_);}\n\t.st106{fill:url(#SVGID_108_);}\n\t.st107{fill:url(#SVGID_109_);}\n\t.st108{fill:url(#SVGID_110_);}\n\t.st109{fill:url(#SVGID_111_);}\n\t.st110{fill:url(#SVGID_112_);}\n\t.st111{fill:url(#SVGID_113_);}\n\t.st112{fill:url(#SVGID_114_);}\n\t.st113{fill:url(#SVGID_115_);}\n\t.st114{fill:url(#SVGID_116_);}\n\t.st115{fill:url(#SVGID_117_);}\n\t.st116{fill:url(#SVGID_118_);}\n\t.st117{fill:url(#SVGID_119_);}\n\t.st118{fill:url(#SVGID_120_);}\n\t.st119{fill:url(#SVGID_121_);}\n\t.st120{fill:url(#SVGID_122_);}\n\t.st121{fill:url(#SVGID_123_);}\n\t.st122{fill:url(#SVGID_124_);}\n\t.st123{fill:url(#SVGID_125_);}\n\t.st124{fill:url(#SVGID_126_);}\n\t.st125{fill:url(#SVGID_127_);}\n\t.st126{fill:url(#SVGID_128_);}\n\t.st127{fill:url(#SVGID_129_);}\n\t.st128{fill:url(#SVGID_130_);}\n\t.st129{fill:url(#SVGID_131_);}\n\t.st130{fill:url(#SVGID_132_);}\n\t.st131{fill:url(#SVGID_133_);}\n\t.st132{fill:url(#SVGID_134_);}\n\t.st133{fill:url(#SVGID_135_);}\n\t.st134{fill:url(#SVGID_136_);}\n\t.st135{fill:url(#SVGID_137_);}\n\t.st136{fill:url(#SVGID_138_);}\n\t.st137{fill:url(#SVGID_139_);}\n\t.st138{fill:url(#SVGID_140_);}\n\t.st139{fill:url(#SVGID_141_);}\n\t.st140{fill:url(#SVGID_142_);}\n\t.st141{fill:url(#SVGID_143_);}\n\t.st142{fill:url(#SVGID_144_);}\n\t.st143{fill:url(#SVGID_145_);}\n\t.st144{fill:url(#SVGID_146_);}\n\t.st145{fill:url(#SVGID_147_);}\n\t.st146{fill:url(#SVGID_148_);}\n\t.st147{fill:url(#SVGID_149_);}\n\t.st148{fill:url(#SVGID_150_);}\n\t.st149{fill:url(#SVGID_151_);}\n\t.st150{fill:url(#SVGID_152_);}\n\t.st151{fill:url(#SVGID_153_);}\n\t.st152{fill:url(#SVGID_154_);}\n\t.st153{fill:url(#SVGID_155_);}\n\t.st154{fill:url(#SVGID_156_);}\n\t.st155{fill:url(#SVGID_157_);}\n\t.st156{fill:url(#SVGID_158_);}\n\t.st157{fill:url(#SVGID_159_);}\n\t.st158{fill:url(#SVGID_160_);}\n\t.st159{fill:url(#SVGID_161_);}\n\t.st160{fill:url(#SVGID_162_);}\n\t.st161{fill:url(#SVGID_163_);}\n\t.st162{fill:url(#SVGID_164_);}\n\t.st163{fill:url(#SVGID_165_);}\n\t.st164{fill:url(#SVGID_166_);}\n\t.st165{fill:url(#SVGID_167_);}\n\t.st166{fill:url(#SVGID_168_);}\n\t.st167{fill:url(#SVGID_169_);}\n\t.st168{fill:url(#SVGID_170_);}\n\t.st169{fill:url(#SVGID_171_);}\n\t.st170{fill:url(#SVGID_172_);}\n\t.st171{fill:url(#SVGID_173_);}\n\t.st172{fill:url(#SVGID_174_);}\n\t.st173{fill:url(#SVGID_175_);}\n\t.st174{fill:url(#SVGID_176_);}\n\t.st175{fill:url(#SVGID_177_);}\n\t.st176{fill:url(#SVGID_178_);}\n\t.st177{fill:url(#SVGID_179_);}\n\t.st178{fill:url(#SVGID_180_);}\n\t.st179{fill:url(#SVGID_181_);}\n\t.st180{fill:url(#SVGID_182_);}\n\t.st181{fill:url(#SVGID_183_);}\n\t.st182{fill:url(#SVGID_184_);}\n\t.st183{fill:url(#SVGID_185_);}\n\t.st184{fill:url(#SVGID_186_);}\n\t.st185{fill:url(#SVGID_187_);}\n\t.st186{fill:url(#SVGID_188_);}\n\t.st187{fill:url(#SVGID_189_);}\n\t.st188{fill:url(#SVGID_190_);}\n\t.st189{fill:url(#SVGID_191_);}\n\t.st190{fill:url(#SVGID_192_);}\n\t.st191{fill:url(#SVGID_193_);}\n\t.st192{fill:url(#SVGID_194_);}\n\t.st193{fill:url(#SVGID_195_);}\n\t.st194{fill:url(#SVGID_196_);}\n\t.st195{fill:url(#SVGID_197_);}\n\t.st196{fill:url(#SVGID_198_);}\n\t.st197{fill:url(#SVGID_199_);}\n\t.st198{fill:url(#SVGID_200_);}\n\t.st199{fill:url(#SVGID_201_);}\n\t.st200{fill:url(#SVGID_202_);}\n\t.st201{fill:url(#SVGID_203_);}\n\t.st202{fill:url(#SVGID_204_);}\n\t.st203{fill:url(#SVGID_205_);}\n\t.st204{fill:url(#SVGID_206_);}\n\t.st205{fill:url(#SVGID_207_);}\n\t.st206{fill:url(#SVGID_208_);}\n\t.st207{fill:url(#SVGID_209_);}\n\t.st208{fill:url(#SVGID_210_);}\n\t.st209{fill:url(#SVGID_211_);}\n\t.st210{fill:#838B16;}\n\t.st211{fill:url(#SVGID_212_);}\n\t.st212{fill:url(#SVGID_213_);}\n\t.st213{opacity:0.4;}\n\t.st214{opacity:0.7;fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_214_);enable-background:new    ;}\n\t.st215{opacity:0.7;fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_215_);enable-background:new    ;}\n\t.st216{opacity:0.7;fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_216_);enable-background:new    ;}\n\t.st217{opacity:0.7;fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_217_);enable-background:new    ;}\n\t.st218{opacity:0.7;fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_218_);enable-background:new    ;}\n\t.st219{opacity:0.7;fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_219_);enable-background:new    ;}\n\t.st220{opacity:0.7;fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_220_);enable-background:new    ;}\n\t.st221{opacity:0.7;fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_221_);enable-background:new    ;}\n\t.st222{opacity:0.7;fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_222_);enable-background:new    ;}\n\t.st223{opacity:0.7;fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_223_);enable-background:new    ;}\n\t.st224{opacity:0.7;fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_224_);enable-background:new    ;}\n\t.st225{opacity:0.7;fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_225_);enable-background:new    ;}\n\t.st226{opacity:0.7;fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_226_);enable-background:new    ;}\n\t.st227{opacity:0.7;fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_227_);enable-background:new    ;}\n\t.st228{opacity:0.7;fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_228_);enable-background:new    ;}\n\t.st229{opacity:0.7;fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_229_);enable-background:new    ;}\n\t.st230{opacity:0.7;fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_230_);enable-background:new    ;}\n\t.st231{opacity:0.7;fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_231_);enable-background:new    ;}\n\t.st232{opacity:0.7;fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_232_);enable-background:new    ;}\n\t.st233{opacity:0.7;fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_233_);enable-background:new    ;}\n\t.st234{opacity:0.7;fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_234_);enable-background:new    ;}\n\t.st235{opacity:0.7;fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_235_);enable-background:new    ;}\n\t.st236{opacity:0.7;fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_236_);enable-background:new    ;}\n\t.st237{opacity:0.7;fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_237_);enable-background:new    ;}\n\t.st238{opacity:0.7;fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_238_);enable-background:new    ;}\n\t.st239{opacity:0.7;fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_239_);enable-background:new    ;}\n\t.st240{opacity:0.7;fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_240_);enable-background:new    ;}\n\t.st241{opacity:0.7;fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_241_);enable-background:new    ;}\n\t.st242{opacity:0.7;fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_242_);enable-background:new    ;}\n\t.st243{opacity:0.7;fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_243_);enable-background:new    ;}\n\t.st244{opacity:0.7;fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_244_);enable-background:new    ;}\n\t.st245{opacity:0.7;fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_245_);enable-background:new    ;}\n\t.st246{opacity:0.7;fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_246_);enable-background:new    ;}\n\t.st247{opacity:0.7;}\n\t.st248{fill:url(#SVGID_247_);}\n\t.st249{fill:url(#SVGID_248_);}\n\t.st250{fill:url(#SVGID_249_);}\n\t.st251{fill:url(#SVGID_250_);}\n\t.st252{fill:url(#SVGID_251_);}\n\t.st253{fill:url(#SVGID_252_);}\n\t.st254{fill:url(#SVGID_253_);}\n\t.st255{fill:url(#SVGID_254_);}\n\t.st256{fill:url(#SVGID_255_);}\n\t.st257{fill:url(#SVGID_256_);}\n\t.st258{fill:url(#SVGID_257_);}\n\t.st259{fill:url(#SVGID_258_);}\n\t.st260{fill:url(#SVGID_259_);}\n\t.st261{fill:url(#SVGID_260_);}\n\t.st262{fill:url(#SVGID_261_);}\n\t.st263{fill:url(#SVGID_262_);}\n\t.st264{fill:url(#SVGID_263_);}\n\t.st265{fill:url(#SVGID_264_);}\n\t.st266{fill:url(#SVGID_265_);}\n\t.st267{fill:url(#SVGID_266_);}\n\t.st268{fill:url(#SVGID_267_);}\n\t.st269{fill:url(#SVGID_268_);}\n\t.st270{fill:url(#SVGID_269_);}\n\t.st271{fill:url(#SVGID_270_);}\n\t.st272{fill:url(#SVGID_271_);}\n\t.st273{fill:url(#SVGID_272_);}\n\t.st274{fill:url(#SVGID_273_);}\n\t.st275{fill:url(#SVGID_274_);}\n\t.st276{fill:url(#SVGID_275_);}\n\t.st277{fill:url(#SVGID_276_);}\n\t.st278{fill:url(#SVGID_277_);}\n\t.st279{fill:#ADBA41;}\n\t.st280{fill:url(#SVGID_278_);}\n\t.st281{fill:url(#SVGID_279_);}\n\t.st282{fill:url(#SVGID_280_);}\n\t.st283{fill:url(#SVGID_281_);}\n\t.st284{fill:url(#SVGID_282_);}\n\t.st285{fill:url(#SVGID_283_);}\n\t.st286{fill:url(#SVGID_284_);}\n\t.st287{fill:url(#SVGID_285_);}\n\t.st288{fill:url(#SVGID_286_);}\n\t.st289{clip-path:url(#SVGID_2_);fill:url(#SVGID_287_);}\n\t.st290{clip-path:url(#SVGID_2_);}\n\t.st291{fill:#383838;}\n\t.st292{fill:#B5C334;}\n\t.st293{opacity:0.7;clip-path:url(#SVGID_289_);}\n\t.st294{fill:url(#SVGID_290_);}\n\t.st295{fill:url(#SVGID_291_);}\n\t.st296{fill:url(#SVGID_292_);}\n\t.st297{fill:url(#SVGID_293_);}\n\t.st298{fill:url(#SVGID_294_);}\n\t.st299{fill:url(#SVGID_295_);}\n\t.st300{fill:url(#SVGID_296_);}\n\t.st301{fill:url(#SVGID_297_);}\n\t.st302{fill:url(#SVGID_298_);}\n\t.st303{fill:url(#SVGID_299_);}\n\t.st304{fill:url(#SVGID_300_);}\n\t.st305{fill:url(#SVGID_301_);}\n\t.st306{fill:url(#SVGID_302_);}\n\t.st307{fill:url(#SVGID_303_);}\n\t.st308{fill:url(#SVGID_304_);}\n\t.st309{fill:url(#SVGID_305_);}\n\t.st310{fill:url(#SVGID_306_);}\n\t.st311{fill:url(#SVGID_307_);}\n\t.st312{fill:url(#SVGID_308_);}\n\t.st313{fill:url(#SVGID_309_);}\n\t.st314{fill:url(#SVGID_310_);}\n\t.st315{fill:url(#SVGID_311_);}\n\t.st316{fill:url(#SVGID_312_);}\n\t.st317{fill:url(#SVGID_313_);}\n\t.st318{fill:url(#SVGID_314_);}\n\t.st319{fill:url(#SVGID_315_);}\n\t.st320{fill:url(#SVGID_316_);}\n\t.st321{fill:url(#SVGID_317_);}\n\t.st322{fill:url(#SVGID_318_);}\n\t.st323{fill:url(#SVGID_319_);}\n\t.st324{fill:url(#SVGID_320_);}\n\t.st325{fill:url(#SVGID_321_);}\n\t.st326{fill:url(#SVGID_322_);}\n\t.st327{fill:url(#SVGID_323_);}\n\t.st328{fill:url(#SVGID_324_);}\n\t.st329{fill:url(#SVGID_325_);}\n\t.st330{fill:url(#SVGID_326_);}\n\t.st331{fill:url(#SVGID_327_);}\n\t.st332{fill:url(#SVGID_328_);}\n\t.st333{fill:url(#SVGID_329_);}\n\t.st334{fill:url(#SVGID_330_);}\n\t.st335{fill:url(#SVGID_331_);}\n\t.st336{fill:url(#SVGID_332_);}\n\t.st337{fill:url(#SVGID_333_);}\n\t.st338{fill:url(#SVGID_334_);}\n\t.st339{fill:url(#SVGID_335_);}\n\t.st340{fill:url(#SVGID_336_);}\n\t.st341{fill:url(#SVGID_337_);}\n\t.st342{fill:url(#SVGID_338_);}\n\t.st343{fill:url(#SVGID_339_);}\n\t.st344{fill:url(#SVGID_340_);}\n\t.st345{fill:url(#SVGID_341_);}\n\t.st346{fill:url(#SVGID_342_);}\n\t.st347{fill:url(#SVGID_343_);}\n\t.st348{fill:url(#SVGID_344_);}\n\t.st349{fill:url(#SVGID_345_);}\n\t.st350{fill:url(#SVGID_346_);}\n\t.st351{fill:url(#SVGID_347_);}\n\t.st352{fill:url(#SVGID_348_);}\n\t.st353{fill:url(#SVGID_349_);}\n\t.st354{fill:url(#SVGID_350_);}\n\t.st355{fill:url(#SVGID_351_);}\n\t.st356{fill:url(#SVGID_352_);}\n\t.st357{fill:url(#SVGID_353_);}\n\t.st358{fill:url(#SVGID_354_);}\n\t.st359{fill:url(#SVGID_355_);}\n\t.st360{fill:url(#SVGID_356_);}\n\t.st361{fill:url(#SVGID_357_);}\n\t.st362{fill:url(#SVGID_358_);}\n\t.st363{fill:url(#SVGID_359_);}\n\t.st364{fill:url(#SVGID_360_);}\n\t.st365{fill:url(#SVGID_361_);}\n\t.st366{fill:url(#SVGID_362_);}\n\t.st367{fill:url(#SVGID_363_);}\n\t.st368{fill:url(#SVGID_364_);}\n\t.st369{fill:url(#SVGID_365_);}\n\t.st370{fill:url(#SVGID_366_);}\n\t.st371{fill:url(#SVGID_367_);}\n\t.st372{fill:url(#SVGID_368_);}\n\t.st373{fill:url(#SVGID_369_);}\n\t.st374{fill:url(#SVGID_370_);}\n\t.st375{fill:url(#SVGID_371_);}\n\t.st376{fill:url(#SVGID_372_);}\n\t.st377{fill:url(#SVGID_373_);}\n\t.st378{fill:url(#SVGID_374_);}\n\t.st379{fill:url(#SVGID_375_);}\n\t.st380{fill:url(#SVGID_376_);}\n\t.st381{fill:url(#SVGID_377_);}\n\t.st382{fill:url(#SVGID_378_);}\n\t.st383{fill:url(#SVGID_379_);}\n\t.st384{fill:url(#SVGID_380_);}\n\t.st385{fill:url(#SVGID_381_);}\n\t.st386{fill:url(#SVGID_382_);}\n\t.st387{fill:url(#SVGID_383_);}\n\t.st388{fill:url(#SVGID_384_);}\n\t.st389{fill:url(#SVGID_385_);}\n\t.st390{fill:url(#SVGID_386_);}\n\t.st391{fill:url(#SVGID_387_);}\n\t.st392{fill:url(#SVGID_388_);}\n\t.st393{fill:url(#SVGID_389_);}\n\t.st394{fill:url(#SVGID_390_);}\n\t.st395{fill:url(#SVGID_391_);}\n\t.st396{fill:url(#SVGID_392_);}\n\t.st397{fill:url(#SVGID_393_);}\n\t.st398{fill:url(#SVGID_394_);}\n\t.st399{fill:url(#SVGID_395_);}\n\t.st400{fill:url(#SVGID_396_);}\n\t.st401{fill:url(#SVGID_397_);}\n\t.st402{fill:url(#SVGID_398_);}\n\t.st403{fill:url(#SVGID_399_);}\n\t.st404{fill:url(#SVGID_400_);}\n\t.st405{fill:url(#SVGID_401_);}\n\t.st406{fill:url(#SVGID_402_);}\n\t.st407{fill:url(#SVGID_403_);}\n\t.st408{fill:url(#SVGID_404_);}\n\t.st409{fill:url(#SVGID_405_);}\n\t.st410{fill:url(#SVGID_406_);}\n\t.st411{fill:url(#SVGID_407_);}\n\t.st412{fill:url(#SVGID_408_);}\n\t.st413{fill:url(#SVGID_409_);}\n\t.st414{fill:url(#SVGID_410_);}\n\t.st415{fill:url(#SVGID_411_);}\n\t.st416{fill:url(#SVGID_412_);}\n\t.st417{fill:url(#SVGID_413_);}\n\t.st418{fill:url(#SVGID_414_);}\n\t.st419{fill:url(#SVGID_415_);}\n\t.st420{fill:url(#SVGID_416_);}\n\t.st421{fill:url(#SVGID_417_);}\n\t.st422{fill:url(#SVGID_418_);}\n\t.st423{fill:url(#SVGID_419_);}\n\t.st424{fill:url(#SVGID_420_);}\n\t.st425{fill:url(#SVGID_421_);}\n\t.st426{fill:url(#SVGID_422_);}\n\t.st427{fill:url(#SVGID_423_);}\n\t.st428{fill:url(#SVGID_424_);}\n\t.st429{fill:url(#SVGID_425_);}\n\t.st430{fill:url(#SVGID_426_);}\n\t.st431{fill:url(#SVGID_427_);}\n\t.st432{fill:url(#SVGID_428_);}\n\t.st433{fill:url(#SVGID_429_);}\n\t.st434{fill:url(#SVGID_430_);}\n\t.st435{fill:url(#SVGID_431_);}\n\t.st436{fill:url(#SVGID_432_);}\n\t.st437{fill:url(#SVGID_433_);}\n\t.st438{fill:url(#SVGID_434_);}\n\t.st439{fill:url(#SVGID_435_);}\n\t.st440{fill:url(#SVGID_436_);}\n\t.st441{fill:url(#SVGID_437_);}\n\t.st442{fill:url(#SVGID_438_);}\n\t.st443{fill:url(#SVGID_439_);}\n\t.st444{fill:url(#SVGID_440_);}\n\t.st445{fill:url(#SVGID_441_);}\n\t.st446{fill:url(#SVGID_442_);}\n\t.st447{fill:url(#SVGID_443_);}\n\t.st448{fill:url(#SVGID_444_);}\n\t.st449{fill:url(#SVGID_445_);}\n\t.st450{fill:url(#SVGID_446_);}\n\t.st451{fill:url(#SVGID_447_);}\n\t.st452{fill:url(#SVGID_448_);}\n\t.st453{fill:url(#SVGID_449_);}\n\t.st454{fill:url(#SVGID_450_);}\n\t.st455{fill:url(#SVGID_451_);}\n\t.st456{fill:url(#SVGID_452_);}\n\t.st457{fill:url(#SVGID_453_);}\n\t.st458{fill:url(#SVGID_454_);}\n\t.st459{fill:url(#SVGID_455_);}\n\t.st460{fill:url(#SVGID_456_);}\n\t.st461{fill:url(#SVGID_457_);}\n\t.st462{fill:url(#SVGID_458_);}\n\t.st463{fill:url(#SVGID_459_);}\n\t.st464{fill:url(#SVGID_460_);}\n\t.st465{fill:url(#SVGID_461_);}\n\t.st466{fill:url(#SVGID_462_);}\n\t.st467{fill:url(#SVGID_463_);}\n\t.st468{fill:url(#SVGID_464_);}\n\t.st469{fill:url(#SVGID_465_);}\n\t.st470{fill:url(#SVGID_466_);}\n\t.st471{fill:url(#SVGID_467_);}\n\t.st472{fill:url(#SVGID_468_);}\n\t.st473{fill:url(#SVGID_469_);}\n\t.st474{fill:url(#SVGID_470_);}\n\t.st475{fill:url(#SVGID_471_);}\n\t.st476{fill:url(#SVGID_472_);}\n\t.st477{fill:url(#SVGID_473_);}\n\t.st478{fill:url(#SVGID_474_);}\n\t.st479{fill:url(#SVGID_475_);}\n\t.st480{fill:url(#SVGID_476_);}\n\t.st481{fill:url(#SVGID_477_);}\n\t.st482{fill:url(#SVGID_478_);}\n\t.st483{fill:url(#SVGID_479_);}\n\t.st484{fill:url(#SVGID_480_);}\n\t.st485{fill:url(#SVGID_481_);}\n\t.st486{fill:url(#SVGID_482_);}\n\t.st487{fill:url(#SVGID_483_);}\n\t.st488{fill:url(#SVGID_484_);}\n\t.st489{fill:url(#SVGID_485_);}\n\t.st490{fill:url(#SVGID_486_);}\n\t.st491{fill:url(#SVGID_487_);}\n\t.st492{fill:url(#SVGID_488_);}\n\t.st493{fill:url(#SVGID_489_);}\n\t.st494{fill:url(#SVGID_490_);}\n\t.st495{fill:url(#SVGID_491_);}\n\t.st496{fill:url(#SVGID_492_);}\n\t.st497{fill:url(#SVGID_493_);}\n\t.st498{fill:url(#SVGID_494_);}\n\t.st499{fill:url(#SVGID_495_);}\n\t.st500{fill:url(#SVGID_496_);}\n\t.st501{fill:url(#SVGID_497_);}\n\t.st502{fill:url(#SVGID_498_);}\n\t.st503{fill:url(#SVGID_499_);}\n\t.st504{fill:url(#SVGID_500_);}\n\t.st505{opacity:0.7;fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_501_);enable-background:new    ;}\n\t.st506{opacity:0.7;fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_502_);enable-background:new    ;}\n\t.st507{opacity:0.7;fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_503_);enable-background:new    ;}\n\t.st508{opacity:0.7;fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_504_);enable-background:new    ;}\n\t.st509{opacity:0.7;fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_505_);enable-background:new    ;}\n\t.st510{opacity:0.7;fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_506_);enable-background:new    ;}\n\t.st511{opacity:0.7;fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_507_);enable-background:new    ;}\n\t.st512{opacity:0.7;fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_508_);enable-background:new    ;}\n\t.st513{opacity:0.7;fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_509_);enable-background:new    ;}\n\t.st514{opacity:0.7;fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_510_);enable-background:new    ;}\n\t.st515{opacity:0.7;fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_511_);enable-background:new    ;}\n\t.st516{opacity:0.7;fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_512_);enable-background:new    ;}\n\t.st517{opacity:0.7;fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_513_);enable-background:new    ;}\n\t.st518{opacity:0.7;fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_514_);enable-background:new    ;}\n\t.st519{opacity:0.7;fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_515_);enable-background:new    ;}\n\t.st520{opacity:0.7;fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_516_);enable-background:new    ;}\n\t.st521{opacity:0.7;fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_517_);enable-background:new    ;}\n\t.st522{opacity:0.7;fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_518_);enable-background:new    ;}\n\t.st523{opacity:0.7;fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_519_);enable-background:new    ;}\n\t.st524{opacity:0.7;fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_520_);enable-background:new    ;}\n\t.st525{opacity:0.7;fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_521_);enable-background:new    ;}\n\t.st526{opacity:0.7;fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_522_);enable-background:new    ;}\n\t.st527{opacity:0.7;fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_523_);enable-background:new    ;}\n\t.st528{opacity:0.7;fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_524_);enable-background:new    ;}\n\t.st529{opacity:0.7;fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_525_);enable-background:new    ;}\n\t.st530{opacity:0.7;fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_526_);enable-background:new    ;}\n\t.st531{opacity:0.7;fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_527_);enable-background:new    ;}\n\t.st532{opacity:0.7;fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_528_);enable-background:new    ;}\n\t.st533{opacity:0.7;fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_529_);enable-background:new    ;}\n\t.st534{opacity:0.7;fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_530_);enable-background:new    ;}\n\t.st535{opacity:0.7;fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_531_);enable-background:new    ;}\n\t.st536{opacity:0.7;fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_532_);enable-background:new    ;}\n\t.st537{opacity:0.7;fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_533_);enable-background:new    ;}\n\t.st538{fill:url(#SVGID_534_);}\n\t.st539{fill:url(#SVGID_535_);}\n\t.st540{fill:url(#SVGID_536_);}\n\t.st541{fill:url(#SVGID_537_);}\n\t.st542{fill:url(#SVGID_538_);}\n\t.st543{fill:url(#SVGID_539_);}\n\t.st544{fill:url(#SVGID_540_);}\n\t.st545{fill:url(#SVGID_541_);}\n\t.st546{fill:url(#SVGID_542_);}\n\t.st547{fill:url(#SVGID_543_);}\n\t.st548{fill:url(#SVGID_544_);}\n\t.st549{fill:url(#SVGID_545_);}\n\t.st550{fill:url(#SVGID_546_);}\n\t.st551{fill:url(#SVGID_547_);}\n\t.st552{fill:url(#SVGID_548_);}\n\t.st553{fill:url(#SVGID_549_);}\n\t.st554{fill:url(#SVGID_550_);}\n\t.st555{fill:url(#SVGID_551_);}\n\t.st556{fill:url(#SVGID_552_);}\n\t.st557{fill:url(#SVGID_553_);}\n\t.st558{fill:url(#SVGID_554_);}\n\t.st559{fill:url(#SVGID_555_);}\n\t.st560{fill:url(#SVGID_556_);}\n\t.st561{fill:url(#SVGID_557_);}\n\t.st562{fill:url(#SVGID_558_);}\n\t.st563{fill:url(#SVGID_559_);}\n\t.st564{fill:url(#SVGID_560_);}\n\t.st565{fill:url(#SVGID_561_);}\n\t.st566{fill:url(#SVGID_562_);}\n\t.st567{fill:url(#SVGID_563_);}\n\t.st568{fill:url(#SVGID_564_);}\n\t.st569{fill:url(#SVGID_565_);}\n\t.st570{fill:url(#SVGID_566_);}\n\t.st571{fill:url(#SVGID_567_);}\n\t.st572{fill:url(#SVGID_568_);}\n\t.st573{fill:url(#SVGID_569_);}\n\t.st574{fill:url(#SVGID_570_);}\n\t.st575{fill:url(#SVGID_571_);}\n\t.st576{fill:url(#SVGID_572_);}\n\t.st577{fill:url(#SVGID_573_);}\n\t.st578{clip-path:url(#SVGID_289_);fill:url(#SVGID_574_);}\n\t.st579{clip-path:url(#SVGID_289_);}\n\t.st580{clip-path:url(#SVGID_289_);fill:#B5C334;}\n\t.st581{clip-path:url(#SVGID_289_);enable-background:new    ;}\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_288_",
    y: 1.7,
    width: 1769,
    height: 143.4
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_288_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 1287.9604,
    y1: 58.1761,
    x2: -293.3593,
    y2: -986.6238,
    gradientTransform: "matrix(1 0 0 1 203.2719 646.4694)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1396,
    style: {
      stopColor: "#FAFAFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3023,
    style: {
      stopColor: "#ECECEC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4765,
    style: {
      stopColor: "#D6D6D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6589,
    style: {
      stopColor: "#B6B6B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8457,
    style: {
      stopColor: "#8D8D8A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#666662"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M629.8,133c0.7,0.1,1.1,1.2,1.1,2.5s-0.6,2.4-1.1,2.3c-0.7-0.1-1.1-1.2-1.1-2.5 C628.7,134,629.2,133,629.8,133z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 1301.3646,
    y1: 63.4077,
    x2: -305.2438,
    y2: -998.1008,
    gradientTransform: "matrix(1 0 0 1 203.2719 646.4694)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1396,
    style: {
      stopColor: "#FAFAFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3023,
    style: {
      stopColor: "#ECECEC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4765,
    style: {
      stopColor: "#D6D6D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6589,
    style: {
      stopColor: "#B6B6B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8457,
    style: {
      stopColor: "#8D8D8A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#666662"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M636.5,133.8c0.7,0.1,1.1,1.2,1.1,2.7c0,1.3-0.6,2.4-1.1,2.3c-0.7-0.1-1.1-1.2-1.1-2.7 C635.3,134.8,635.9,133.7,636.5,133.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 1315.7493,
    y1: 69.2141,
    x2: -318.1035,
    y2: -1010.2952,
    gradientTransform: "matrix(1 0 0 1 203.2719 646.4694)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1396,
    style: {
      stopColor: "#FAFAFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3023,
    style: {
      stopColor: "#ECECEC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4765,
    style: {
      stopColor: "#D6D6D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6589,
    style: {
      stopColor: "#B6B6B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8457,
    style: {
      stopColor: "#8D8D8A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#666662"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M643.4,134.6c0.7,0.1,1.2,1.2,1.2,2.7s-0.6,2.4-1.2,2.4c-0.7-0.1-1.2-1.2-1.2-2.7S642.7,134.5,643.4,134.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 1329.0771,
    y1: 74.1944,
    x2: -330.1422,
    y2: -1022.0756,
    gradientTransform: "matrix(1 0 0 1 203.2719 646.4694)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1396,
    style: {
      stopColor: "#FAFAFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3023,
    style: {
      stopColor: "#ECECEC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4765,
    style: {
      stopColor: "#D6D6D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6589,
    style: {
      stopColor: "#B6B6B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8457,
    style: {
      stopColor: "#8D8D8A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#666662"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M650.3,135.4c0.7,0.1,1.2,1.3,1.2,2.7c0,1.4-0.6,2.5-1.2,2.4c-0.7-0.1-1.2-1.3-1.2-2.7 C649.1,136.4,649.7,135.2,650.3,135.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 1343.2678,
    y1: 79.6532,
    x2: -343.0444,
    y2: -1034.5167,
    gradientTransform: "matrix(1 0 0 1 203.2719 646.4694)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1396,
    style: {
      stopColor: "#FAFAFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3023,
    style: {
      stopColor: "#ECECEC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4765,
    style: {
      stopColor: "#D6D6D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6589,
    style: {
      stopColor: "#B6B6B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8457,
    style: {
      stopColor: "#8D8D8A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#666662"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M657.5,136.1c0.7,0.1,1.2,1.3,1.2,2.8s-0.6,2.5-1.2,2.4s-1.2-1.3-1.2-2.8C656.3,137.1,656.8,136,657.5,136.1 z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 1358.9034,
    y1: 85.8662,
    x2: -357.2876,
    y2: -1048.0457,
    gradientTransform: "matrix(1 0 0 1 203.2719 646.4694)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1396,
    style: {
      stopColor: "#FAFAFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3023,
    style: {
      stopColor: "#ECECEC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4765,
    style: {
      stopColor: "#D6D6D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6589,
    style: {
      stopColor: "#B6B6B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8457,
    style: {
      stopColor: "#8D8D8A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#666662"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M664.9,136.9c0.7,0.1,1.2,1.3,1.2,2.8c0,1.4-0.6,2.5-1.2,2.4c-0.7-0.1-1.2-1.3-1.2-2.8 C663.6,138,664.3,136.9,664.9,136.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 1376.4729,
    y1: 93.4369,
    x2: -373.6491,
    y2: -1062.8937,
    gradientTransform: "matrix(1 0 0 1 203.2719 646.4694)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1396,
    style: {
      stopColor: "#FAFAFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3023,
    style: {
      stopColor: "#ECECEC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4765,
    style: {
      stopColor: "#D6D6D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6589,
    style: {
      stopColor: "#B6B6B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8457,
    style: {
      stopColor: "#8D8D8A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#666662"
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M672.4,137.8c0.8,0.1,1.3,1.3,1.3,2.8c0,1.4-0.6,2.5-1.3,2.5c-0.7-0.1-1.3-1.3-1.3-2.8 C671.2,138.8,671.8,137.7,672.4,137.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 1392.2657,
    y1: 99.6017,
    x2: -388.4184,
    y2: -1076.921,
    gradientTransform: "matrix(1 0 0 1 203.2719 646.4694)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1396,
    style: {
      stopColor: "#FAFAFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3023,
    style: {
      stopColor: "#ECECEC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4765,
    style: {
      stopColor: "#D6D6D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6589,
    style: {
      stopColor: "#B6B6B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8457,
    style: {
      stopColor: "#8D8D8A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#666662"
    }
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M680.2,138.6c0.8,0.1,1.3,1.3,1.3,2.9c0,1.4-0.6,2.7-1.3,2.5s-1.3-1.3-1.3-2.9 C678.8,139.7,679.5,138.6,680.2,138.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 1408.1758,
    y1: 105.7415,
    x2: -403.4331,
    y2: -1091.2142,
    gradientTransform: "matrix(1 0 0 1 203.2719 646.4694)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1396,
    style: {
      stopColor: "#FAFAFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3023,
    style: {
      stopColor: "#ECECEC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4765,
    style: {
      stopColor: "#D6D6D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6589,
    style: {
      stopColor: "#B6B6B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8457,
    style: {
      stopColor: "#8D8D8A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#666662"
    }
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M688.1,139.4c0.8,0.1,1.3,1.3,1.3,2.9s-0.7,2.7-1.3,2.5c-0.8-0.1-1.3-1.3-1.3-2.9 C686.8,140.6,687.3,139.4,688.1,139.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 1426.069,
    y1: 113.0452,
    x2: -420.4889,
    y2: -1107.0018,
    gradientTransform: "matrix(1 0 0 1 203.2719 646.4694)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1396,
    style: {
      stopColor: "#FAFAFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3023,
    style: {
      stopColor: "#ECECEC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4765,
    style: {
      stopColor: "#D6D6D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6589,
    style: {
      stopColor: "#B6B6B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8457,
    style: {
      stopColor: "#8D8D8A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#666662"
    }
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M696.3,140.3c0.8,0.1,1.4,1.4,1.4,2.9c0,1.5-0.7,2.7-1.4,2.5s-1.4-1.4-1.4-2.9S695.5,140.3,696.3,140.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 1442.7416,
    y1: 119.6171,
    x2: -436.6856,
    y2: -1122.1465,
    gradientTransform: "matrix(1 0 0 1 203.2719 646.4694)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1396,
    style: {
      stopColor: "#FAFAFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3023,
    style: {
      stopColor: "#ECECEC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4765,
    style: {
      stopColor: "#D6D6D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6589,
    style: {
      stopColor: "#B6B6B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8457,
    style: {
      stopColor: "#8D8D8A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#666662"
    }
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M704.7,141.3c0.8,0.1,1.4,1.4,1.4,3c0,1.5-0.7,2.8-1.4,2.7s-1.4-1.4-1.4-3 C703.3,142.4,703.8,141.2,704.7,141.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 1461.1906,
    y1: 127.069,
    x2: -454.649,
    y2: -1138.7527,
    gradientTransform: "matrix(1 0 0 1 203.2719 646.4694)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1396,
    style: {
      stopColor: "#FAFAFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3023,
    style: {
      stopColor: "#ECECEC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4765,
    style: {
      stopColor: "#D6D6D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6589,
    style: {
      stopColor: "#B6B6B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8457,
    style: {
      stopColor: "#8D8D8A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#666662"
    }
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M713.2,142.2c0.8,0.1,1.4,1.4,1.4,3c0,1.5-0.7,2.8-1.4,2.7s-1.4-1.4-1.4-3 C711.8,143.3,712.4,142.1,713.2,142.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 1478.151,
    y1: 133.4293,
    x2: -471.276,
    y2: -1154.585,
    gradientTransform: "matrix(1 0 0 1 203.2719 646.4694)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1396,
    style: {
      stopColor: "#FAFAFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3023,
    style: {
      stopColor: "#ECECEC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4765,
    style: {
      stopColor: "#D6D6D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6589,
    style: {
      stopColor: "#B6B6B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8457,
    style: {
      stopColor: "#8D8D8A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#666662"
    }
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M722,143.2c0.9,0.1,1.5,1.4,1.5,3c0,1.5-0.7,2.8-1.5,2.7c-0.9-0.1-1.5-1.4-1.5-3 C720.6,144.3,721.3,143.1,722,143.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 1498.7568,
    y1: 142.1618,
    x2: -491.9243,
    y2: -1173.1088,
    gradientTransform: "matrix(1 0 0 1 203.2719 646.4694)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1396,
    style: {
      stopColor: "#FAFAFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3023,
    style: {
      stopColor: "#ECECEC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4765,
    style: {
      stopColor: "#D6D6D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6589,
    style: {
      stopColor: "#B6B6B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8457,
    style: {
      stopColor: "#8D8D8A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#666662"
    }
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M731.1,144.2c0.9,0.1,1.5,1.4,1.5,3.1c0,1.7-0.7,2.9-1.5,2.8c-0.9-0.1-1.5-1.4-1.5-3.1 C729.6,145.3,730.3,144.1,731.1,144.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 1288.0804,
    y1: 43.7617,
    x2: -285.1303,
    y2: -995.6811,
    gradientTransform: "matrix(1 0 0 1 203.2719 646.4694)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1396,
    style: {
      stopColor: "#FAFAFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3023,
    style: {
      stopColor: "#ECECEC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4765,
    style: {
      stopColor: "#D6D6D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6589,
    style: {
      stopColor: "#B6B6B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8457,
    style: {
      stopColor: "#8D8D8A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#666662"
    }
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M629.8,118.6c0.7,0,1.1,1.2,1.1,2.5c0,1.3-0.6,2.4-1.1,2.3c-0.7-0.1-1.1-1.2-1.1-2.5 C628.7,119.6,629.2,118.5,629.8,118.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 1301.6014,
    y1: 48.8495,
    x2: -296.8727,
    y2: -1007.2852,
    gradientTransform: "matrix(1 0 0 1 203.2719 646.4694)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1396,
    style: {
      stopColor: "#FAFAFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3023,
    style: {
      stopColor: "#ECECEC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4765,
    style: {
      stopColor: "#D6D6D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6589,
    style: {
      stopColor: "#B6B6B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8457,
    style: {
      stopColor: "#8D8D8A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#666662"
    }
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M636.5,119.1c0.7,0,1.1,1.2,1.1,2.5c0,1.3-0.6,2.4-1.1,2.4c-0.7-0.1-1.1-1.2-1.1-2.5 C635.3,120.1,635.9,119,636.5,119.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: 1315.3658,
    y1: 54.0435,
    x2: -308.9663,
    y2: -1019.1753,
    gradientTransform: "matrix(1 0 0 1 203.2719 646.4694)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1396,
    style: {
      stopColor: "#FAFAFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3023,
    style: {
      stopColor: "#ECECEC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4765,
    style: {
      stopColor: "#D6D6D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6589,
    style: {
      stopColor: "#B6B6B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8457,
    style: {
      stopColor: "#8D8D8A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#666662"
    }
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M643.4,119.7c0.7,0.1,1.2,1.2,1.2,2.7c0,1.4-0.6,2.4-1.2,2.4c-0.7-0.1-1.2-1.2-1.2-2.7 C642.2,120.7,642.7,119.7,643.4,119.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientUnits: "userSpaceOnUse",
    x1: 1328.3971,
    y1: 58.6065,
    x2: -320.494,
    y2: -1030.8387,
    gradientTransform: "matrix(1 0 0 1 203.2719 646.4694)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1396,
    style: {
      stopColor: "#FAFAFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3023,
    style: {
      stopColor: "#ECECEC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4765,
    style: {
      stopColor: "#D6D6D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6589,
    style: {
      stopColor: "#B6B6B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8457,
    style: {
      stopColor: "#8D8D8A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#666662"
    }
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M650.3,120.2c0.7,0,1.2,1.2,1.2,2.7c0,1.4-0.6,2.5-1.2,2.4c-0.7,0-1.2-1.2-1.2-2.7 C649.1,121.3,649.7,120.2,650.3,120.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientUnits: "userSpaceOnUse",
    x1: 1343.8489,
    y1: 64.7141,
    x2: -334.284,
    y2: -1044.0521,
    gradientTransform: "matrix(1 0 0 1 203.2719 646.4694)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1396,
    style: {
      stopColor: "#FAFAFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3023,
    style: {
      stopColor: "#ECECEC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4765,
    style: {
      stopColor: "#D6D6D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6589,
    style: {
      stopColor: "#B6B6B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8457,
    style: {
      stopColor: "#8D8D8A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#666662"
    }
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M657.5,120.9c0.7,0,1.2,1.2,1.2,2.7c0,1.4-0.6,2.5-1.2,2.4s-1.2-1.2-1.2-2.7 C656.3,121.9,656.8,120.8,657.5,120.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientUnits: "userSpaceOnUse",
    x1: 1359.9501,
    y1: 71.143,
    x2: -348.8008,
    y2: -1057.8524,
    gradientTransform: "matrix(1 0 0 1 203.2719 646.4694)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1396,
    style: {
      stopColor: "#FAFAFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3023,
    style: {
      stopColor: "#ECECEC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4765,
    style: {
      stopColor: "#D6D6D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6589,
    style: {
      stopColor: "#B6B6B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8457,
    style: {
      stopColor: "#8D8D8A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#666662"
    }
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M664.9,121.4c0.7,0.1,1.2,1.3,1.2,2.8c0,1.4-0.6,2.5-1.2,2.5c-0.7-0.1-1.2-1.3-1.2-2.8 C663.6,122.5,664.3,121.4,664.9,121.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_23_",
    gradientUnits: "userSpaceOnUse",
    x1: 1375.801,
    y1: 77.302,
    x2: -363.2584,
    y2: -1071.7188,
    gradientTransform: "matrix(1 0 0 1 203.2719 646.4694)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1396,
    style: {
      stopColor: "#FAFAFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3023,
    style: {
      stopColor: "#ECECEC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4765,
    style: {
      stopColor: "#D6D6D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6589,
    style: {
      stopColor: "#B6B6B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8457,
    style: {
      stopColor: "#8D8D8A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#666662"
    }
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M672.4,122.1c0.8,0.1,1.3,1.3,1.3,2.8c0,1.4-0.6,2.7-1.3,2.5c-0.7-0.1-1.3-1.3-1.3-2.8 C671.2,123.2,671.8,122.1,672.4,122.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_24_",
    gradientUnits: "userSpaceOnUse",
    x1: 1390.7664,
    y1: 82.7546,
    x2: -377.0168,
    y2: -1085.2443,
    gradientTransform: "matrix(1 0 0 1 203.2719 646.4694)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1396,
    style: {
      stopColor: "#FAFAFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3023,
    style: {
      stopColor: "#ECECEC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4765,
    style: {
      stopColor: "#D6D6D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6589,
    style: {
      stopColor: "#B6B6B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8457,
    style: {
      stopColor: "#8D8D8A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#666662"
    }
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M680.2,122.8c0.8,0.1,1.3,1.3,1.3,2.8s-0.6,2.7-1.3,2.5c-0.8-0.1-1.3-1.3-1.3-2.8S679.5,122.8,680.2,122.8z "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_25_",
    gradientUnits: "userSpaceOnUse",
    x1: 1408.1554,
    y1: 89.7612,
    x2: -393.2423,
    y2: -1100.448,
    gradientTransform: "matrix(1 0 0 1 203.2719 646.4694)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1396,
    style: {
      stopColor: "#FAFAFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3023,
    style: {
      stopColor: "#ECECEC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4765,
    style: {
      stopColor: "#D6D6D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6589,
    style: {
      stopColor: "#B6B6B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8457,
    style: {
      stopColor: "#8D8D8A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#666662"
    }
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M688.1,123.4c0.8,0.1,1.3,1.3,1.3,2.9c0,1.5-0.7,2.7-1.3,2.7c-0.8-0.1-1.3-1.3-1.3-2.9 C686.8,124.5,687.3,123.4,688.1,123.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_26_",
    gradientUnits: "userSpaceOnUse",
    x1: 1427.0132,
    y1: 97.4808,
    x2: -410.9296,
    y2: -1116.8734,
    gradientTransform: "matrix(1 0 0 1 203.2719 646.4694)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1396,
    style: {
      stopColor: "#FAFAFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3023,
    style: {
      stopColor: "#ECECEC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4765,
    style: {
      stopColor: "#D6D6D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6589,
    style: {
      stopColor: "#B6B6B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8457,
    style: {
      stopColor: "#8D8D8A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#666662"
    }
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M696.3,124.1c0.8,0.1,1.4,1.3,1.4,2.9c0,1.5-0.7,2.7-1.4,2.7c-0.8-0.1-1.4-1.3-1.4-2.9 C694.9,125.2,695.5,124.1,696.3,124.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_27_",
    gradientUnits: "userSpaceOnUse",
    x1: 1442.2834,
    y1: 102.7954,
    x2: -425.3783,
    y2: -1131.1953,
    gradientTransform: "matrix(1 0 0 1 203.2719 646.4694)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1396,
    style: {
      stopColor: "#FAFAFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3023,
    style: {
      stopColor: "#ECECEC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4765,
    style: {
      stopColor: "#D6D6D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6589,
    style: {
      stopColor: "#B6B6B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8457,
    style: {
      stopColor: "#8D8D8A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#666662"
    }
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M704.7,124.9c0.8,0.1,1.4,1.3,1.4,2.9c0,1.5-0.7,2.8-1.4,2.7s-1.4-1.3-1.4-2.9 C703.3,126,703.8,124.8,704.7,124.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_28_",
    gradientUnits: "userSpaceOnUse",
    x1: 1460.183,
    y1: 109.7181,
    x2: -442.5275,
    y2: -1147.4291,
    gradientTransform: "matrix(1 0 0 1 203.2719 646.4694)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1396,
    style: {
      stopColor: "#FAFAFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3023,
    style: {
      stopColor: "#ECECEC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4765,
    style: {
      stopColor: "#D6D6D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6589,
    style: {
      stopColor: "#B6B6B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8457,
    style: {
      stopColor: "#8D8D8A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#666662"
    }
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M713.2,125.5c0.8,0.1,1.4,1.4,1.4,3c0,1.5-0.7,2.8-1.4,2.7s-1.4-1.4-1.4-3 C711.8,126.6,712.4,125.5,713.2,125.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_29_",
    gradientUnits: "userSpaceOnUse",
    x1: 1479.3771,
    y1: 117.3884,
    x2: -461.1762,
    y2: -1164.7628,
    gradientTransform: "matrix(1 0 0 1 203.2719 646.4694)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1396,
    style: {
      stopColor: "#FAFAFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3023,
    style: {
      stopColor: "#ECECEC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4765,
    style: {
      stopColor: "#D6D6D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6589,
    style: {
      stopColor: "#B6B6B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8457,
    style: {
      stopColor: "#8D8D8A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#666662"
    }
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M722,126.3c0.9,0.1,1.5,1.4,1.5,3s-0.7,2.8-1.5,2.8c-0.9-0.1-1.5-1.4-1.5-3 C720.6,127.4,721.3,126.2,722,126.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_30_",
    gradientUnits: "userSpaceOnUse",
    x1: 1498.3398,
    y1: 124.704,
    x2: -479.6999,
    y2: -1182.2144,
    gradientTransform: "matrix(1 0 0 1 203.2719 646.4694)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1396,
    style: {
      stopColor: "#FAFAFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3023,
    style: {
      stopColor: "#ECECEC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4765,
    style: {
      stopColor: "#D6D6D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6589,
    style: {
      stopColor: "#B6B6B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8457,
    style: {
      stopColor: "#8D8D8A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#666662"
    }
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M731.1,127.1c0.9,0.1,1.5,1.4,1.5,3c0,1.7-0.7,2.9-1.5,2.8c-0.9-0.1-1.5-1.4-1.5-3S730.3,127,731.1,127.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_31_",
    gradientUnits: "userSpaceOnUse",
    x1: 1518.9348,
    y1: 132.9377,
    x2: -500.0918,
    y2: -1201.0612,
    gradientTransform: "matrix(1 0 0 1 203.2719 646.4694)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1396,
    style: {
      stopColor: "#FAFAFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3023,
    style: {
      stopColor: "#ECECEC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4765,
    style: {
      stopColor: "#D6D6D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6589,
    style: {
      stopColor: "#B6B6B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8457,
    style: {
      stopColor: "#8D8D8A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#666662"
    }
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M740.5,127.8c0.9,0.1,1.5,1.4,1.5,3.1s-0.8,2.9-1.5,2.8c-0.9-0.1-1.7-1.4-1.7-3.1 C738.8,129.1,739.6,127.7,740.5,127.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_32_",
    gradientUnits: "userSpaceOnUse",
    x1: 1541.2852,
    y1: 142.179,
    x2: -522.5739,
    y2: -1221.442,
    gradientTransform: "matrix(1 0 0 1 203.2719 646.4694)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1396,
    style: {
      stopColor: "#FAFAFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3023,
    style: {
      stopColor: "#ECECEC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4765,
    style: {
      stopColor: "#D6D6D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6589,
    style: {
      stopColor: "#B6B6B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8457,
    style: {
      stopColor: "#8D8D8A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#666662"
    }
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M750.1,128.6c0.9,0.1,1.7,1.4,1.7,3.1c0,1.7-0.8,2.9-1.7,2.9c-0.9-0.1-1.7-1.4-1.7-3.1 S749.1,128.5,750.1,128.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_33_",
    gradientUnits: "userSpaceOnUse",
    x1: 1287.9324,
    y1: 29.1518,
    x2: -276.7544,
    y2: -1004.6584,
    gradientTransform: "matrix(1 0 0 1 203.2719 646.4694)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1396,
    style: {
      stopColor: "#FAFAFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3023,
    style: {
      stopColor: "#ECECEC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4765,
    style: {
      stopColor: "#D6D6D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6589,
    style: {
      stopColor: "#B6B6B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8457,
    style: {
      stopColor: "#8D8D8A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#666662"
    }
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M629.8,104c0.7,0,1.1,1.2,1.1,2.5c0,1.3-0.6,2.4-1.1,2.4c-0.7,0-1.1-1.2-1.1-2.5 C628.7,105,629.2,104,629.8,104z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_34_",
    gradientUnits: "userSpaceOnUse",
    x1: 1301.911,
    y1: 34.3763,
    x2: -288.6789,
    y2: -1016.5486,
    gradientTransform: "matrix(1 0 0 1 203.2719 646.4694)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1396,
    style: {
      stopColor: "#FAFAFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3023,
    style: {
      stopColor: "#ECECEC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4765,
    style: {
      stopColor: "#D6D6D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6589,
    style: {
      stopColor: "#B6B6B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8457,
    style: {
      stopColor: "#8D8D8A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#666662"
    }
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M636.5,104.4c0.7,0,1.1,1.2,1.1,2.5c0,1.3-0.6,2.4-1.1,2.4c-0.7,0-1.1-1.2-1.1-2.5 C635.3,105.4,635.9,104.3,636.5,104.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_35_",
    gradientUnits: "userSpaceOnUse",
    x1: 1315.4269,
    y1: 39.1115,
    x2: -300.2573,
    y2: -1028.3942,
    gradientTransform: "matrix(1 0 0 1 203.2719 646.4694)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1396,
    style: {
      stopColor: "#FAFAFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3023,
    style: {
      stopColor: "#ECECEC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4765,
    style: {
      stopColor: "#D6D6D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6589,
    style: {
      stopColor: "#B6B6B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8457,
    style: {
      stopColor: "#8D8D8A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#666662"
    }
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M643.4,104.8c0.7,0,1.2,1.2,1.2,2.5c0,1.4-0.6,2.5-1.2,2.4c-0.7,0-1.2-1.2-1.2-2.7 C642.2,105.9,642.7,104.8,643.4,104.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_36_",
    gradientUnits: "userSpaceOnUse",
    x1: 1328.8367,
    y1: 43.8695,
    x2: -312.0184,
    y2: -1040.2668,
    gradientTransform: "matrix(1 0 0 1 203.2719 646.4694)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1396,
    style: {
      stopColor: "#FAFAFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3023,
    style: {
      stopColor: "#ECECEC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4765,
    style: {
      stopColor: "#D6D6D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6589,
    style: {
      stopColor: "#B6B6B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8457,
    style: {
      stopColor: "#8D8D8A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#666662"
    }
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M650.3,105.2c0.7,0,1.2,1.2,1.2,2.7c0,1.4-0.6,2.5-1.2,2.4c-0.7,0-1.2-1.2-1.2-2.7 C649.1,106.3,649.7,105.2,650.3,105.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_37_",
    gradientUnits: "userSpaceOnUse",
    x1: 1343.5446,
    y1: 49.3387,
    x2: -324.9595,
    y2: -1053.0651,
    gradientTransform: "matrix(1 0 0 1 203.2719 646.4694)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1396,
    style: {
      stopColor: "#FAFAFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3023,
    style: {
      stopColor: "#ECECEC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4765,
    style: {
      stopColor: "#D6D6D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6589,
    style: {
      stopColor: "#B6B6B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8457,
    style: {
      stopColor: "#8D8D8A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#666662"
    }
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M657.5,105.6c0.7,0,1.2,1.2,1.2,2.7c0,1.4-0.6,2.5-1.2,2.5s-1.2-1.2-1.2-2.7 C656.3,106.7,656.8,105.5,657.5,105.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_38_",
    gradientUnits: "userSpaceOnUse",
    x1: 1358.3049,
    y1: 54.6416,
    x2: -337.9928,
    y2: -1066.1259,
    gradientTransform: "matrix(1 0 0 1 203.2719 646.4694)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1396,
    style: {
      stopColor: "#FAFAFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3023,
    style: {
      stopColor: "#ECECEC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4765,
    style: {
      stopColor: "#D6D6D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6589,
    style: {
      stopColor: "#B6B6B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8457,
    style: {
      stopColor: "#8D8D8A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#666662"
    }
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M664.9,106.1c0.7,0,1.2,1.2,1.2,2.7c0,1.4-0.6,2.5-1.2,2.5s-1.2-1.2-1.2-2.7 C663.6,107.2,664.3,106,664.9,106.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_39_",
    gradientUnits: "userSpaceOnUse",
    x1: 1374.3896,
    y1: 60.7882,
    x2: -352.4161,
    y2: -1080.1368,
    gradientTransform: "matrix(1 0 0 1 203.2719 646.4694)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1396,
    style: {
      stopColor: "#FAFAFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3023,
    style: {
      stopColor: "#ECECEC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4765,
    style: {
      stopColor: "#D6D6D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6589,
    style: {
      stopColor: "#B6B6B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8457,
    style: {
      stopColor: "#8D8D8A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#666662"
    }
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M672.4,106.5c0.8,0,1.3,1.2,1.3,2.8c0,1.4-0.6,2.7-1.3,2.5c-0.7,0-1.3-1.2-1.3-2.8 C671.2,107.6,671.8,106.4,672.4,106.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_40_",
    gradientUnits: "userSpaceOnUse",
    x1: 1389.5186,
    y1: 66.1846,
    x2: -366.0949,
    y2: -1093.7743,
    gradientTransform: "matrix(1 0 0 1 203.2719 646.4694)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1396,
    style: {
      stopColor: "#FAFAFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3023,
    style: {
      stopColor: "#ECECEC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4765,
    style: {
      stopColor: "#D6D6D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6589,
    style: {
      stopColor: "#B6B6B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8457,
    style: {
      stopColor: "#8D8D8A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#666662"
    }
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M680.2,107c0.8,0,1.3,1.3,1.3,2.8c0,1.4-0.6,2.7-1.3,2.7s-1.3-1.3-1.3-2.8 C678.8,108.1,679.5,106.9,680.2,107z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_41_",
    gradientUnits: "userSpaceOnUse",
    x1: 1408.0382,
    y1: 73.5864,
    x2: -382.9538,
    y2: -1109.7474,
    gradientTransform: "matrix(1 0 0 1 203.2719 646.4694)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1396,
    style: {
      stopColor: "#FAFAFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3023,
    style: {
      stopColor: "#ECECEC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4765,
    style: {
      stopColor: "#D6D6D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6589,
    style: {
      stopColor: "#B6B6B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8457,
    style: {
      stopColor: "#8D8D8A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#666662"
    }
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M688.1,107.4c0.8,0,1.3,1.3,1.3,2.8c0,1.5-0.7,2.7-1.3,2.7c-0.8-0.1-1.3-1.3-1.3-2.8 C686.8,108.5,687.3,107.3,688.1,107.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_42_",
    gradientUnits: "userSpaceOnUse",
    x1: 1424.7906,
    y1: 79.7692,
    x2: -398.3923,
    y2: -1124.833,
    gradientTransform: "matrix(1 0 0 1 203.2719 646.4694)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1396,
    style: {
      stopColor: "#FAFAFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3023,
    style: {
      stopColor: "#ECECEC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4765,
    style: {
      stopColor: "#D6D6D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6589,
    style: {
      stopColor: "#B6B6B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8457,
    style: {
      stopColor: "#8D8D8A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#666662"
    }
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M696.3,107.8c0.8,0,1.4,1.3,1.4,2.9c0,1.5-0.7,2.8-1.4,2.7c-0.8,0-1.4-1.3-1.4-2.9 C694.9,109.1,695.5,107.8,696.3,107.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_43_",
    gradientUnits: "userSpaceOnUse",
    x1: 1441.5059,
    y1: 85.7968,
    x2: -413.9245,
    y2: -1140.1118,
    gradientTransform: "matrix(1 0 0 1 203.2719 646.4694)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1396,
    style: {
      stopColor: "#FAFAFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3023,
    style: {
      stopColor: "#ECECEC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4765,
    style: {
      stopColor: "#D6D6D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6589,
    style: {
      stopColor: "#B6B6B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8457,
    style: {
      stopColor: "#8D8D8A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#666662"
    }
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M704.7,108.4c0.8,0,1.4,1.3,1.4,2.9c0,1.5-0.7,2.8-1.4,2.7s-1.4-1.3-1.4-2.9 C703.3,109.5,703.8,108.3,704.7,108.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_44_",
    gradientUnits: "userSpaceOnUse",
    x1: 1459.8479,
    y1: 92.812,
    x2: -431.2213,
    y2: -1156.6444,
    gradientTransform: "matrix(1 0 0 1 203.2719 646.4694)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1396,
    style: {
      stopColor: "#FAFAFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3023,
    style: {
      stopColor: "#ECECEC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4765,
    style: {
      stopColor: "#D6D6D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6589,
    style: {
      stopColor: "#B6B6B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8457,
    style: {
      stopColor: "#8D8D8A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#666662"
    }
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "st42",
    d: "M713.2,108.8c0.8,0,1.4,1.3,1.4,2.9c0,1.5-0.7,2.8-1.4,2.8s-1.4-1.3-1.4-2.9S712.4,108.8,713.2,108.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_45_",
    gradientUnits: "userSpaceOnUse",
    x1: 1477.475,
    y1: 99.1991,
    x2: -447.9439,
    y2: -1172.9519,
    gradientTransform: "matrix(1 0 0 1 203.2719 646.4694)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1396,
    style: {
      stopColor: "#FAFAFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3023,
    style: {
      stopColor: "#ECECEC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4765,
    style: {
      stopColor: "#D6D6D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6589,
    style: {
      stopColor: "#B6B6B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8457,
    style: {
      stopColor: "#8D8D8A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#666662"
    }
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "M722,109.4c0.9,0,1.5,1.3,1.5,3c0,1.5-0.7,2.9-1.5,2.8c-0.9-0.1-1.5-1.4-1.5-3 C720.6,110.6,721.3,109.3,722,109.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_46_",
    gradientUnits: "userSpaceOnUse",
    x1: 1497.6455,
    y1: 107.0974,
    x2: -467.3782,
    y2: -1191.2211,
    gradientTransform: "matrix(1 0 0 1 203.2719 646.4694)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1396,
    style: {
      stopColor: "#FAFAFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3023,
    style: {
      stopColor: "#ECECEC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4765,
    style: {
      stopColor: "#D6D6D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6589,
    style: {
      stopColor: "#B6B6B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8457,
    style: {
      stopColor: "#8D8D8A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#666662"
    }
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "st44",
    d: "M731.1,109.9c0.9,0,1.5,1.4,1.5,3c0,1.7-0.7,2.9-1.5,2.8c-0.9-0.1-1.5-1.4-1.5-3 C729.6,111.1,730.3,109.8,731.1,109.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_47_",
    gradientUnits: "userSpaceOnUse",
    x1: 1517.5808,
    y1: 114.6744,
    x2: -486.7383,
    y2: -1209.6079,
    gradientTransform: "matrix(1 0 0 1 203.2719 646.4694)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1396,
    style: {
      stopColor: "#FAFAFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3023,
    style: {
      stopColor: "#ECECEC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4765,
    style: {
      stopColor: "#D6D6D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6589,
    style: {
      stopColor: "#B6B6B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8457,
    style: {
      stopColor: "#8D8D8A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#666662"
    }
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "M740.5,110.5c0.9,0,1.5,1.4,1.5,3c0,1.7-0.8,2.9-1.5,2.9c-0.9-0.1-1.7-1.4-1.7-3.1 C738.8,111.6,739.6,110.4,740.5,110.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_48_",
    gradientUnits: "userSpaceOnUse",
    x1: 1539.3527,
    y1: 123.312,
    x2: -508.2273,
    y2: -1229.5532,
    gradientTransform: "matrix(1 0 0 1 203.2719 646.4694)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1396,
    style: {
      stopColor: "#FAFAFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3023,
    style: {
      stopColor: "#ECECEC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4765,
    style: {
      stopColor: "#D6D6D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6589,
    style: {
      stopColor: "#B6B6B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8457,
    style: {
      stopColor: "#8D8D8A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#666662"
    }
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "st46",
    d: "M750.1,111.1c0.9,0,1.7,1.4,1.7,3.1c0,1.7-0.8,3-1.7,2.9c-0.9-0.1-1.7-1.4-1.7-3.1 C748.5,112.3,749.1,110.9,750.1,111.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_49_",
    gradientUnits: "userSpaceOnUse",
    x1: 1288.0811,
    y1: 14.7752,
    x2: -268.7341,
    y2: -1013.8348,
    gradientTransform: "matrix(1 0 0 1 203.2719 646.4694)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1396,
    style: {
      stopColor: "#FAFAFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3023,
    style: {
      stopColor: "#ECECEC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4765,
    style: {
      stopColor: "#D6D6D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6589,
    style: {
      stopColor: "#B6B6B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8457,
    style: {
      stopColor: "#8D8D8A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#666662"
    }
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "M629.8,89.5c0.7,0,1.1,1.1,1.1,2.5c0,1.3-0.6,2.4-1.1,2.4c-0.7,0-1.1-1.1-1.1-2.5 C628.7,90.5,629.2,89.4,629.8,89.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_50_",
    gradientUnits: "userSpaceOnUse",
    x1: 1300.8638,
    y1: 18.8776,
    x2: -279.3456,
    y2: -1025.1886,
    gradientTransform: "matrix(1 0 0 1 203.2719 646.4694)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1396,
    style: {
      stopColor: "#FAFAFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3023,
    style: {
      stopColor: "#ECECEC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4765,
    style: {
      stopColor: "#D6D6D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6589,
    style: {
      stopColor: "#B6B6B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8457,
    style: {
      stopColor: "#8D8D8A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#666662"
    }
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "st48",
    d: "M636.5,89.6c0.7,0,1.1,1.2,1.1,2.5c0,1.3-0.6,2.4-1.1,2.4c-0.7,0-1.1-1.2-1.1-2.5 C635.3,90.7,635.9,89.6,636.5,89.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_51_",
    gradientUnits: "userSpaceOnUse",
    x1: 1314.807,
    y1: 23.8908,
    x2: -291.211,
    y2: -1037.2283,
    gradientTransform: "matrix(1 0 0 1 203.2719 646.4694)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1396,
    style: {
      stopColor: "#FAFAFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3023,
    style: {
      stopColor: "#ECECEC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4765,
    style: {
      stopColor: "#D6D6D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6589,
    style: {
      stopColor: "#B6B6B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8457,
    style: {
      stopColor: "#8D8D8A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#666662"
    }
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "st49",
    d: "M643.4,89.9c0.7,0,1.2,1.1,1.2,2.5c0,1.4-0.6,2.5-1.2,2.4c-0.7,0-1.2-1.2-1.2-2.5 C642.2,90.9,642.7,89.8,643.4,89.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_52_",
    gradientUnits: "userSpaceOnUse",
    x1: 1328.9805,
    y1: 28.9365,
    x2: -303.3731,
    y2: -1049.5822,
    gradientTransform: "matrix(1 0 0 1 203.2719 646.4694)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1396,
    style: {
      stopColor: "#FAFAFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3023,
    style: {
      stopColor: "#ECECEC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4765,
    style: {
      stopColor: "#D6D6D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6589,
    style: {
      stopColor: "#B6B6B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8457,
    style: {
      stopColor: "#8D8D8A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#666662"
    }
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M650.3,90.2c0.7,0,1.2,1.2,1.2,2.5c0,1.4-0.6,2.5-1.2,2.5s-1.2-1.2-1.2-2.5 C649.1,91.3,649.7,90.1,650.3,90.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_53_",
    gradientUnits: "userSpaceOnUse",
    x1: 1343.2389,
    y1: 33.8883,
    x2: -315.6776,
    y2: -1062.1814,
    gradientTransform: "matrix(1 0 0 1 203.2719 646.4694)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1396,
    style: {
      stopColor: "#FAFAFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3023,
    style: {
      stopColor: "#ECECEC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4765,
    style: {
      stopColor: "#D6D6D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6589,
    style: {
      stopColor: "#B6B6B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8457,
    style: {
      stopColor: "#8D8D8A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#666662"
    }
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M657.5,90.4c0.7,0,1.2,1.2,1.2,2.7c0,1.4-0.6,2.5-1.2,2.5s-1.2-1.2-1.2-2.7 C656.3,91.5,656.8,90.4,657.5,90.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_54_",
    gradientUnits: "userSpaceOnUse",
    x1: 1357.5469,
    y1: 38.6713,
    x2: -328.0515,
    y2: -1075.0275,
    gradientTransform: "matrix(1 0 0 1 203.2719 646.4694)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1396,
    style: {
      stopColor: "#FAFAFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3023,
    style: {
      stopColor: "#ECECEC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4765,
    style: {
      stopColor: "#D6D6D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6589,
    style: {
      stopColor: "#B6B6B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8457,
    style: {
      stopColor: "#8D8D8A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#666662"
    }
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "st52",
    d: "M664.9,90.6c0.7,0,1.2,1.2,1.2,2.7c0,1.4-0.6,2.7-1.2,2.5c-0.7,0-1.2-1.2-1.2-2.7 C663.6,91.7,664.3,90.6,664.9,90.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_55_",
    gradientUnits: "userSpaceOnUse",
    x1: 1374.8385,
    y1: 45.3941,
    x2: -343.2795,
    y2: -1089.791,
    gradientTransform: "matrix(1 0 0 1 203.2719 646.4694)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1396,
    style: {
      stopColor: "#FAFAFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3023,
    style: {
      stopColor: "#ECECEC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4765,
    style: {
      stopColor: "#D6D6D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6589,
    style: {
      stopColor: "#B6B6B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8457,
    style: {
      stopColor: "#8D8D8A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#666662"
    }
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "st53",
    d: "M672.4,90.8c0.8,0,1.3,1.2,1.3,2.7c0,1.4-0.6,2.7-1.3,2.7c-0.7,0-1.3-1.2-1.3-2.7 C671.2,91.9,671.8,90.8,672.4,90.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_56_",
    gradientUnits: "userSpaceOnUse",
    x1: 1390.287,
    y1: 50.7806,
    x2: -356.9974,
    y2: -1103.675,
    gradientTransform: "matrix(1 0 0 1 203.2719 646.4694)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1396,
    style: {
      stopColor: "#FAFAFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3023,
    style: {
      stopColor: "#ECECEC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4765,
    style: {
      stopColor: "#D6D6D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6589,
    style: {
      stopColor: "#B6B6B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8457,
    style: {
      stopColor: "#8D8D8A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#666662"
    }
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "st54",
    d: "M680.2,91.1c0.8,0,1.3,1.2,1.3,2.8c0,1.4-0.6,2.7-1.3,2.7s-1.3-1.2-1.3-2.8 C678.8,92.3,679.5,91.1,680.2,91.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_57_",
    gradientUnits: "userSpaceOnUse",
    x1: 1406.4827,
    y1: 56.556,
    x2: -371.5323,
    y2: -1118.2031,
    gradientTransform: "matrix(1 0 0 1 203.2719 646.4694)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1396,
    style: {
      stopColor: "#FAFAFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3023,
    style: {
      stopColor: "#ECECEC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4765,
    style: {
      stopColor: "#D6D6D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6589,
    style: {
      stopColor: "#B6B6B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8457,
    style: {
      stopColor: "#8D8D8A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#666662"
    }
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "st55",
    d: "M688.1,91.4c0.8,0,1.3,1.2,1.3,2.8c0,1.5-0.7,2.7-1.3,2.7c-0.8,0-1.3-1.2-1.3-2.8 C686.8,92.5,687.3,91.4,688.1,91.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_58_",
    gradientUnits: "userSpaceOnUse",
    x1: 1424.8533,
    y1: 63.5121,
    x2: -388.1322,
    y2: -1134.3525,
    gradientTransform: "matrix(1 0 0 1 203.2719 646.4694)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1396,
    style: {
      stopColor: "#FAFAFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3023,
    style: {
      stopColor: "#ECECEC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4765,
    style: {
      stopColor: "#D6D6D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6589,
    style: {
      stopColor: "#B6B6B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8457,
    style: {
      stopColor: "#8D8D8A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#666662"
    }
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "st56",
    d: "M696.3,91.6c0.8,0,1.4,1.3,1.4,2.8c0,1.5-0.7,2.8-1.4,2.7c-0.8,0-1.4-1.3-1.4-2.8 C694.9,92.8,695.5,91.6,696.3,91.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_59_",
    gradientUnits: "userSpaceOnUse",
    x1: 1440.7361,
    y1: 68.8996,
    x2: -402.7029,
    y2: -1149.0861,
    gradientTransform: "matrix(1 0 0 1 203.2719 646.4694)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1396,
    style: {
      stopColor: "#FAFAFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3023,
    style: {
      stopColor: "#ECECEC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4765,
    style: {
      stopColor: "#D6D6D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6589,
    style: {
      stopColor: "#B6B6B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8457,
    style: {
      stopColor: "#8D8D8A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#666662"
    }
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "st57",
    d: "M704.7,91.9c0.8,0,1.4,1.3,1.4,2.9c0,1.5-0.7,2.8-1.4,2.8s-1.4-1.3-1.4-2.9C703.3,93,703.8,91.8,704.7,91.9 z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_60_",
    gradientUnits: "userSpaceOnUse",
    x1: 1459.053,
    y1: 75.6015,
    x2: -419.5991,
    y2: -1165.6506,
    gradientTransform: "matrix(1 0 0 1 203.2719 646.4694)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1396,
    style: {
      stopColor: "#FAFAFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3023,
    style: {
      stopColor: "#ECECEC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4765,
    style: {
      stopColor: "#D6D6D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6589,
    style: {
      stopColor: "#B6B6B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8457,
    style: {
      stopColor: "#8D8D8A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#666662"
    }
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "st58",
    d: "M713.2,92.2c0.8,0,1.4,1.3,1.4,2.9c0,1.5-0.7,2.8-1.4,2.8s-1.4-1.3-1.4-2.9 C711.8,93.4,712.4,92.2,713.2,92.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_61_",
    gradientUnits: "userSpaceOnUse",
    x1: 1476.0253,
    y1: 81.306,
    x2: -435.3419,
    y2: -1181.5608,
    gradientTransform: "matrix(1 0 0 1 203.2719 646.4694)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1396,
    style: {
      stopColor: "#FAFAFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3023,
    style: {
      stopColor: "#ECECEC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4765,
    style: {
      stopColor: "#D6D6D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6589,
    style: {
      stopColor: "#B6B6B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8457,
    style: {
      stopColor: "#8D8D8A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#666662"
    }
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M722,92.5c0.9,0,1.5,1.3,1.5,2.9c0,1.5-0.7,2.9-1.5,2.8c-0.9,0-1.5-1.3-1.5-2.9 C720.6,93.7,721.3,92.5,722,92.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_62_",
    gradientUnits: "userSpaceOnUse",
    x1: 1496.3097,
    y1: 89.053,
    x2: -454.5414,
    y2: -1199.9014,
    gradientTransform: "matrix(1 0 0 1 203.2719 646.4694)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1396,
    style: {
      stopColor: "#FAFAFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3023,
    style: {
      stopColor: "#ECECEC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4765,
    style: {
      stopColor: "#D6D6D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6589,
    style: {
      stopColor: "#B6B6B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8457,
    style: {
      stopColor: "#8D8D8A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#666662"
    }
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "st60",
    d: "M731.1,92.7c0.9,0,1.5,1.3,1.5,3c0,1.7-0.7,2.9-1.5,2.9c-0.9,0-1.5-1.3-1.5-3 C729.6,94,730.3,92.7,731.1,92.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_63_",
    gradientUnits: "userSpaceOnUse",
    x1: 1516.8618,
    y1: 96.7564,
    x2: -474.1421,
    y2: -1218.7275,
    gradientTransform: "matrix(1 0 0 1 203.2719 646.4694)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1396,
    style: {
      stopColor: "#FAFAFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3023,
    style: {
      stopColor: "#ECECEC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4765,
    style: {
      stopColor: "#D6D6D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6589,
    style: {
      stopColor: "#B6B6B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8457,
    style: {
      stopColor: "#8D8D8A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#666662"
    }
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "st61",
    d: "M740.5,93c0.9,0,1.5,1.3,1.5,3c0,1.7-0.8,2.9-1.5,2.9c-0.9,0-1.7-1.4-1.7-3C738.8,94.3,739.6,93,740.5,93z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_64_",
    gradientUnits: "userSpaceOnUse",
    x1: 1537.8884,
    y1: 104.6298,
    x2: -494.4485,
    y2: -1238.1633,
    gradientTransform: "matrix(1 0 0 1 203.2719 646.4694)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1396,
    style: {
      stopColor: "#FAFAFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3023,
    style: {
      stopColor: "#ECECEC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4765,
    style: {
      stopColor: "#D6D6D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6589,
    style: {
      stopColor: "#B6B6B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8457,
    style: {
      stopColor: "#8D8D8A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#666662"
    }
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "st62",
    d: "M750.1,93.4c0.9,0,1.7,1.4,1.7,3c0,1.7-0.8,3-1.7,2.9c-0.9,0-1.7-1.4-1.7-3.1 C748.5,94.6,749.1,93.4,750.1,93.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_65_",
    gradientUnits: "userSpaceOnUse",
    x1: 1286.2087,
    y1: -1.1028,
    x2: -259.0492,
    y2: -1022.0768,
    gradientTransform: "matrix(1 0 0 1 203.2719 646.4694)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1396,
    style: {
      stopColor: "#FAFAFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3023,
    style: {
      stopColor: "#ECECEC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4765,
    style: {
      stopColor: "#D6D6D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6589,
    style: {
      stopColor: "#B6B6B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8457,
    style: {
      stopColor: "#8D8D8A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#666662"
    }
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "st63",
    d: "M629.8,74.9c0.7,0,1.1,1.1,1.1,2.4c0,1.3-0.6,2.4-1.1,2.4c-0.7,0-1.1-1.1-1.1-2.4 C628.7,76,629.2,74.9,629.8,74.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_66_",
    gradientUnits: "userSpaceOnUse",
    x1: 1300.2549,
    y1: 3.779,
    x2: -270.5697,
    y2: -1034.0865,
    gradientTransform: "matrix(1 0 0 1 203.2719 646.4694)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1396,
    style: {
      stopColor: "#FAFAFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3023,
    style: {
      stopColor: "#ECECEC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4765,
    style: {
      stopColor: "#D6D6D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6589,
    style: {
      stopColor: "#B6B6B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8457,
    style: {
      stopColor: "#8D8D8A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#666662"
    }
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "st64",
    d: "M636.5,74.9c0.7,0,1.1,1.1,1.1,2.5c0,1.3-0.6,2.4-1.1,2.4c-0.7,0-1.1-1.1-1.1-2.5 C635.3,76,635.9,74.9,636.5,74.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_67_",
    gradientUnits: "userSpaceOnUse",
    x1: 1314.0938,
    y1: 8.5622,
    x2: -282.148,
    y2: -1046.0974,
    gradientTransform: "matrix(1 0 0 1 203.2719 646.4694)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1396,
    style: {
      stopColor: "#FAFAFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3023,
    style: {
      stopColor: "#ECECEC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4765,
    style: {
      stopColor: "#D6D6D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6589,
    style: {
      stopColor: "#B6B6B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8457,
    style: {
      stopColor: "#8D8D8A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#666662"
    }
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "st65",
    d: "M643.4,75c0.7,0,1.2,1.1,1.2,2.5c0,1.4-0.6,2.5-1.2,2.5s-1.2-1.1-1.2-2.5C642.2,76.1,642.7,75,643.4,75z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_68_",
    gradientUnits: "userSpaceOnUse",
    x1: 1328.2244,
    y1: 13.2987,
    x2: -293.9761,
    y2: -1058.5116,
    gradientTransform: "matrix(1 0 0 1 203.2719 646.4694)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1396,
    style: {
      stopColor: "#FAFAFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3023,
    style: {
      stopColor: "#ECECEC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4765,
    style: {
      stopColor: "#D6D6D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6589,
    style: {
      stopColor: "#B6B6B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8457,
    style: {
      stopColor: "#8D8D8A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#666662"
    }
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "st66",
    d: "M650.3,75c0.7,0,1.2,1.1,1.2,2.5c0,1.4-0.6,2.5-1.2,2.5s-1.2-1.1-1.2-2.5C649.1,76.1,649.7,75,650.3,75z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_69_",
    gradientUnits: "userSpaceOnUse",
    x1: 1341.8778,
    y1: 17.6851,
    x2: -305.5517,
    y2: -1070.795,
    gradientTransform: "matrix(1 0 0 1 203.2719 646.4694)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1396,
    style: {
      stopColor: "#FAFAFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3023,
    style: {
      stopColor: "#ECECEC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4765,
    style: {
      stopColor: "#D6D6D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6589,
    style: {
      stopColor: "#B6B6B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8457,
    style: {
      stopColor: "#8D8D8A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#666662"
    }
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "st67",
    d: "M657.5,75.1c0.7,0,1.2,1.1,1.2,2.5c0,1.4-0.6,2.5-1.2,2.5s-1.2-1.1-1.2-2.5 C656.3,76.2,656.8,75.1,657.5,75.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_70_",
    gradientUnits: "userSpaceOnUse",
    x1: 1357.777,
    y1: 23.3533,
    x2: -319.0949,
    y2: -1084.5791,
    gradientTransform: "matrix(1 0 0 1 203.2719 646.4694)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1396,
    style: {
      stopColor: "#FAFAFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3023,
    style: {
      stopColor: "#ECECEC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4765,
    style: {
      stopColor: "#D6D6D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6589,
    style: {
      stopColor: "#B6B6B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8457,
    style: {
      stopColor: "#8D8D8A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#666662"
    }
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "st68",
    d: "M664.9,75.1c0.7,0,1.2,1.2,1.2,2.7c0,1.4-0.6,2.7-1.2,2.5c-0.7,0-1.2-1.2-1.2-2.7 C663.6,76.4,664.3,75.1,664.9,75.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_71_",
    gradientUnits: "userSpaceOnUse",
    x1: 1374.5483,
    y1: 29.6222,
    x2: -333.684,
    y2: -1099.0312,
    gradientTransform: "matrix(1 0 0 1 203.2719 646.4694)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1396,
    style: {
      stopColor: "#FAFAFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3023,
    style: {
      stopColor: "#ECECEC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4765,
    style: {
      stopColor: "#D6D6D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6589,
    style: {
      stopColor: "#B6B6B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8457,
    style: {
      stopColor: "#8D8D8A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#666662"
    }
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "st69",
    d: "M672.4,75.2c0.8,0,1.3,1.2,1.3,2.7c0,1.4-0.6,2.7-1.3,2.7c-0.7,0-1.3-1.2-1.3-2.7 C671.2,76.4,671.8,75.1,672.4,75.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_72_",
    gradientUnits: "userSpaceOnUse",
    x1: 1387.9163,
    y1: 33.3575,
    x2: -345.2127,
    y2: -1111.7449,
    gradientTransform: "matrix(1 0 0 1 203.2719 646.4694)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1396,
    style: {
      stopColor: "#FAFAFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3023,
    style: {
      stopColor: "#ECECEC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4765,
    style: {
      stopColor: "#D6D6D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6589,
    style: {
      stopColor: "#B6B6B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8457,
    style: {
      stopColor: "#8D8D8A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#666662"
    }
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    className: "st70",
    d: "M680.2,75.2c0.8,0,1.3,1.2,1.3,2.7c0,1.4-0.6,2.7-1.3,2.7s-1.3-1.2-1.3-2.7 C678.8,76.5,679.5,75.2,680.2,75.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_73_",
    gradientUnits: "userSpaceOnUse",
    x1: 1406.2507,
    y1: 40.3809,
    x2: -361.4532,
    y2: -1127.5663,
    gradientTransform: "matrix(1 0 0 1 203.2719 646.4694)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1396,
    style: {
      stopColor: "#FAFAFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3023,
    style: {
      stopColor: "#ECECEC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4765,
    style: {
      stopColor: "#D6D6D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6589,
    style: {
      stopColor: "#B6B6B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8457,
    style: {
      stopColor: "#8D8D8A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#666662"
    }
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    className: "st71",
    d: "M688.1,75.4c0.8,0,1.3,1.2,1.3,2.8c0,1.5-0.7,2.8-1.3,2.7c-0.8,0-1.3-1.2-1.3-2.8 C686.8,76.5,687.3,75.2,688.1,75.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_74_",
    gradientUnits: "userSpaceOnUse",
    x1: 1423.9954,
    y1: 46.7574,
    x2: -377.2237,
    y2: -1143.333,
    gradientTransform: "matrix(1 0 0 1 203.2719 646.4694)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1396,
    style: {
      stopColor: "#FAFAFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3023,
    style: {
      stopColor: "#ECECEC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4765,
    style: {
      stopColor: "#D6D6D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6589,
    style: {
      stopColor: "#B6B6B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8457,
    style: {
      stopColor: "#8D8D8A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#666662"
    }
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    className: "st72",
    d: "M696.3,75.4c0.8,0,1.4,1.2,1.4,2.8c0,1.5-0.7,2.8-1.4,2.8s-1.4-1.2-1.4-2.8 C694.9,76.6,695.5,75.4,696.3,75.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_75_",
    gradientUnits: "userSpaceOnUse",
    x1: 1439.9982,
    y1: 51.8926,
    x2: -391.5343,
    y2: -1158.2263,
    gradientTransform: "matrix(1 0 0 1 203.2719 646.4694)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1396,
    style: {
      stopColor: "#FAFAFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3023,
    style: {
      stopColor: "#ECECEC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4765,
    style: {
      stopColor: "#D6D6D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6589,
    style: {
      stopColor: "#B6B6B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8457,
    style: {
      stopColor: "#8D8D8A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#666662"
    }
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    className: "st73",
    d: "M704.7,75.5c0.8,0,1.4,1.2,1.4,2.8c0,1.5-0.7,2.8-1.4,2.8s-1.4-1.2-1.4-2.8 C703.3,76.7,703.8,75.4,704.7,75.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_76_",
    gradientUnits: "userSpaceOnUse",
    x1: 1457.0619,
    y1: 57.5956,
    x2: -406.9548,
    y2: -1173.9868,
    gradientTransform: "matrix(1 0 0 1 203.2719 646.4694)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1396,
    style: {
      stopColor: "#FAFAFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3023,
    style: {
      stopColor: "#ECECEC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4765,
    style: {
      stopColor: "#D6D6D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6589,
    style: {
      stopColor: "#B6B6B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8457,
    style: {
      stopColor: "#8D8D8A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#666662"
    }
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    className: "st74",
    d: "M713.2,75.5c0.8,0,1.4,1.2,1.4,2.9c0,1.5-0.7,2.9-1.4,2.8c-0.8,0-1.4-1.3-1.4-2.9 C711.8,76.7,712.4,75.5,713.2,75.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_77_",
    gradientUnits: "userSpaceOnUse",
    x1: 1475.981,
    y1: 64.4257,
    x2: -424.3666,
    y2: -1191.1603,
    gradientTransform: "matrix(1 0 0 1 203.2719 646.4694)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1396,
    style: {
      stopColor: "#FAFAFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3023,
    style: {
      stopColor: "#ECECEC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4765,
    style: {
      stopColor: "#D6D6D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6589,
    style: {
      stopColor: "#B6B6B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8457,
    style: {
      stopColor: "#8D8D8A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#666662"
    }
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    className: "st75",
    d: "M722,75.6c0.9,0,1.5,1.3,1.5,2.9c0,1.5-0.7,2.9-1.5,2.9c-0.9,0-1.5-1.3-1.5-2.9 C720.6,76.8,721.3,75.6,722,75.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_78_",
    gradientUnits: "userSpaceOnUse",
    x1: 1495.9677,
    y1: 71.6446,
    x2: -442.8454,
    y2: -1209.3561,
    gradientTransform: "matrix(1 0 0 1 203.2719 646.4694)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1396,
    style: {
      stopColor: "#FAFAFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3023,
    style: {
      stopColor: "#ECECEC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4765,
    style: {
      stopColor: "#D6D6D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6589,
    style: {
      stopColor: "#B6B6B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8457,
    style: {
      stopColor: "#8D8D8A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#666662"
    }
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    className: "st76",
    d: "M731.1,75.6c0.9,0,1.5,1.3,1.5,2.9c0,1.7-0.7,2.9-1.5,2.9c-0.9,0-1.5-1.3-1.5-2.9 C729.6,76.9,730.3,75.6,731.1,75.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_79_",
    gradientUnits: "userSpaceOnUse",
    x1: 1515.9429,
    y1: 78.8073,
    x2: -461.5931,
    y2: -1227.7789,
    gradientTransform: "matrix(1 0 0 1 203.2719 646.4694)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1396,
    style: {
      stopColor: "#FAFAFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3023,
    style: {
      stopColor: "#ECECEC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4765,
    style: {
      stopColor: "#D6D6D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6589,
    style: {
      stopColor: "#B6B6B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8457,
    style: {
      stopColor: "#8D8D8A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#666662"
    }
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    className: "st77",
    d: "M740.5,75.7c0.9,0,1.5,1.3,1.5,3c0,1.7-0.8,3-1.5,2.9c-0.9,0-1.7-1.3-1.7-3 C738.8,76.9,739.6,75.7,740.5,75.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_80_",
    gradientUnits: "userSpaceOnUse",
    x1: 1537.1373,
    y1: 86.5097,
    x2: -481.6755,
    y2: -1247.3479,
    gradientTransform: "matrix(1 0 0 1 203.2719 646.4694)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1396,
    style: {
      stopColor: "#FAFAFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3023,
    style: {
      stopColor: "#ECECEC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4765,
    style: {
      stopColor: "#D6D6D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6589,
    style: {
      stopColor: "#B6B6B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8457,
    style: {
      stopColor: "#8D8D8A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#666662"
    }
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    className: "st78",
    d: "M750.1,75.7c0.9,0,1.7,1.3,1.7,3c0,1.7-0.8,3-1.7,3s-1.7-1.3-1.7-3C748.5,77,749.1,75.7,750.1,75.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_81_",
    gradientUnits: "userSpaceOnUse",
    x1: 1287.9078,
    y1: -14.5662,
    x2: -252.3467,
    y2: -1032.2338,
    gradientTransform: "matrix(1 0 0 1 203.2719 646.4694)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1396,
    style: {
      stopColor: "#FAFAFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3023,
    style: {
      stopColor: "#ECECEC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4765,
    style: {
      stopColor: "#D6D6D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6589,
    style: {
      stopColor: "#B6B6B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8457,
    style: {
      stopColor: "#8D8D8A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#666662"
    }
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    className: "st79",
    d: "M629.8,60.3c0.7,0,1.1,1.1,1.1,2.4s-0.6,2.4-1.1,2.4c-0.7,0-1.1-1.1-1.1-2.4S629.2,60.3,629.8,60.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_82_",
    gradientUnits: "userSpaceOnUse",
    x1: 1301.1178,
    y1: -10.3469,
    x2: -263.0728,
    y2: -1043.8295,
    gradientTransform: "matrix(1 0 0 1 203.2719 646.4694)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1396,
    style: {
      stopColor: "#FAFAFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3023,
    style: {
      stopColor: "#ECECEC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4765,
    style: {
      stopColor: "#D6D6D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6589,
    style: {
      stopColor: "#B6B6B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8457,
    style: {
      stopColor: "#8D8D8A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#666662"
    }
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    className: "st80",
    d: "M636.5,60.2c0.7,0,1.1,1.1,1.1,2.4s-0.6,2.5-1.1,2.5c-0.7,0-1.1-1.1-1.1-2.4 C635.3,61.3,635.9,60.2,636.5,60.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_83_",
    gradientUnits: "userSpaceOnUse",
    x1: 1313.9645,
    y1: -6.4407,
    x2: -273.6188,
    y2: -1055.3789,
    gradientTransform: "matrix(1 0 0 1 203.2719 646.4694)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1396,
    style: {
      stopColor: "#FAFAFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3023,
    style: {
      stopColor: "#ECECEC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4765,
    style: {
      stopColor: "#D6D6D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6589,
    style: {
      stopColor: "#B6B6B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8457,
    style: {
      stopColor: "#8D8D8A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#666662"
    }
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    className: "st81",
    d: "M643.4,60.1c0.7,0,1.2,1.1,1.2,2.5s-0.6,2.5-1.2,2.5s-1.2-1.1-1.2-2.5S642.7,60.1,643.4,60.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_84_",
    gradientUnits: "userSpaceOnUse",
    x1: 1328.4843,
    y1: -1.5569,
    x2: -285.6165,
    y2: -1068.0162,
    gradientTransform: "matrix(1 0 0 1 203.2719 646.4694)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1396,
    style: {
      stopColor: "#FAFAFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3023,
    style: {
      stopColor: "#ECECEC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4765,
    style: {
      stopColor: "#D6D6D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6589,
    style: {
      stopColor: "#B6B6B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8457,
    style: {
      stopColor: "#8D8D8A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#666662"
    }
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    className: "st82",
    d: "M650.3,60c0.7,0,1.2,1.1,1.2,2.5s-0.6,2.5-1.2,2.5s-1.2-1.1-1.2-2.5C649.1,61.1,649.7,60,650.3,60z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_85_",
    gradientUnits: "userSpaceOnUse",
    x1: 1342.4166,
    y1: 2.7371,
    x2: -297.1545,
    y2: -1080.5509,
    gradientTransform: "matrix(1 0 0 1 203.2719 646.4694)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1396,
    style: {
      stopColor: "#FAFAFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3023,
    style: {
      stopColor: "#ECECEC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4765,
    style: {
      stopColor: "#D6D6D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6589,
    style: {
      stopColor: "#B6B6B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8457,
    style: {
      stopColor: "#8D8D8A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#666662"
    }
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    className: "st83",
    d: "M657.5,59.8c0.7,0,1.2,1.1,1.2,2.5c0,1.4-0.6,2.5-1.2,2.7c-0.7,0-1.2-1.1-1.2-2.5 C656.3,61,656.8,59.9,657.5,59.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_86_",
    gradientUnits: "userSpaceOnUse",
    x1: 1358.5363,
    y1: 8.3849,
    x2: -310.6826,
    y2: -1094.4911,
    gradientTransform: "matrix(1 0 0 1 203.2719 646.4694)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1396,
    style: {
      stopColor: "#FAFAFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3023,
    style: {
      stopColor: "#ECECEC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4765,
    style: {
      stopColor: "#D6D6D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6589,
    style: {
      stopColor: "#B6B6B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8457,
    style: {
      stopColor: "#8D8D8A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#666662"
    }
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    className: "st84",
    d: "M664.9,59.7c0.7,0,1.2,1.1,1.2,2.5c0,1.4-0.6,2.7-1.2,2.7s-1.2-1.1-1.2-2.7 C663.6,60.9,664.3,59.7,664.9,59.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_87_",
    gradientUnits: "userSpaceOnUse",
    x1: 1373.6477,
    y1: 13.3361,
    x2: -323.5601,
    y2: -1108.0327,
    gradientTransform: "matrix(1 0 0 1 203.2719 646.4694)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1396,
    style: {
      stopColor: "#FAFAFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3023,
    style: {
      stopColor: "#ECECEC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4765,
    style: {
      stopColor: "#D6D6D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6589,
    style: {
      stopColor: "#B6B6B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8457,
    style: {
      stopColor: "#8D8D8A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#666662"
    }
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    className: "st85",
    d: "M672.4,59.6c0.8,0,1.3,1.2,1.3,2.7c0,1.4-0.6,2.7-1.3,2.7c-0.7,0-1.3-1.2-1.3-2.7S671.8,59.6,672.4,59.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_88_",
    gradientUnits: "userSpaceOnUse",
    x1: 1389.2506,
    y1: 18.4379,
    x2: -336.9307,
    y2: -1122.074,
    gradientTransform: "matrix(1 0 0 1 203.2719 646.4694)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1396,
    style: {
      stopColor: "#FAFAFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3023,
    style: {
      stopColor: "#ECECEC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4765,
    style: {
      stopColor: "#D6D6D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6589,
    style: {
      stopColor: "#B6B6B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8457,
    style: {
      stopColor: "#8D8D8A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#666662"
    }
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    className: "st86",
    d: "M680.2,59.4c0.8,0,1.3,1.2,1.3,2.7c0,1.4-0.6,2.7-1.3,2.7s-1.3-1.2-1.3-2.7S679.5,59.4,680.2,59.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_89_",
    gradientUnits: "userSpaceOnUse",
    x1: 1405.8146,
    y1: 23.9597,
    x2: -351.2059,
    y2: -1136.9281,
    gradientTransform: "matrix(1 0 0 1 203.2719 646.4694)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1396,
    style: {
      stopColor: "#FAFAFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3023,
    style: {
      stopColor: "#ECECEC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4765,
    style: {
      stopColor: "#D6D6D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6589,
    style: {
      stopColor: "#B6B6B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8457,
    style: {
      stopColor: "#8D8D8A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#666662"
    }
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    className: "st87",
    d: "M688.1,59.2c0.8,0,1.3,1.2,1.3,2.7c0,1.5-0.7,2.8-1.3,2.8c-0.8,0-1.3-1.2-1.3-2.7S687.3,59.2,688.1,59.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_90_",
    gradientUnits: "userSpaceOnUse",
    x1: 1422.6171,
    y1: 29.6039,
    x2: -365.9164,
    y2: -1152.1057,
    gradientTransform: "matrix(1 0 0 1 203.2719 646.4694)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1396,
    style: {
      stopColor: "#FAFAFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3023,
    style: {
      stopColor: "#ECECEC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4765,
    style: {
      stopColor: "#D6D6D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6589,
    style: {
      stopColor: "#B6B6B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8457,
    style: {
      stopColor: "#8D8D8A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#666662"
    }
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    className: "st88",
    d: "M696.3,59.1c0.8,0,1.4,1.2,1.4,2.8s-0.7,2.8-1.4,2.8s-1.4-1.2-1.4-2.8C694.9,60.3,695.5,59.1,696.3,59.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_91_",
    gradientUnits: "userSpaceOnUse",
    x1: 1440.3209,
    y1: 35.5864,
    x2: -381.4936,
    y2: -1168.1117,
    gradientTransform: "matrix(1 0 0 1 203.2719 646.4694)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1396,
    style: {
      stopColor: "#FAFAFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3023,
    style: {
      stopColor: "#ECECEC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4765,
    style: {
      stopColor: "#D6D6D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6589,
    style: {
      stopColor: "#B6B6B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8457,
    style: {
      stopColor: "#8D8D8A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#666662"
    }
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    className: "st89",
    d: "M704.7,58.9c0.8,0,1.4,1.2,1.4,2.8s-0.7,2.8-1.4,2.9c-0.8,0-1.4-1.2-1.4-2.8S703.8,59,704.7,58.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_92_",
    gradientUnits: "userSpaceOnUse",
    x1: 1456.7159,
    y1: 40.6871,
    x2: -396.0603,
    y2: -1183.4685,
    gradientTransform: "matrix(1 0 0 1 203.2719 646.4694)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1396,
    style: {
      stopColor: "#FAFAFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3023,
    style: {
      stopColor: "#ECECEC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4765,
    style: {
      stopColor: "#D6D6D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6589,
    style: {
      stopColor: "#B6B6B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8457,
    style: {
      stopColor: "#8D8D8A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#666662"
    }
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    className: "st90",
    d: "M713.2,58.8c0.8,0,1.4,1.2,1.4,2.8s-0.7,2.9-1.4,2.9s-1.4-1.2-1.4-2.8C711.8,60.1,712.4,58.8,713.2,58.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_93_",
    gradientUnits: "userSpaceOnUse",
    x1: 1475.2644,
    y1: 46.9356,
    x2: -412.7039,
    y2: -1200.4712,
    gradientTransform: "matrix(1 0 0 1 203.2719 646.4694)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1396,
    style: {
      stopColor: "#FAFAFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3023,
    style: {
      stopColor: "#ECECEC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4765,
    style: {
      stopColor: "#D6D6D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6589,
    style: {
      stopColor: "#B6B6B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8457,
    style: {
      stopColor: "#8D8D8A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#666662"
    }
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    className: "st91",
    d: "M722,58.6c0.9,0,1.5,1.2,1.5,2.9s-0.7,2.9-1.5,2.9c-0.9,0-1.5-1.2-1.5-2.9C720.6,59.9,721.3,58.7,722,58.6z "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_94_",
    gradientUnits: "userSpaceOnUse",
    x1: 1494.6101,
    y1: 53.6205,
    x2: -430.3374,
    y2: -1218.219,
    gradientTransform: "matrix(1 0 0 1 203.2719 646.4694)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1396,
    style: {
      stopColor: "#FAFAFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3023,
    style: {
      stopColor: "#ECECEC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4765,
    style: {
      stopColor: "#D6D6D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6589,
    style: {
      stopColor: "#B6B6B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8457,
    style: {
      stopColor: "#8D8D8A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#666662"
    }
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    className: "st92",
    d: "M731.1,58.5c0.9,0,1.5,1.3,1.5,2.9c0,1.7-0.7,2.9-1.5,2.9c-0.9,0-1.5-1.3-1.5-2.9S730.3,58.5,731.1,58.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_95_",
    gradientUnits: "userSpaceOnUse",
    x1: 1515.0459,
    y1: 60.756,
    x2: -449.1141,
    y2: -1236.9924,
    gradientTransform: "matrix(1 0 0 1 203.2719 646.4694)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1396,
    style: {
      stopColor: "#FAFAFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3023,
    style: {
      stopColor: "#ECECEC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4765,
    style: {
      stopColor: "#D6D6D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6589,
    style: {
      stopColor: "#B6B6B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8457,
    style: {
      stopColor: "#8D8D8A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#666662"
    }
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    className: "st93",
    d: "M740.5,58.2c0.9,0,1.5,1.3,1.5,2.9c0,1.7-0.8,3-1.5,3c-0.9,0-1.7-1.3-1.7-2.9 C738.8,59.6,739.6,58.2,740.5,58.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_96_",
    gradientUnits: "userSpaceOnUse",
    x1: 1536.4244,
    y1: 68.4699,
    x2: -469.1493,
    y2: -1256.6412,
    gradientTransform: "matrix(1 0 0 1 203.2719 646.4694)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1396,
    style: {
      stopColor: "#FAFAFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3023,
    style: {
      stopColor: "#ECECEC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4765,
    style: {
      stopColor: "#D6D6D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6589,
    style: {
      stopColor: "#B6B6B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8457,
    style: {
      stopColor: "#8D8D8A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#666662"
    }
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    className: "st94",
    d: "M750.1,58.1c0.9,0,1.7,1.3,1.7,3s-0.8,3-1.7,3s-1.7-1.3-1.7-3S749.1,58.1,750.1,58.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_97_",
    gradientUnits: "userSpaceOnUse",
    x1: 1287.4745,
    y1: -29.2771,
    x2: -244.1635,
    y2: -1041.2522,
    gradientTransform: "matrix(1 0 0 1 203.2719 646.4694)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1396,
    style: {
      stopColor: "#FAFAFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3023,
    style: {
      stopColor: "#ECECEC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4765,
    style: {
      stopColor: "#D6D6D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6589,
    style: {
      stopColor: "#B6B6B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8457,
    style: {
      stopColor: "#8D8D8A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#666662"
    }
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    className: "st95",
    d: "M629.8,45.9c0.7,0,1.1,1,1.1,2.4s-0.6,2.4-1.1,2.5c-0.7,0-1.1-1.1-1.1-2.4C628.7,47,629.2,45.9,629.8,45.9z "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_98_",
    gradientUnits: "userSpaceOnUse",
    x1: 1300.4514,
    y1: -25.4835,
    x2: -254.4306,
    y2: -1052.8156,
    gradientTransform: "matrix(1 0 0 1 203.2719 646.4694)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1396,
    style: {
      stopColor: "#FAFAFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3023,
    style: {
      stopColor: "#ECECEC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4765,
    style: {
      stopColor: "#D6D6D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6589,
    style: {
      stopColor: "#B6B6B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8457,
    style: {
      stopColor: "#8D8D8A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#666662"
    }
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    className: "st96",
    d: "M636.5,45.5c0.7,0,1.1,1.1,1.1,2.4s-0.6,2.5-1.1,2.5c-0.7,0-1.1-1.1-1.1-2.4 C635.3,46.7,635.9,45.5,636.5,45.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_99_",
    gradientUnits: "userSpaceOnUse",
    x1: 1314.2102,
    y1: -21.2508,
    x2: -265.4313,
    y2: -1064.9419,
    gradientTransform: "matrix(1 0 0 1 203.2719 646.4694)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1396,
    style: {
      stopColor: "#FAFAFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3023,
    style: {
      stopColor: "#ECECEC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4765,
    style: {
      stopColor: "#D6D6D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6589,
    style: {
      stopColor: "#B6B6B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8457,
    style: {
      stopColor: "#8D8D8A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#666662"
    }
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M643.4,45.2c0.7,0,1.2,1.1,1.2,2.4c0,1.4-0.6,2.5-1.2,2.5s-1.2-1.1-1.2-2.4 C642.2,46.4,642.7,45.3,643.4,45.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_100_",
    gradientUnits: "userSpaceOnUse",
    x1: 1328.4635,
    y1: -16.6539,
    x2: -277.0712,
    y2: -1077.453,
    gradientTransform: "matrix(1 0 0 1 203.2719 646.4694)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1396,
    style: {
      stopColor: "#FAFAFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3023,
    style: {
      stopColor: "#ECECEC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4765,
    style: {
      stopColor: "#D6D6D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6589,
    style: {
      stopColor: "#B6B6B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8457,
    style: {
      stopColor: "#8D8D8A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#666662"
    }
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    className: "st98",
    d: "M650.3,44.9c0.7,0,1.2,1.1,1.2,2.5c0,1.4-0.6,2.5-1.2,2.7c-0.7,0-1.2-1.1-1.2-2.5 C649.1,46.1,649.7,45,650.3,44.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_101_",
    gradientUnits: "userSpaceOnUse",
    x1: 1342.2544,
    y1: -12.619,
    x2: -288.3004,
    y2: -1089.9492,
    gradientTransform: "matrix(1 0 0 1 203.2719 646.4694)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1396,
    style: {
      stopColor: "#FAFAFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3023,
    style: {
      stopColor: "#ECECEC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4765,
    style: {
      stopColor: "#D6D6D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6589,
    style: {
      stopColor: "#B6B6B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8457,
    style: {
      stopColor: "#8D8D8A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#666662"
    }
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    className: "st99",
    d: "M657.5,44.5c0.7,0,1.2,1.1,1.2,2.5c0,1.4-0.6,2.7-1.2,2.7s-1.2-1.1-1.2-2.5 C656.3,45.7,656.8,44.6,657.5,44.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_102_",
    gradientUnits: "userSpaceOnUse",
    x1: 1358.201,
    y1: -7.195,
    x2: -301.5153,
    y2: -1103.7932,
    gradientTransform: "matrix(1 0 0 1 203.2719 646.4694)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1396,
    style: {
      stopColor: "#FAFAFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3023,
    style: {
      stopColor: "#ECECEC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4765,
    style: {
      stopColor: "#D6D6D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6589,
    style: {
      stopColor: "#B6B6B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8457,
    style: {
      stopColor: "#8D8D8A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#666662"
    }
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    className: "st100",
    d: "M664.9,44.3c0.7,0,1.2,1.1,1.2,2.5s-0.6,2.7-1.2,2.7s-1.2-1.1-1.2-2.5C663.6,45.5,664.3,44.3,664.9,44.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_103_",
    gradientUnits: "userSpaceOnUse",
    x1: 1373.5605,
    y1: -2.4118,
    x2: -314.2574,
    y2: -1117.5773,
    gradientTransform: "matrix(1 0 0 1 203.2719 646.4694)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1396,
    style: {
      stopColor: "#FAFAFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3023,
    style: {
      stopColor: "#ECECEC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4765,
    style: {
      stopColor: "#D6D6D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6589,
    style: {
      stopColor: "#B6B6B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8457,
    style: {
      stopColor: "#8D8D8A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#666662"
    }
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    className: "st101",
    d: "M672.4,43.9c0.8,0,1.3,1.1,1.3,2.7c0,1.4-0.6,2.7-1.3,2.7c-0.7,0-1.3-1.1-1.3-2.5 C671.2,45.2,671.8,44,672.4,43.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_104_",
    gradientUnits: "userSpaceOnUse",
    x1: 1388.5392,
    y1: 2.1114,
    x2: -326.8752,
    y2: -1131.2866,
    gradientTransform: "matrix(1 0 0 1 203.2719 646.4694)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1396,
    style: {
      stopColor: "#FAFAFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3023,
    style: {
      stopColor: "#ECECEC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4765,
    style: {
      stopColor: "#D6D6D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6589,
    style: {
      stopColor: "#B6B6B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8457,
    style: {
      stopColor: "#8D8D8A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#666662"
    }
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    className: "st102",
    d: "M680.2,43.5c0.8,0,1.3,1.1,1.3,2.7c0,1.4-0.6,2.7-1.3,2.8c-0.8,0-1.3-1.1-1.3-2.7 C678.8,44.9,679.5,43.6,680.2,43.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_105_",
    gradientUnits: "userSpaceOnUse",
    x1: 1405.6752,
    y1: 7.8402,
    x2: -341.4337,
    y2: -1146.4995,
    gradientTransform: "matrix(1 0 0 1 203.2719 646.4694)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1396,
    style: {
      stopColor: "#FAFAFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3023,
    style: {
      stopColor: "#ECECEC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4765,
    style: {
      stopColor: "#D6D6D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6589,
    style: {
      stopColor: "#B6B6B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8457,
    style: {
      stopColor: "#8D8D8A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#666662"
    }
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    className: "st103",
    d: "M688.1,43.2c0.8,0,1.3,1.1,1.3,2.7c0,1.4-0.7,2.8-1.3,2.8c-0.8,0-1.3-1.2-1.3-2.7 C686.8,44.5,687.3,43.2,688.1,43.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_106_",
    gradientUnits: "userSpaceOnUse",
    x1: 1422.5685,
    y1: 13.2734,
    x2: -355.9142,
    y2: -1161.7955,
    gradientTransform: "matrix(1 0 0 1 203.2719 646.4694)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1396,
    style: {
      stopColor: "#FAFAFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3023,
    style: {
      stopColor: "#ECECEC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4765,
    style: {
      stopColor: "#D6D6D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6589,
    style: {
      stopColor: "#B6B6B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8457,
    style: {
      stopColor: "#8D8D8A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#666662"
    }
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M696.3,42.9c0.8,0,1.4,1.2,1.4,2.7c0,1.5-0.7,2.8-1.4,2.8s-1.4-1.2-1.4-2.7S695.5,42.9,696.3,42.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_107_",
    gradientUnits: "userSpaceOnUse",
    x1: 1438.9307,
    y1: 18.2037,
    x2: -370.0179,
    y2: -1176.9938,
    gradientTransform: "matrix(1 0 0 1 203.2719 646.4694)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1396,
    style: {
      stopColor: "#FAFAFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3023,
    style: {
      stopColor: "#ECECEC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4765,
    style: {
      stopColor: "#D6D6D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6589,
    style: {
      stopColor: "#B6B6B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8457,
    style: {
      stopColor: "#8D8D8A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#666662"
    }
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    className: "st105",
    d: "M704.7,42.4c0.8,0,1.4,1.2,1.4,2.8s-0.7,2.8-1.4,2.9c-0.8,0-1.4-1.2-1.4-2.8 C703.3,43.8,703.8,42.5,704.7,42.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_108_",
    gradientUnits: "userSpaceOnUse",
    x1: 1456.5458,
    y1: 23.8891,
    x2: -385.4559,
    y2: -1193.1469,
    gradientTransform: "matrix(1 0 0 1 203.2719 646.4694)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1396,
    style: {
      stopColor: "#FAFAFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3023,
    style: {
      stopColor: "#ECECEC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4765,
    style: {
      stopColor: "#D6D6D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6589,
    style: {
      stopColor: "#B6B6B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8457,
    style: {
      stopColor: "#8D8D8A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#666662"
    }
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    className: "st106",
    d: "M713.2,42.1c0.8,0,1.4,1.2,1.4,2.8s-0.7,2.9-1.4,2.9s-1.4-1.2-1.4-2.8C711.8,43.4,712.4,42.1,713.2,42.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_109_",
    gradientUnits: "userSpaceOnUse",
    x1: 1474.9735,
    y1: 29.782,
    x2: -401.6434,
    y2: -1210.1248,
    gradientTransform: "matrix(1 0 0 1 203.2719 646.4694)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1396,
    style: {
      stopColor: "#FAFAFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3023,
    style: {
      stopColor: "#ECECEC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4765,
    style: {
      stopColor: "#D6D6D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6589,
    style: {
      stopColor: "#B6B6B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8457,
    style: {
      stopColor: "#8D8D8A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#666662"
    }
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "M722,41.7c0.9,0,1.5,1.2,1.5,2.8s-0.7,2.9-1.5,2.9c-0.9,0-1.5-1.2-1.5-2.8C720.6,43.1,721.3,41.8,722,41.7 z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_110_",
    gradientUnits: "userSpaceOnUse",
    x1: 1494.238,
    y1: 36.3027,
    x2: -418.9964,
    y2: -1227.7979,
    gradientTransform: "matrix(1 0 0 1 203.2719 646.4694)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1396,
    style: {
      stopColor: "#FAFAFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3023,
    style: {
      stopColor: "#ECECEC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4765,
    style: {
      stopColor: "#D6D6D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6589,
    style: {
      stopColor: "#B6B6B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8457,
    style: {
      stopColor: "#8D8D8A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#666662"
    }
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    className: "st108",
    d: "M731.1,41.3c0.9,0,1.5,1.2,1.5,2.9c0,1.7-0.7,3-1.5,3c-0.9,0-1.5-1.2-1.5-2.9S730.3,41.3,731.1,41.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_111_",
    gradientUnits: "userSpaceOnUse",
    x1: 1513.5315,
    y1: 42.4078,
    x2: -436.2756,
    y2: -1245.8575,
    gradientTransform: "matrix(1 0 0 1 203.2719 646.4694)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1396,
    style: {
      stopColor: "#FAFAFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3023,
    style: {
      stopColor: "#ECECEC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4765,
    style: {
      stopColor: "#D6D6D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6589,
    style: {
      stopColor: "#B6B6B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8457,
    style: {
      stopColor: "#8D8D8A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#666662"
    }
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    className: "st109",
    d: "M740.5,40.9c0.9,0,1.5,1.2,1.5,2.9s-0.8,3-1.5,3c-0.9,0-1.7-1.2-1.7-2.9C738.8,42.2,739.6,40.9,740.5,40.9 z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_112_",
    gradientUnits: "userSpaceOnUse",
    x1: 1535.5289,
    y1: 50.1916,
    x2: -456.4865,
    y2: -1265.9606,
    gradientTransform: "matrix(1 0 0 1 203.2719 646.4694)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1396,
    style: {
      stopColor: "#FAFAFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3023,
    style: {
      stopColor: "#ECECEC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4765,
    style: {
      stopColor: "#D6D6D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6589,
    style: {
      stopColor: "#B6B6B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8457,
    style: {
      stopColor: "#8D8D8A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#666662"
    }
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    className: "st110",
    d: "M750.1,40.4c0.9,0,1.7,1.2,1.7,2.9s-0.8,3-1.7,3.1c-0.9,0-1.7-1.3-1.7-2.9 C748.5,41.9,749.1,40.4,750.1,40.4z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_113_",
    gradientUnits: "userSpaceOnUse",
    x1: 2127.2583,
    y1: 281.0841,
    x2: -1730.2057,
    y2: -1716.8475,
    gradientTransform: "matrix(1 0 0 1 203.2719 646.4694)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFEF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4628,
    style: {
      stopColor: "#CCC337"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#899F00"
    }
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st111",
    points: "905.9,123.2 854,122.5 826.2,165.9 789.1,163.3 769.7,128.6 682.8,126.7 674,144.2 651.9,143.1  651.9,144.9 674.3,146.1 683.1,128.5 769.2,130.7 788.6,165.4 826.9,168.2 854.6,125 905.2,125.7 956.5,202.3 1122.8,219  1181.5,293.8 1207,297.9 1253.5,356.1 1348.2,375.5 1489.3,541 1492.9,539 1349.9,371.9 1255,352.8 1208.3,294.7 1182.8,290.6  1124,215.9 957.3,199.8  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_114_",
    gradientUnits: "userSpaceOnUse",
    x1: 1248.306,
    y1: -88.3597,
    x2: -628.6967,
    y2: -1060.5323,
    gradientTransform: "matrix(1 0 0 1 203.2719 646.4694)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFEF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4628,
    style: {
      stopColor: "#CCC337"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#899F00"
    }
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    className: "st112",
    d: "M652,140.7c-0.9,0-1.5,1.4-1.5,3.2c0,1.9,0.7,3.3,1.5,3.4c0.9,0,1.5-1.4,1.5-3.2 C653.5,142.2,652.8,140.7,652,140.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_115_",
    gradientUnits: "userSpaceOnUse",
    x1: 2564.7295,
    y1: -101.329,
    x2: -1714.7753,
    y2: -2317.8506,
    gradientTransform: "matrix(1 0 0 1 203.2719 646.4694)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFEF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4628,
    style: {
      stopColor: "#CCC337"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#899F00"
    }
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st113",
    points: "2084.1,-437 1924.1,-295 1463.2,-193.8 1370.2,-90.8 1259.1,-73.5 1205.8,-9.7 1136.9,-2.3  1104.3,-36.5 1049.6,-28.6 1023.9,7.3 966.7,13.7 952.8,-4 896.9,3.3 866.4,52.9 804.9,57.6 783,22.3 748.1,26.7 724.3,73.1  653.5,77.5 653.5,79.2 724.7,75.1 748.6,28.7 782.5,24.5 804.5,59.8 867,55.4 897.5,5.7 952,-1.2 965.9,16.5 1024.8,10.2  1050.4,-25.9 1103.2,-33.3 1135.7,1.1 1207,-6.4 1260.5,-70.2 1372,-87.2 1465.1,-190.1 1927.6,-290.2 2091.1,-434.7  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_116_",
    gradientUnits: "userSpaceOnUse",
    x1: 1247.014,
    y1: -155.5132,
    x2: -588.3457,
    y2: -1106.1172,
    gradientTransform: "matrix(1 0 0 1 203.2719 646.4694)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFEF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4628,
    style: {
      stopColor: "#CCC337"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#899F00"
    }
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    className: "st114",
    d: "M653.6,75c-0.9,0.1-1.5,1.5-1.5,3.4c0,1.9,0.7,3.3,1.5,3.2c0.9,0,1.5-1.5,1.5-3.4 C655.3,76.5,654.5,74.9,653.6,75z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_117_",
    gradientUnits: "userSpaceOnUse",
    x1: 2280.7959,
    y1: 170.8275,
    x2: -1756.2206,
    y2: -1920.1001,
    gradientTransform: "matrix(1 0 0 1 203.2719 646.4694)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFEF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4628,
    style: {
      stopColor: "#CCC337"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#899F00"
    }
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st115",
    points: "945.7,35.5 901.9,39.3 874.8,82.1 795.4,85.2 776.6,53.9 754.4,55.8 728.2,105.2 683,105.6  672.9,126.1 654,125.7 654,127.5 673.2,128 683.4,107.5 728.7,107.2 754.9,57.8 776.2,56.1 794.9,87.4 875.4,84.5 902.7,41.8  944.9,38.1 970.6,72.2 1062.9,68 1093.4,28.6 1239.1,16.7 1346.2,121.3 1630.6,123.2 1707.9,185 1712.5,181.8 1633.1,118.5  1347.9,117.5 1240.5,13 1092.4,25.6 1061.9,65 971.4,69.4  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_118_",
    gradientUnits: "userSpaceOnUse",
    x1: 1249.033,
    y1: -106.3554,
    x2: -619.4745,
    y2: -1074.1281,
    gradientTransform: "matrix(1 0 0 1 203.2719 646.4694)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFEF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4628,
    style: {
      stopColor: "#CCC337"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#899F00"
    }
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    className: "st116",
    d: "M654,123.3c-0.9,0-1.5,1.4-1.5,3.3c0,1.9,0.7,3.3,1.5,3.3c0.9,0,1.5-1.4,1.5-3.3 C655.6,124.8,654.9,123.3,654,123.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_119_",
    gradientUnits: "userSpaceOnUse",
    x1: 1023.9391,
    y1: -297.1852,
    x2: -255.2656,
    y2: -959.735,
    gradientTransform: "matrix(1 0 0 1 203.2719 646.4694)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFEF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4628,
    style: {
      stopColor: "#CCC337"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#899F00"
    }
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st117",
    points: "750.8,42.9 729,84.5 681.6,86.5 669.9,110.7 654.9,110.7 654.9,112.5 670.2,112.5 682,88.4  729.4,86.5 751.5,44.2  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_120_",
    gradientUnits: "userSpaceOnUse",
    x1: 1251.7026,
    y1: -120.5106,
    x2: -614.1296,
    y2: -1086.8976,
    gradientTransform: "matrix(1 0 0 1 203.2719 646.4694)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFEF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4628,
    style: {
      stopColor: "#CCC337"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#899F00"
    }
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    className: "st118",
    d: "M655,108.3c-0.9,0-1.5,1.5-1.5,3.3c0,1.9,0.7,3.3,1.5,3.3c0.9,0,1.5-1.5,1.5-3.3S655.9,108.3,655,108.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_121_",
    gradientUnits: "userSpaceOnUse",
    x1: 1436.9504,
    y1: -142.3114,
    x2: -837.9827,
    y2: -1320.5876,
    gradientTransform: "matrix(1 0 0 1 203.2719 646.4694)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFEF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4628,
    style: {
      stopColor: "#CCC337"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#899F00"
    }
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    className: "st119",
    d: "M749.7,41.1c0.9-1.5,2.2-1.8,3-0.3c0.9,1.4,0.9,3.9,0,5.5c-0.9,1.5-2.2,1.7-3,0.3 C748.8,45.2,748.8,42.7,749.7,41.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_122_",
    gradientUnits: "userSpaceOnUse",
    x1: 1651.0896,
    y1: -51.3794,
    x2: -1131.3024,
    y2: -1492.4883,
    gradientTransform: "matrix(1 0 0 1 203.2719 646.4694)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFEF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4628,
    style: {
      stopColor: "#CCC337"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#899F00"
    }
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "st120",
    points: "938.4,61.1 899.3,63.5 871.7,106.2 793.4,106.9 775,75.5 760.3,76.2 744.1,105.9 744.9,107.3  760.7,78.2 774.4,77.6 792.9,109.1 872.3,108.6 899.9,66 937.6,63.9 969,106.6 1071.9,106 1071.9,103 969.8,104  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_123_",
    gradientUnits: "userSpaceOnUse",
    x1: 1430.2095,
    y1: -79.6205,
    x2: -871.6348,
    y2: -1271.8351,
    gradientTransform: "matrix(1 0 0 1 203.2719 646.4694)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFEF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4628,
    style: {
      stopColor: "#CCC337"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#899F00"
    }
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    className: "st121",
    d: "M743.1,103.8c-0.8,1.5-0.8,4,0,5.4c0.8,1.5,2.1,1.5,3,0c0.8-1.5,0.8-4,0-5.4 C745.2,102.2,743.9,102.2,743.1,103.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_124_",
    gradientUnits: "userSpaceOnUse",
    x1: 2144.5,
    y1: 118.9428,
    x2: -2200.4497,
    y2: -2131.4753,
    gradientTransform: "matrix(1 0 0 1 203.2719 646.4694)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFEF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4628,
    style: {
      stopColor: "#CCC337"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#899F00"
    }
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    className: "st122",
    d: "M1071.7,98.8c2.5,0,4.6,2.4,4.6,5.6c0,3.2-2.1,5.7-4.6,5.7c-2.5,0-4.5-2.5-4.5-5.6 C1067,101.3,1069.1,98.8,1071.7,98.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_125_",
    gradientUnits: "userSpaceOnUse",
    x1: 1445.3796,
    y1: -79.7489,
    x2: -894.2884,
    y2: -1291.5547,
    gradientTransform: "matrix(1 0 0 1 203.2719 646.4694)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFEF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4628,
    style: {
      stopColor: "#CCC337"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#899F00"
    }
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "st123",
    points: "778.9,109.1 762.9,109.2 762.9,111.3 778.5,111.2 791,132.9 828.9,133.9 828.9,131.7 791.4,130.7  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_126_",
    gradientUnits: "userSpaceOnUse",
    x1: 1467.9761,
    y1: -65.795,
    x2: -933.499,
    y2: -1309.613,
    gradientTransform: "matrix(1 0 0 1 203.2719 646.4694)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFEF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4628,
    style: {
      stopColor: "#CCC337"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#899F00"
    }
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    className: "st124",
    d: "M763,106.3c-1.2,0-2.2,1.8-2.2,4c0,2.2,1,4,2.2,4s2.2-1.8,2.2-4C765.2,108.1,764.3,106.3,763,106.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_127_",
    gradientUnits: "userSpaceOnUse",
    x1: 1605.8942,
    y1: -5.8728,
    x2: -1179.5985,
    y2: -1448.5886,
    gradientTransform: "matrix(1 0 0 1 203.2719 646.4694)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFEF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4628,
    style: {
      stopColor: "#CCC337"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#899F00"
    }
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    className: "st125",
    d: "M828.8,128.5c1.4,0,2.7,2,2.7,4.4c0,2.4-1.2,4.3-2.7,4.2c-1.4,0-2.7-2-2.7-4.4 C826.1,130.4,827.3,128.5,828.8,128.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_128_",
    gradientUnits: "userSpaceOnUse",
    x1: 3149.595,
    y1: 686.6107,
    x2: -4208.5166,
    y2: -3124.4409,
    gradientTransform: "matrix(1 0 0 1 203.2719 646.4694)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFEF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4628,
    style: {
      stopColor: "#CCC337"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#899F00"
    }
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "st126",
    points: "917.1,93.5 915.7,95.4 966,167.6 1169.9,180 1244.9,269 1432.8,293.7 1526.5,391.2 1667.5,418  1789.5,535.8 2072.9,605.3 2072.9,599.3 1792.4,531.4 1670,413.7 1528.6,387.2 1434.6,289.8 1246.4,265.5 1171.1,176.8  966.9,165  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_129_",
    gradientUnits: "userSpaceOnUse",
    x1: 1792.0237,
    y1: 6.8613,
    x2: -1479.7051,
    y2: -1687.6941,
    gradientTransform: "matrix(1 0 0 1 203.2719 646.4694)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFEF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4628,
    style: {
      stopColor: "#CCC337"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#899F00"
    }
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    className: "st127",
    d: "M918.8,91.2c-1.3-1.9-3.4-1.8-4.6,0.1c-1.3,1.9-1.3,5,0,6.7c1.3,1.9,3.3,1.8,4.6-0.1 S920.2,92.9,918.8,91.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_130_",
    gradientUnits: "userSpaceOnUse",
    x1: 2450.3826,
    y1: 259.5766,
    x2: -2740.2041,
    y2: -2428.8298,
    gradientTransform: "matrix(1 0 0 1 203.2719 646.4694)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFEF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4628,
    style: {
      stopColor: "#CCC337"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#899F00"
    }
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "st128",
    points: "937,84.3 935.6,86.2 982,151.1 1087.8,155.5 1124.5,112.5 1203.6,112.5 1272.3,187.5  1498.8,201.4 1498.8,197.1 1273.8,184 1204.8,109.1 1123.4,109.4 1086.8,152.4 982.9,148.4  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_131_",
    gradientUnits: "userSpaceOnUse",
    x1: 1833.7181,
    y1: 9.0353,
    x2: -1549.0253,
    y2: -1743.0189,
    gradientTransform: "matrix(1 0 0 1 203.2719 646.4694)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFEF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4628,
    style: {
      stopColor: "#CCC337"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#899F00"
    }
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    className: "st129",
    d: "M938.8,81.9c-1.3-1.9-3.5-1.8-4.9,0.2c-1.3,2-1.3,5.1,0,7c1.3,1.9,3.5,1.8,4.9-0.1 C940.2,86.9,940.2,83.8,938.8,81.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_132_",
    gradientUnits: "userSpaceOnUse",
    x1: 3185.7776,
    y1: 616.0698,
    x2: -4811.1221,
    y2: -3525.8352,
    gradientTransform: "matrix(1 0 0 1 203.2719 646.4694)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFEF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4628,
    style: {
      stopColor: "#CCC337"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#899F00"
    }
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "st130",
    points: "1182.7,140.2 1136,139.1 1136,142.3 1181.5,143.6 1250.6,222.3 1515.1,246.7 1599.9,327.3  1739.3,346.7 1829,425.9 1834.3,423.1 1742,342.1 1602.4,323 1517.2,242.7 1251.9,218.9  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_133_",
    gradientUnits: "userSpaceOnUse",
    x1: 2302.1077,
    y1: 203.3493,
    x2: -2598.7922,
    y2: -2335.0171,
    gradientTransform: "matrix(1 0 0 1 203.2719 646.4694)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFEF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4628,
    style: {
      stopColor: "#CCC337"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#899F00"
    }
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    className: "st131",
    d: "M1136.3,134.7c-2.9,0-5.2,2.5-5.2,5.9c0,3.3,2.3,6.1,5.2,6.2s5.2-2.5,5.2-5.9 C1141.5,137.6,1139.2,134.8,1136.3,134.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_134_",
    gradientUnits: "userSpaceOnUse",
    x1: 2603.8579,
    y1: 264.5463,
    x2: -3095.1626,
    y2: -2687.1997,
    gradientTransform: "matrix(1 0 0 1 203.2719 646.4694)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFEF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4628,
    style: {
      stopColor: "#CCC337"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#899F00"
    }
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "st132",
    points: "1232.4,43.4 1111.9,50.6 1083.3,86.2 1010.7,88.1 1010.7,90.9 1084.4,89.3 1113,53.7 1231.1,47.1  1325.5,142.3 1537,147.2 1537,142.8 1327.1,138.6  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_135_",
    gradientUnits: "userSpaceOnUse",
    x1: 2001.8093,
    y1: 61.5706,
    x2: -1883.6564,
    y2: -1950.863,
    gradientTransform: "matrix(1 0 0 1 203.2719 646.4694)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFEF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4628,
    style: {
      stopColor: "#CCC337"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#899F00"
    }
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    className: "st133",
    d: "M1010.9,84.2c-2.2,0.1-4.1,2.5-4.1,5.4c0,2.9,1.8,5.3,4.1,5.2c2.2,0,4.1-2.5,4.1-5.4 C1014.9,86.5,1013.1,84.1,1010.9,84.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_136_",
    gradientUnits: "userSpaceOnUse",
    x1: 3327.7832,
    y1: 531.5795,
    x2: -5320.3154,
    y2: -3947.6067,
    gradientTransform: "matrix(1 0 0 1 203.2719 646.4694)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFEF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4628,
    style: {
      stopColor: "#CCC337"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#899F00"
    }
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    className: "st134",
    d: "M1536.4,136.7c5.4,0.1,9.9,3.9,9.9,8.5c0,4.6-4.4,8.3-9.9,8.1c-5.4-0.1-9.7-4-9.7-8.5 C1526.7,140.2,1531,136.6,1536.4,136.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_137_",
    gradientUnits: "userSpaceOnUse",
    x1: 2976.22,
    y1: 481.5167,
    x2: -3942.2764,
    y2: -3101.8435,
    gradientTransform: "matrix(1 0 0 1 203.2719 646.4694)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFEF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4628,
    style: {
      stopColor: "#CCC337"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#899F00"
    }
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "st135",
    points: "1217.2,74 1119.9,77.3 1082.6,122.7 992.4,121.8 992.4,124.5 1083.7,125.6 1121.1,80.4  1215.9,77.6 1298.5,164.2 1561.5,175.1 1698.1,294.1 1839.3,309.8 1839.3,304.5 1700.8,289.5 1563.8,170.7 1299.9,160.6  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_138_",
    gradientUnits: "userSpaceOnUse",
    x1: 1964.2233,
    y1: 85.1548,
    x2: -1844.1984,
    y2: -1887.3748,
    gradientTransform: "matrix(1 0 0 1 203.2719 646.4694)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFEF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4628,
    style: {
      stopColor: "#CCC337"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#899F00"
    }
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    className: "st136",
    d: "M992.7,117.9c-2.1,0-3.9,2.3-3.9,5.2c0,2.9,1.8,5.2,3.9,5.3c2.2,0,4-2.3,4-5.2 C996.5,120.3,994.8,117.9,992.7,117.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_139_",
    gradientUnits: "userSpaceOnUse",
    x1: 1164.7278,
    y1: -296.9347,
    x2: -422.5748,
    y2: -1119.0609,
    gradientTransform: "matrix(1 0 0 1 203.2719 646.4694)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFEF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4628,
    style: {
      stopColor: "#CCC337"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#899F00"
    }
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    className: "st137",
    points: "679.7,-7 651.7,-1.4 651.7,0.3 679.4,-5 690.1,14.8 743.6,6.4 743.6,4.3 690.6,12.8  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_140_",
    gradientUnits: "userSpaceOnUse",
    x1: 1236.5326,
    y1: -238.8604,
    x2: -530.5691,
    y2: -1154.1116,
    gradientTransform: "matrix(1 0 0 1 203.2719 646.4694)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFEF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4628,
    style: {
      stopColor: "#CCC337"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#899F00"
    }
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    className: "st138",
    d: "M651.8-3.9c-0.9,0.2-1.5,1.8-1.5,3.6s0.7,3.2,1.5,3c0.9-0.1,1.5-1.8,1.5-3.6 C653.3-2.7,652.7-4.1,651.8-3.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_141_",
    gradientUnits: "userSpaceOnUse",
    x1: 1417.9567,
    y1: -186.4528,
    x2: -783.9774,
    y2: -1326.9199,
    gradientTransform: "matrix(1 0 0 1 203.2719 646.4694)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFEF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4628,
    style: {
      stopColor: "#CCC337"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#899F00"
    }
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    className: "st139",
    d: "M743.5,1.5c1.2-0.2,2.1,1.3,2.1,3.5c0,2.1-1,4-2.1,4.2s-2.1-1.4-2.1-3.5C741.4,3.5,742.4,1.8,743.5,1.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_142_",
    gradientUnits: "userSpaceOnUse",
    x1: 2463.3096,
    y1: -126.1379,
    x2: -1761.1366,
    y2: -2314.1426,
    gradientTransform: "matrix(1 0 0 1 203.2719 646.4694)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFEF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4628,
    style: {
      stopColor: "#CCC337"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#899F00"
    }
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    className: "st140",
    points: "1909.2,-366.4 1361.6,-224 1293.4,-140.9 1224.3,-126.5 1181.1,-164 1123,-149.6 1074.4,-80.3  972.2,-60.8 932.3,-107.7 878.1,-93.9 852.2,-47.7 764.8,-29.9 754.8,-10.1 707.7,-1.7 707.7,0.2 755.3,-8.1 765.2,-28  852.8,-45.5 878.7,-91.7 931.5,-105 971.3,-57.9 1075.4,-77.5 1124.1,-146.7 1179.8,-160.3 1222.9,-122.9 1294.9,-137.5  1363.4,-220.6 1909.2,-360.8  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_143_",
    gradientUnits: "userSpaceOnUse",
    x1: 1347.1851,
    y1: -210.7097,
    x2: -678.8907,
    y2: -1260.093,
    gradientTransform: "matrix(1 0 0 1 203.2719 646.4694)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFEF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4628,
    style: {
      stopColor: "#CCC337"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#899F00"
    }
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    className: "st141",
    d: "M707.8-4.3c-1,0.2-1.9,2-1.9,4s0.9,3.4,1.9,3.3c1-0.2,1.9-2,1.9-4C709.7-3.1,708.8-4.5,707.8-4.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_144_",
    gradientUnits: "userSpaceOnUse",
    x1: 2528.7568,
    y1: -75.5872,
    x2: -2028.917,
    y2: -2436.1851,
    gradientTransform: "matrix(1 0 0 1 203.2719 646.4694)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFEF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4628,
    style: {
      stopColor: "#CCC337"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#899F00"
    }
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    className: "st142",
    points: "1886.8,-330.4 1450.4,-224.2 1350.4,-110.2 1239.2,-90.8 1207,-51.3 1150.6,-43.1 1127.1,-66.6  1039.6,-51.8 1019,-22 1000.5,-19.3 984.6,-38.1 896.4,-23.6 865.7,27.4 817.1,32.6 798.6,4.1 758.4,10.1 758.4,12.2 798.1,6.3  816.5,34.9 866.2,29.7 897.1,-21.2 983.8,-35.2 999.6,-16.4 1019.8,-19.2 1040.6,-49.1 1126,-63.2 1149.3,-39.8 1208.3,-48.1  1240.5,-87.5 1352.1,-106.6 1452.3,-220.4 1886.8,-325  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_145_",
    gradientUnits: "userSpaceOnUse",
    x1: 1448.9952,
    y1: -172.4705,
    x2: -833.8021,
    y2: -1354.8198,
    gradientTransform: "matrix(1 0 0 1 203.2719 646.4694)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFEF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4628,
    style: {
      stopColor: "#CCC337"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#899F00"
    }
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    className: "st143",
    d: "M758.5,7.2c-1.2,0.2-2.2,2.1-2.2,4.2c0,2.2,1,3.8,2.2,3.6c1.2-0.2,2.2-2.1,2.2-4.2 C760.6,8.6,759.7,7,758.5,7.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_146_",
    gradientUnits: "userSpaceOnUse",
    x1: 1085.3519,
    y1: -306.2469,
    x2: -330.0898,
    y2: -1039.3591,
    gradientTransform: "matrix(1 0 0 1 203.2719 646.4694)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFEF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4628,
    style: {
      stopColor: "#CCC337"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#899F00"
    }
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    className: "st144",
    points: "736.8,17.7 688.6,24.5 679.4,44.2 654.9,47 654.9,48.7 679.7,46.1 689,26.4 736.8,19.7  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_147_",
    gradientUnits: "userSpaceOnUse",
    x1: 1247.4584,
    y1: -186.4332,
    x2: -571.5852,
    y2: -1128.5872,
    gradientTransform: "matrix(1 0 0 1 203.2719 646.4694)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFEF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4628,
    style: {
      stopColor: "#CCC337"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#899F00"
    }
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    className: "st145",
    d: "M655,44.5c-0.9,0.1-1.5,1.7-1.5,3.5s0.7,3.2,1.5,3.2c0.9-0.1,1.5-1.7,1.5-3.5 C656.5,45.9,655.9,44.4,655,44.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_148_",
    gradientUnits: "userSpaceOnUse",
    x1: 1404.787,
    y1: -176.4529,
    x2: -773.455,
    y2: -1304.649,
    gradientTransform: "matrix(1 0 0 1 203.2719 646.4694)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFEF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4628,
    style: {
      stopColor: "#CCC337"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#899F00"
    }
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    className: "st146",
    d: "M736.7,14.9c1.1-0.1,2.1,1.4,2.1,3.5s-0.9,3.9-2.1,4.1c-1.1,0.1-2-1.4-2-3.5 C734.8,16.9,735.6,15.1,736.7,14.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_149_",
    gradientUnits: "userSpaceOnUse",
    x1: 1078.9132,
    y1: -285.5619,
    x2: -334.3047,
    y2: -1017.5223,
    gradientTransform: "matrix(1 0 0 1 203.2719 646.4694)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFEF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4628,
    style: {
      stopColor: "#CCC337"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#899F00"
    }
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    className: "st147",
    points: "729.7,40.2 694.6,44.1 684.9,64.2 651.2,66.9 651.2,68.6 685.4,66.1 695,46 729.7,42.2  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_150_",
    gradientUnits: "userSpaceOnUse",
    x1: 1240.9679,
    y1: -168.0434,
    x2: -574.1689,
    y2: -1108.1732,
    gradientTransform: "matrix(1 0 0 1 203.2719 646.4694)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFEF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4628,
    style: {
      stopColor: "#CCC337"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#899F00"
    }
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    className: "st148",
    d: "M651.3,64.4c-0.9,0.1-1.5,1.7-1.5,3.4s0.7,3.2,1.5,3.2c0.9-0.1,1.5-1.7,1.5-3.4 C652.9,65.9,652.1,64.4,651.3,64.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_151_",
    gradientUnits: "userSpaceOnUse",
    x1: 1392.4358,
    y1: -156.5874,
    x2: -770.1866,
    y2: -1276.6935,
    gradientTransform: "matrix(1 0 0 1 203.2719 646.4694)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFEF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4628,
    style: {
      stopColor: "#CCC337"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#899F00"
    }
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    className: "st149",
    d: "M729.7,37.6c1.1-0.1,2,1.4,2,3.5s-0.9,3.9-2,4s-2-1.4-2-3.5C727.6,39.4,728.5,37.7,729.7,37.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_152_",
    gradientUnits: "userSpaceOnUse",
    x1: 1430.1195,
    y1: -275.9522,
    x2: -714.7136,
    y2: -1386.8453,
    gradientTransform: "matrix(1 0 0 1 203.2719 646.4694)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFEF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4628,
    style: {
      stopColor: "#CCC337"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#899F00"
    }
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    className: "st150",
    points: "935.7,-68.1 904.6,-61.5 866.5,2.7 824.4,8.4 811.1,-11.5 765.5,-3.9 765.5,-1.8 810.6,-9.1  823.8,10.8 867.1,5 905.2,-59.2 935.7,-65.4  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_153_",
    gradientUnits: "userSpaceOnUse",
    x1: 1461.7589,
    y1: -183.4156,
    x2: -843.4526,
    y2: -1377.3741,
    gradientTransform: "matrix(1 0 0 1 203.2719 646.4694)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFEF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4628,
    style: {
      stopColor: "#CCC337"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#899F00"
    }
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    className: "st151",
    d: "M765.6-6.7c-1.2,0.2-2.2,2.1-2.2,4.3c0,2.2,1,3.8,2.2,3.6c1.2-0.2,2.2-2.1,2.2-4.3 C767.9-5.4,766.9-7,765.6-6.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_154_",
    gradientUnits: "userSpaceOnUse",
    x1: 3270.387,
    y1: 432.8027,
    x2: -4796.7515,
    y2: -3745.4844,
    gradientTransform: "matrix(1 0 0 1 203.2719 646.4694)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFEF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4628,
    style: {
      stopColor: "#CCC337"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#899F00"
    }
  })), _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    className: "st152",
    points: "1254.9,-19.1 1252.4,-16.4 1340.6,66.3 1660.6,54.6 1792.3,152.3 1797.4,148.7 1663.2,49.7  1342.3,62.4  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_155_",
    gradientUnits: "userSpaceOnUse",
    x1: 3518.9565,
    y1: 459.3479,
    x2: -5402.5181,
    y2: -4161.4302,
    gradientTransform: "matrix(1 0 0 1 203.2719 646.4694)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFEF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4628,
    style: {
      stopColor: "#CCC337"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#899F00"
    }
  })), _polygon19 || (_polygon19 = /*#__PURE__*/React.createElement("polygon", {
    className: "st153",
    points: "1619.9,-63 1530,-52.8 1463.5,11 1357.6,18.8 1314.5,-19.6 1311.9,-16.6 1356,22.8 1465.5,15.1  1532.1,-48.6 1617.5,-58.1 1695,-4.6 1821.9,-13.8 1903.6,38.1 1909.5,33.9 1825,-19.3 1697.6,-9.7  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_156_",
    gradientUnits: "userSpaceOnUse",
    x1: 3953.4841,
    y1: 661.257,
    x2: -7005.3652,
    y2: -5014.7603,
    gradientTransform: "matrix(1 0 0 1 203.2719 646.4694)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFEF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4628,
    style: {
      stopColor: "#CCC337"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#899F00"
    }
  })), _polygon20 || (_polygon20 = /*#__PURE__*/React.createElement("polygon", {
    className: "st154",
    points: "1768.9,15.7 1584.7,26.3 1584.7,30.8 1765.9,21 1933.8,134.5 1939.7,130.6  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_157_",
    gradientUnits: "userSpaceOnUse",
    x1: 3444.0122,
    y1: 449.9942,
    x2: -5419.0757,
    y2: -4140.543,
    gradientTransform: "matrix(1 0 0 1 203.2719 646.4694)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFEF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4628,
    style: {
      stopColor: "#CCC337"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#899F00"
    }
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    className: "st155",
    d: "M1585.3,19.9c-5.7,0.3-10.4,4.4-10.4,9.2s4.6,8.3,10.4,8c5.9-0.3,10.6-4.4,10.6-9.2 C1595.7,23.2,1591,19.6,1585.3,19.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_158_",
    gradientUnits: "userSpaceOnUse",
    x1: 3914.7092,
    y1: 600.4051,
    x2: -6481.4312,
    y2: -4784.1597,
    gradientTransform: "matrix(1 0 0 1 203.2719 646.4694)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFEF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4628,
    style: {
      stopColor: "#CCC337"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#899F00"
    }
  })), _polygon21 || (_polygon21 = /*#__PURE__*/React.createElement("polygon", {
    className: "st156",
    points: "1677,-98.2 1462.2,-70.2 1425.4,-32.5 1354,-24.9 1354,-21 1427.2,-28.6 1464.1,-66.2  1674.4,-93.1 1736.4,-53.1 1881.7,-67.6 2145.1,86.4 2152.5,81.9 1885,-73.4 1739.3,-58.5  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st213"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_159_",
    gradientUnits: "userSpaceOnUse",
    x1: 2110.179,
    y1: 289.8205,
    x2: -413.0868,
    y2: -1377.3362,
    gradientTransform: "matrix(1 0 0 1 203.2719 646.4694)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1396,
    style: {
      stopColor: "#FAFAFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3023,
    style: {
      stopColor: "#ECECEC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4765,
    style: {
      stopColor: "#D6D6D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6589,
    style: {
      stopColor: "#B6B6B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8457,
    style: {
      stopColor: "#8D8D8A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#666662"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.7,
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_159_)",
      enableBackground: "new"
    },
    points: " 889.2,-19.3 876.7,-17.2 876.7,1.7 889.2,0  "
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st279",
    points: "657.8,31.3 614.1,37.3 614.1,39.3 657.5,33.5 662.9,44.3 680.6,42.2 700.6,80.2 818.6,74.1  856.1,133.9 857.4,132 819.3,71.4 701,78 681,40 663.4,42.1  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st279",
    d: "M854.2,136.5c1.3,2.1,3.4,2.2,4.8,0.1c1.3-2,1.3-5.4,0-7.5c-1.3-2.1-3.5-2.1-4.8-0.1 C852.9,131.1,852.9,134.4,854.2,136.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st279",
    d: "M614.1,42c-0.9,0.1-1.7-1.4-1.7-3.5c0-2,0.8-3.8,1.7-3.9s1.7,1.4,1.7,3.4 C615.7,40.1,615.1,41.9,614.1,42z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st279",
    points: "727.8,-29.8 670.1,-17.3 670.1,-15.2 727.2,-27.3 756.9,21.9 898.2,3.3 968.5,98.7 1386.8,92  1386.8,87.3 969.4,95.5 899.1,0.2 757.4,19.3  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st279",
    d: "M1386.2,80.9c5.3-0.1,9.5,3.8,9.5,8.7s-4.3,9.1-9.5,9.1s-9.4-3.9-9.4-8.7 C1376.9,85,1381.1,81,1386.2,80.9z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st279",
    points: "732.4,76.1 731.5,77.9 763.9,136.6 828.8,138.8 854.1,180.8 1149.7,206.1 1149.7,202.2  854.8,178 829.4,136.1 764.5,134.1  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st279",
    points: "766.8,74.8 765.8,76.7 780.4,101.7 805,101.3 805,98.7 780.9,99.1  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st279",
    d: "M804.8,95c1.7,0,3,2.2,3,5s-1.3,5-3,5.1c-1.7,0-3-2.2-3-5C801.8,97.2,803.1,95,804.8,95z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st279",
    points: "930.1,42.7 881.5,46.6 862.5,76.9 863.8,78.9 882.3,49.5 930.1,45.7  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st279",
    d: "M865.7,81.4c-1.3,2.1-3.5,2.2-4.9,0.2c-1.3-2-1.3-5.4,0-7.6c1.3-2.2,3.5-2.3,4.9-0.2 C867.1,75.8,867.1,79.2,865.7,81.4z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st279",
    points: "924.3,-32 830.1,-16.1 814.6,11.5 815.9,13.3 830.9,-13.5 923.4,-28.8 994.5,62.4 1122.7,55.5  1122.7,51.6 995.5,59  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st279",
    d: "M1122.4,46.4c3.3-0.2,6.1,2.9,6.1,6.7c0,4-2.8,7.3-6.1,7.5c-3.3,0.1-6.1-2.9-6.1-6.7 C1116.4,49.9,1119.1,46.6,1122.4,46.4z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st279",
    points: "1063.3,148.2 908.1,142.8 881.9,180.3 883.3,182.5 908.9,145.7 1063.3,151.8  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st279",
    d: "M1062.9,143.3c3,0.1,5.4,3.2,5.4,7c0,3.8-2.4,6.6-5.4,6.5c-3-0.1-5.4-3.2-5.4-7 C1057.6,146.1,1059.9,143.2,1062.9,143.3z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st279",
    points: "1082.6,94.6 1080.5,97.1 1108.3,130.7 1289.9,133.8 1289.9,129.4 1109.6,127  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st279",
    d: "M1289.4,123.3c4.5,0,8.2,3.8,8.2,8.4c0,4.5-3.6,8.2-8.2,8.2c-4.4-0.1-8.1-3.9-8.1-8.4 C1281.4,127,1285,123.3,1289.4,123.3z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st279",
    points: "1360.9,-65.7 1309.3,-9.1 1054.4,15.9 1023.4,57.9 1025.2,60.2 1055.6,19.3 1311.2,-4.9  1364.4,-62.9  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st279",
    points: "638.1,45.1 619.9,47.3 610.9,68.5 611.5,69.8 620.3,49.2 637.6,47.2 676.4,127 708.2,127.7  746,201.5 803.7,209.1 803.7,206.4 746.6,199.1 708.8,125.4 676.8,124.8  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st279",
    d: "M612.4,71.6c-0.7,1.4-1.7,1.5-2.3,0.1c-0.7-1.3-0.7-3.6,0-5.2c0.7-1.4,1.7-1.5,2.3-0.2 C613.1,67.7,613.1,70.1,612.4,71.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st279",
    points: "666.9,63.6 647.6,65.2 647.6,67.3 666.5,65.9 684.7,101.9 704,101.5 704,99.2 685.1,99.7  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st279",
    d: "M703.9,96c1.2,0,2.2,1.9,2.2,4.3s-1,4.3-2.2,4.3s-2.2-1.9-2.2-4.3C701.7,98,702.7,96.1,703.9,96z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st279",
    points: "746.6,102.3 728.6,102.5 720.3,118.2 721.2,119.9 729.1,105 746.6,104.8  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st279",
    d: "M722.5,122c-0.9,1.8-2.4,1.7-3.3,0c-0.9-1.8-0.9-4.5,0-6.2c0.9-1.8,2.4-1.8,3.3,0 C723.4,117.6,723.4,120.3,722.5,122z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st279",
    points: "924.3,90.6 914.9,104.5 840.3,105.3 840.3,108.1 915.6,107.6 925.8,92.8  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st279",
    d: "M922,88c1.5-2.3,4.1-2.4,5.6-0.2c1.5,2.2,1.5,6,0,8.2c-1.5,2.3-4.1,2.3-5.6,0.1 C920.5,93.8,920.5,90.2,922,88z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st279",
    points: "1040.1,123.1 967.3,122.3 951.3,144.2 952.9,146.5 968.3,125.5 1040.1,126.5  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st279",
    d: "M1039.8,118.2c2.9,0,5.2,3,5.2,6.6s-2.3,6.5-5.2,6.5s-5.1-3-5.1-6.6S1037,118.2,1039.8,118.2z"
  }))))), /*#__PURE__*/React.createElement("g", {
    className: "st247"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_160_",
    gradientUnits: "userSpaceOnUse",
    x1: 707.2914,
    y1: 790.8507,
    x2: 789.0392,
    y2: -819.5936,
    gradientTransform: "matrix(1 0 0 1 203.2719 646.4694)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1396,
    style: {
      stopColor: "#FAFAFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3023,
    style: {
      stopColor: "#ECECEC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4765,
    style: {
      stopColor: "#D6D6D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6589,
    style: {
      stopColor: "#B6B6B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8457,
    style: {
      stopColor: "#8D8D8A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#666662"
    }
  })), _polygon22 || (_polygon22 = /*#__PURE__*/React.createElement("polygon", {
    className: "st158",
    points: "974.5,3.8 994.6,-14.6 974.5,-27.3  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_161_",
    gradientUnits: "userSpaceOnUse",
    x1: 644.5852,
    y1: 685.6575,
    x2: 720.1346,
    y2: -802.6764,
    gradientTransform: "matrix(1 0 0 1 203.2719 646.4694)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1396,
    style: {
      stopColor: "#FAFAFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3023,
    style: {
      stopColor: "#ECECEC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4765,
    style: {
      stopColor: "#D6D6D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6589,
    style: {
      stopColor: "#B6B6B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8457,
    style: {
      stopColor: "#8D8D8A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#666662"
    }
  })), _polygon23 || (_polygon23 = /*#__PURE__*/React.createElement("polygon", {
    className: "st159",
    points: "906.1,61.2 920.5,48.1 906.1,37.1  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_162_",
    gradientUnits: "userSpaceOnUse",
    x1: 569.1381,
    y1: 560.6197,
    x2: 637.3157,
    y2: -782.4902,
    gradientTransform: "matrix(1 0 0 1 203.2719 646.4694)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1396,
    style: {
      stopColor: "#FAFAFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3023,
    style: {
      stopColor: "#ECECEC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4765,
    style: {
      stopColor: "#D6D6D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6589,
    style: {
      stopColor: "#B6B6B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8457,
    style: {
      stopColor: "#8D8D8A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#666662"
    }
  })), _polygon24 || (_polygon24 = /*#__PURE__*/React.createElement("polygon", {
    className: "st160",
    points: "823.9,106.4 834.1,96.8 823.9,87.5  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_163_",
    gradientUnits: "userSpaceOnUse",
    x1: 776.5404,
    y1: 919.3441,
    x2: 865.892,
    y2: -840.8963,
    gradientTransform: "matrix(1 0 0 1 203.2719 646.4694)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1396,
    style: {
      stopColor: "#FAFAFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3023,
    style: {
      stopColor: "#ECECEC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4765,
    style: {
      stopColor: "#D6D6D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6589,
    style: {
      stopColor: "#B6B6B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8457,
    style: {
      stopColor: "#8D8D8A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#666662"
    }
  })), _polygon25 || (_polygon25 = /*#__PURE__*/React.createElement("polygon", {
    className: "st161",
    points: "1059.1,108.1 1047.2,116.7 1059.1,125.4  "
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_164_",
    gradientUnits: "userSpaceOnUse",
    x1: 0.642,
    y1: 72.6679,
    x2: 1769.642,
    y2: 72.6679,
    gradientTransform: "matrix(1 0 0 -1 0 146.928)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 0.6,
    y: -85.8,
    style: {
      clipPath: "url(#SVGID_2_)",
      fill: "url(#SVGID_164_)"
    },
    width: 1769,
    height: 320.2
  }), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st290"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st291",
    d: "M156.1,92.6c-0.9,1.1-2.2,1.6-3.8,1.6c-1.8,0-3.3-0.8-4-2c-0.4-0.7-0.5-1.3-0.5-2.9v-5.6 c0-1.6-0.1-2.1-0.9-2.5h3.7c-0.7,0.4-0.9,0.8-0.9,2.5v5.6c0,1.3,0.1,1.8,0.6,2.4c0.6,0.7,1.5,1.1,2.5,1.1c1.1,0,2.2-0.5,2.8-1.3 c0.3-0.4,0.4-0.8,0.4-1.5v-6.3c0-1.6-0.2-2.1-0.9-2.5h3.7c-0.7,0.4-0.9,0.8-0.9,2.5v7.8c0,1.6,0.2,2.1,0.9,2.5h-2.7L156.1,92.6 L156.1,92.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st291",
    d: "M187,92.7c0,0.6,0,0.7,0.1,1c-0.3,0-0.3,0-0.7,0.1c-1.7,0.4-2.7,0.5-3.9,0.5c-2.1,0-3.7-0.4-5.1-1.4 c-1.8-1.2-2.8-3.1-2.8-5.2c0-2.2,1.1-4.1,3-5.4c1.4-0.9,3-1.4,5-1.4c1,0,1.8,0.1,3,0.3v2.2c-0.9-0.8-1.9-1.2-3.4-1.2 c-3.2,0-5.4,2.1-5.4,5.1c0,3,2.5,5.4,5.6,5.4c0.9,0,2-0.1,2.6-0.4v-2.6c0-1.6-0.1-2.1-0.9-2.5h2.9c-0.1,0.2-0.1,0.6-0.1,1.1v4.4 H187z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st291",
    d: "M204.6,91.3l3.4-8.5c0.1-0.4,0.2-0.7,0.2-0.9c0-0.3-0.1-0.5-0.6-0.8h3.1l4.1,10.1c0.6,1.5,1,2.1,1.9,2.6 h-4c0.6-0.3,0.7-0.5,0.7-0.8c0-0.2,0-0.3-0.3-1.1L212,89h-4.9l-1.1,2.9c-0.1,0.4-0.2,0.7-0.2,1c0,0.4,0.2,0.6,0.7,0.9H203 C203.7,93.3,203.9,93,204.6,91.3z M211.3,87.9l-2-5l-2,5H211.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st291",
    d: "M232.8,91.6v-8.2c0-1.3-0.2-1.8-1-2.3h2.8c0.1,0.2,0.1,0.2,0.5,0.7l7.1,9.1v-7.5c0-1.3-0.2-1.7-1-2.3h3.4 c-0.8,0.5-1,1-1,2.3v11.1c-1.1-0.3-1.8-1-2.6-2l-6.8-8.6v7.7c0,1.3,0.2,1.8,1,2.3h-3.4C232.6,93.4,232.8,92.9,232.8,91.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st291",
    d: "M261.4,93.1c0.1-0.4,0.2-0.8,0.2-1.7v-7.7c0-1.6-0.1-2.1-0.9-2.5h1.9c0.3,0,0.8,0,1.3,0c0.6,0,1.2,0,1.5,0 c2.2,0,3.6,0.4,4.9,1.5c1.5,1.1,2.3,2.8,2.3,4.7c0,2.5-1.5,4.8-3.7,5.8c-0.8,0.4-1.5,0.5-2.8,0.6c-0.5,0-1.7,0.1-2.2,0.1h-3.1 C261.3,93.4,261.3,93.4,261.4,93.1z M265,92.5c1.6,0,2.7-0.3,3.5-0.9c1.3-0.9,2-2.3,2-4c0-1.4-0.5-2.8-1.3-3.7 c-0.9-0.9-2.2-1.5-3.9-1.5c-0.6,0-1,0.1-1.8,0.2v9.6C264.1,92.4,264.4,92.5,265,92.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st291",
    d: "M288.6,91.3l3.4-8.5c0.1-0.4,0.2-0.7,0.2-0.9c0-0.3-0.1-0.5-0.6-0.8h3.1l4.1,10.1c0.6,1.5,1,2.1,1.9,2.6 h-4c0.6-0.3,0.7-0.5,0.7-0.8c0-0.2,0-0.3-0.3-1.1L296,89h-4.9l-1.1,2.9c-0.1,0.4-0.2,0.7-0.2,1c0,0.4,0.2,0.6,0.7,0.9H287 C287.7,93.3,288,93,288.6,91.3z M295.4,87.9l-2-5l-2,5H295.4z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st291",
    d: "M299.3,73.9c-0.2,0-0.3,0-0.5,0c-14.9,0-29.7,0-44.6,0c-0.2,0-0.4,0-0.6,0c0,0-0.1-0.1,0-0.1 c0.1-0.1,0.1-0.3,0.2-0.4c0.9-1.5,1.8-3,2.8-4.5c1.2-2,2.4-3.9,3.6-5.9c0.1-0.1,0.2-0.3,0.2-0.4c0.2-0.3,0.5-0.5,0.9-0.5 c0.1,0,0.3,0,0.4,0c0.3,0,0.6,0,0.9,0c4.7,0,9.4,0,14.2,0c0.5,0,0.5,0,0.5-0.1c0-0.2-0.1-0.3-0.2-0.5c-3.4-5.8-6.8-11.7-10.2-17.6 c-0.1-0.1-0.2-0.3-0.2-0.4c-0.1-0.1-0.1-0.1-0.2,0c-0.1,0.1-0.1,0.2-0.2,0.3c-2.7,4.5-5.4,8.9-8.1,13.5c-1.9,3.1-3.8,6.2-5.6,9.3 c-1.1,1.8-2.1,3.6-3.2,5.4c-0.1,0.2-0.2,0.4-0.4,0.6c-0.1,0.2-0.3,0.4-0.5,0.5c-0.4,0.4-0.9,0.6-1.5,0.7c-0.3,0-0.6,0.1-1,0.1 c-1.3,0-2.7,0-4-0.1c-2.5,0-5,0-7.5,0c-0.2,0-0.4,0-0.6,0c0-0.5,0.2-0.8,0.5-1.2c0.1-0.1,0.1-0.2,0.2-0.3c0.2-0.2,0.3-0.5,0.5-0.7 c0.4-0.7,0.9-1.4,1.3-2.1c0.5-0.9,1.1-1.8,1.7-2.7c0.5-0.8,1-1.7,1.4-2.6c0.1-0.2,0.2-0.3,0.2-0.5c0.1-0.1,0.2-0.3,0.3-0.4 c0.9-1.6,1.9-3.1,2.8-4.7c5.1-8.4,10.2-16.9,15.4-25.3c0.4-0.7,0.9-1.4,1.4-2.1c0.5-0.7,1.1-1.4,1.7-2c0.9-0.9,1.9-1.5,3.1-2 c1-0.3,2-0.5,3.1-0.4c1.7,0.1,3.2,0.8,4.5,1.8c0.7,0.6,1.3,1.3,1.8,2c0.4,0.5,0.8,1.1,1.1,1.7c2.2,3.7,4.3,7.3,6.5,11.1 c5.7,9.6,11.4,19.2,17,28.8c0.2,0.4,0.5,0.9,0.7,1.3l0,0C299.3,73.7,299.3,73.8,299.3,73.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st292",
    d: "M118.8,21.5c0.1,0.1,0.1,0.1,0.2,0.1c0.9,0.1,1.7,0.4,2.5,0.8c0.7,0.4,1.3,0.9,1.9,1.5 c0.6,0.7,1,1.4,1.4,2.2c0.8,1.9,1.7,3.8,2.5,5.7c0.7,1.5,1.3,3,1.9,4.5c0.8,1.8,1.5,3.6,2.3,5.3c0.5,1.1,1,2.2,1.4,3.3 c0.5,1.3,1,2.6,1.3,3.9c0.2,0.8,0.3,1.6,0.4,2.4c0.1,0.6,0.1,1.2,0.1,1.8c0,0.8-0.1,1.6-0.2,2.4c-0.1,0.7-0.2,1.3-0.3,2 c-0.4,1.6-0.9,3.1-1.7,4.6c-0.1,0.1-0.2,0.3-0.3,0.4c-0.1,0.1-0.2,0.2-0.3,0.2c-0.2,0.1-0.3,0.1-0.5,0c-0.1-0.1-0.2-0.1-0.3-0.2 c-0.1-0.1-0.2-0.2-0.4-0.4c-0.8-0.8-1.6-1.6-2.4-2.4c-0.5-0.5-1-0.9-1.5-1.4c-0.6-0.7-1.3-1.3-1.9-2c-0.6-0.6-1.2-1.2-1.9-1.6 c-1-0.6-2.1-1.1-3.2-1.3c-0.6,0-1.2-0.2-1.9-0.1c-0.3,0-0.6,0-1,0c-0.2,0-0.3,0-0.5,0c-0.5-0.1-0.9-0.2-1.4-0.1 c-0.3,0-0.6,0.1-1,0.2c-0.6,0.2-1.1,0.5-1.5,1c-0.4,0.4-0.6,0.9-0.8,1.5c-0.1,0.2-0.1,0.3-0.2,0.5c-0.3,0.9-0.8,1.7-1.5,2.4 c-0.9,1-2,1.7-3.3,2.3c-0.8,0.4-1.6,0.6-2.5,0.8c-0.8,0.1-1.5,0.1-2.3,0c-0.7-0.1-1.4-0.3-2-0.5c-1.2-0.4-2.4-0.9-3.4-1.7 c-1-0.7-1.8-1.6-2.4-2.7c-0.6-1.1-1.1-2.3-1.3-3.6c-0.1-0.7-0.2-1.3-0.2-2c0.1-1.8,0.5-3.6,1.5-5.1c0.8-1.3,1.9-2.3,3.2-3.1 c1-0.6,2-1,3.1-1.2c1-0.2,2.1-0.3,3.1-0.2c1.2,0.1,2.3,0.4,3.4,0.9c1.2,0.6,2.2,1.4,3.1,2.4c0.6,0.7,1,1.4,1.4,2.2 c0.1,0.2,0.2,0.4,0.4,0.6c0.3,0.5,0.8,0.8,1.5,0.8c0.2,0,0.5,0,0.7,0c1,0,2.1,0,3.1,0c0.4,0,0.8,0,1.2,0c1,0.1,2.1,0.2,3.1,0.4 c1.4,0.3,2.6,0.8,3.8,1.6c0.4,0.3,0.8,0.6,1.2,1c0.4,0.4,0.8,0.8,1.3,1.2c0.4,0.4,0.9,0.8,1.3,1.2c0.2,0.2,0.4,0.4,0.5,0.5 c0.1,0.1,0.3,0.2,0.4,0.1c0.2,0,0.4-0.2,0.5-0.5c0-0.1,0-0.1,0-0.2c0-0.4,0-0.8,0-1.2c0-1.2-0.1-2.4-0.5-3.5 c-0.2-0.9-0.6-1.8-0.9-2.6c-0.4-1.1-0.9-2.1-1.3-3.1c-0.8-1.7-1.5-3.5-2.3-5.2c-0.7-1.7-1.5-3.4-2.2-5.1c-0.7-1.6-1.4-3.2-2.1-4.8 c-0.2-0.5-0.4-1-0.7-1.4c-0.2-0.3-0.5-0.7-0.8-0.9c-0.5-0.4-1.2-0.5-1.8-0.4c-0.4,0.1-0.8,0.2-1.1,0.4c-0.3,0.2-0.7,0.4-1,0.6 c-0.8,0.5-1.7,1-2.6,1.5c-0.9,0.5-1.9,0.9-2.9,1.3c-1.4,0.6-2.9,1-4.4,1.4c-0.9,0.2-1.9,0.4-2.8,0.6c-0.8,0.1-1.5,0.2-2.3,0.4 c-0.4,0.1-0.8,0.1-1.2,0.1c-0.5,0.1-1,0.1-1.5,0.2c-0.1,0-0.1,0-0.2,0c-1,0.1-2,0.1-3.1,0.1c-0.6,0-1.2,0-1.7,0 c-0.9,0-1.8-0.1-2.7-0.1c-0.6-0.1-1.2-0.1-1.8-0.2C87.9,32,87.5,32,87,32c-0.3,0-0.6-0.1-1-0.1c-0.5-0.1-1-0.2-1.6-0.2 c-0.6-0.1-1.2-0.2-1.8-0.1c-0.6,0-1.2,0.1-1.8,0.4c-0.7,0.3-1.3,0.7-1.7,1.3c-0.3,0.4-0.5,0.8-0.7,1.3c-0.2,0.6-0.4,1.2-0.4,1.8 c-0.1,0.7-0.2,1.4-0.3,2.1c-0.1,0.8-0.3,1.6-0.4,2.5c-0.1,0.5-0.1,1-0.1,1.5c0,0.9,0.2,1.8,0.5,2.6c0.2,0.4,0.4,0.8,0.5,1.3 c0.1,0.3,0.3,0.5,0.4,0.7c0.3,0.4,0.6,0.7,1,0.9c0.4,0.2,0.7,0.4,1.1,0.7c0.6,0.5,1,1,1.3,1.7c0.2,0.5,0.4,1,0.4,1.6 c0,1-0.2,2-0.7,2.8c-0.3,0.6-0.7,1.2-1.2,1.8c-0.8,0.9-1.6,1.8-2.4,2.6c-0.9,0.9-1.8,1.7-2.8,2.6c-0.9,0.8-1.8,1.5-2.6,2.3 c-0.4,0.4-0.9,0.8-1.3,1.1c-0.2,0.1-0.4,0.3-0.6,0.4c-0.3,0.1-0.5,0.1-0.7-0.1c-0.2-0.1-0.3-0.3-0.4-0.4c-0.1-0.2-0.3-0.4-0.4-0.5 c-0.2-0.3-0.4-0.6-0.8-0.8c-0.2-0.1-0.3-0.3-0.4-0.5c0-0.1,0-0.2,0-0.3c0.1-0.2,0.2-0.4,0.3-0.5c0.2-0.2,0.5-0.5,0.7-0.7 c0.6-0.5,1.2-1.1,1.8-1.6c0.7-0.6,1.4-1.3,2.1-1.9c1.2-1.1,2.3-2.1,3.5-3.2c0.3-0.3,0.6-0.6,0.9-0.9c0.3-0.3,0.5-0.6,0.6-0.9 c0.1-0.2,0.2-0.4,0.2-0.6c0.1-0.3,0-0.6-0.2-0.8c-0.1-0.1-0.3-0.2-0.4-0.3c-0.4-0.2-0.7-0.5-1.1-0.8c-0.7-0.6-1.2-1.3-1.7-2 c-0.6-1-1-2-1.2-3.1c-0.2-0.8-0.3-1.7-0.3-2.5c0-0.5-0.1-1.1-0.1-1.6c0-0.8,0.1-1.6,0.2-2.4c0.1-0.5,0.1-1,0.2-1.5 c0.1-0.8,0.3-1.6,0.6-2.4c0.2-0.8,0.5-1.5,0.8-2.3c0.4-0.9,0.9-1.8,1.6-2.6c0.5-0.5,1.1-1,1.7-1.4c0.8-0.5,1.7-0.8,2.7-1 c0.8-0.2,1.5-0.2,2.3-0.2c0.4,0,0.8,0,1.2,0c0.5,0,0.9,0.1,1.4,0.2c0.7,0.1,1.3,0.2,2,0.3c0.4,0.1,0.8,0.1,1.2,0.1 c0.5,0.1,1,0.1,1.5,0.2h0.1c0.7,0,1.5,0.1,2.2,0.1c0.7,0,1.5,0,2.2,0c0.5,0,1,0,1.5-0.1h0.1c0.8,0,1.6-0.1,2.4-0.2 c2.2-0.3,4.4-0.7,6.5-1.3c1.9-0.5,3.7-1.2,5.5-2c0.6-0.3,1.1-0.5,1.7-0.9c0.4-0.2,0.8-0.5,1.1-0.8c1-0.9,2.2-1.4,3.5-1.6 c0.1,0,0.1,0,0.2-0.1C118.1,21.5,118.5,21.5,118.8,21.5z M108.2,51.8c0-0.7-0.2-1.5-0.5-2.2c-0.9-1.9-2.9-3.1-4.9-3.1 c-0.7,0-1.5,0.2-2.1,0.5c-1.4,0.7-2.4,1.8-2.9,3.3c-0.4,1.1-0.4,2.2,0.1,3.3c0.7,1.6,1.9,2.7,3.5,3.3c0.7,0.3,1.5,0.3,2.3,0.2 c0.6-0.1,1.2-0.3,1.7-0.7c0.8-0.5,1.5-1.2,2-2.1C107.9,53.7,108.2,52.8,108.2,51.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st291",
    d: "M53.3,93.3c0,0,0.1,0,0.1-0.1v-0.1c0.1-0.7,0.2-1.5,0.4-2.2c0.2-1.2,0.5-2.3,0.7-3.5 c0.2-1.2,0.5-2.4,0.7-3.6c0.3-1.5,0.6-3,1-4.4c0.4-1.6,0.7-3.2,1.1-4.7c0.2-0.8,0.4-1.6,0.5-2.3c0.3-1.3,0.7-2.5,1.3-3.7 c0.4-0.8,0.8-1.6,1.3-2.3c0.4-0.7,0.9-1.4,1.3-2.1c0.1-0.2,0.3-0.4,0.4-0.5c0.2-0.2,0.5-0.2,0.7,0c0.2,0.1,0.4,0.3,0.6,0.5 c0.9,0.9,1.9,1.8,2.8,2.8c0.9,0.9,1.9,1.9,2.8,2.8c0.4,0.4,0.8,0.8,1.2,1.3s0.9,0.9,1.4,1.3c0.9,0.7,1.8,1.1,2.9,1.4 c0.9,0.2,1.8,0.3,2.7,0.2c0.4,0,0.8,0,1.2,0c0.5,0.1,1.1,0.1,1.6,0.1c1-0.1,1.8-0.5,2.4-1.2c0.3-0.3,0.5-0.7,0.7-1 c0.1-0.3,0.3-0.6,0.4-0.8c0.6-1.5,1.6-2.7,3-3.6c1.1-0.8,2.3-1.2,3.7-1.5c0.9-0.2,1.9-0.2,2.8-0.2c1.7,0.1,3.4,0.7,4.8,1.7 c2.2,1.5,3.6,3.5,4.3,6.1c0.3,1.2,0.3,2.4,0.2,3.6c-0.4,2.9-2.2,5.8-4.9,7.4c-1,0.6-2.2,1-3.3,1.2c-0.4,0.1-0.9,0.1-1.3,0.1 c-3.1,0.1-6.3-1.2-8.3-3.8c-0.3-0.4-0.6-0.9-0.8-1.4c-0.1-0.1-0.1-0.3-0.2-0.4c-0.1-0.2-0.2-0.4-0.4-0.6c-0.4-0.6-1-0.9-1.8-0.9 c-0.3,0-0.6,0-0.9,0c-1.1,0.1-2.3,0.1-3.4,0c-0.5,0-1,0-1.5,0c-2.8-0.1-5.3-1.1-7.3-3.1c-0.5-0.5-1-1-1.5-1.6c-1-1.1-2-2.2-3-3.3 c-0.1-0.1-0.3-0.3-0.4-0.4c-0.1-0.1-0.2-0.1-0.2,0c-0.3,0.6-0.6,1.2-0.8,1.9c-0.4,1.1-0.8,2.3-1,3.4c-0.2,1.1-0.5,2.3-0.7,3.4 c-0.2,1-0.4,2.1-0.7,3.1c-0.3,1.3-0.6,2.6-0.9,3.9c-0.4,1.9-0.8,3.8-1.2,5.7c-0.1,0.3-0.1,0.6-0.2,1c-0.1,0.5-0.1,1-0.1,1.5 c0,0.2,0.1,0.3,0.1,0.4c0.2,0.6,0.6,0.9,1.2,0.9c0.3,0,0.6,0,0.9,0c0.4-0.1,0.8-0.2,1.1-0.3c1.8-0.6,3.7-1.2,5.6-1.6 c1.1-0.3,2.3-0.5,3.4-0.7c1-0.2,2.1-0.3,3.1-0.5c0.8-0.1,1.6-0.2,2.4-0.2c0.7-0.1,1.3-0.1,2-0.2c0.1,0,0.2,0,0.3,0 c2.2-0.1,4.4-0.1,6.6-0.1c4.2,0.1,8.4,0.1,12.7,0.1c1.7,0,3.5,0,5.2,0c2.4,0,4.8,0,7.2,0c0.7,0,1.4,0,2.1-0.2 c0.6-0.1,1.2-0.3,1.8-0.5c0.9-0.4,1.6-1.1,2-2.1c0.2-0.5,0.4-1.1,0.5-1.6c0.1-0.7,0.2-1.3,0.2-2c0-0.4,0-0.8,0-1.2 c0-0.7,0.1-1.5,0.2-2.2c0.3-2.7,1-5.3,1.9-7.9c0.8-2.1,1.7-4.1,2.6-6c0.4-0.8,0.9-1.7,1.3-2.5c0.6-1.1,1.2-2.2,1.8-3.3 c0-0.1,0.1-0.2,0.1-0.3c0.2-0.4,0.2-0.4,0.6-0.2c0.2,0.1,0.3,0.2,0.4,0.3c0.1,0.1,0.3,0.3,0.4,0.4c0.2,0.2,0.4,0.4,0.6,0.5 c0.1,0.1,0.3,0.2,0.4,0.3c0.5,0.5,0.6,1.1,0.4,1.7c-0.1,0.3-0.2,0.5-0.3,0.8c-0.1,0.3-0.3,0.6-0.4,0.9c-0.7,1.3-1.4,2.6-2,3.8 c-0.7,1.3-1.4,2.7-1.9,4.1c-0.5,1.3-0.9,2.6-1.2,3.9c-0.1,0.6-0.2,1.2-0.4,1.8c-0.1,0.6-0.2,1.2-0.3,1.8c-0.1,0.5-0.1,0.9-0.1,1.4 c-0.1,0.8-0.1,1.7-0.1,2.6c0,1.3-0.2,2.6-0.7,3.8c-1,2.5-2.7,4.2-5.2,5.2c-0.7,0.3-1.5,0.4-2.3,0.5c-0.6,0.1-1.2,0.1-1.7,0.1 c-2,0-4,0-6,0c-5,0-9.9,0-15,0c-3,0-6,0-9,0c-1.2,0-2.3,0-3.5,0.1c-0.9,0.1-1.8,0.1-2.7,0.2c-0.8,0.1-1.7,0.2-2.5,0.4 c-1.1,0.2-2.1,0.4-3.2,0.7c-1.6,0.4-3.3,0.9-4.8,1.4c-0.8,0.3-1.7,0.5-2.5,0.7c-0.1,0-0.2,0-0.3,0.1c-0.2,0-0.4,0-0.6,0.1 c-0.4,0-0.9,0-1.3,0c-0.2,0-0.4-0.1-0.6-0.1c-0.2,0-0.4-0.1-0.6-0.1c-2-0.6-3.2-1.9-3.7-3.9c-0.1-0.2-0.1-0.5-0.1-0.8 c0-0.1-0.1-0.2-0.2-0.3C53.3,93.8,53.3,93.5,53.3,93.3z M92.5,80.7c0.3,0,0.6,0,0.9-0.1c1.3-0.3,2.4-0.9,3.3-2 c0.6-0.8,0.9-1.6,1.1-2.6c0.1-0.5,0-1.1-0.1-1.6c-0.4-1.7-1.4-2.9-2.9-3.7c-1.1-0.6-2.3-0.7-3.5-0.4c-1.2,0.3-2.3,1-3,2 c-1,1.3-1.3,2.7-0.9,4.3C88,79.2,90.3,80.7,92.5,80.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st291",
    d: "M194.5,48.3c0,3.3,0,6.6,0,9.9c0,2.9,0,5.8,0,8.7c0,0.8-0.1,1.5-0.2,2.2c-0.2,0.9-0.5,1.8-1,2.6 c-1,1.6-2.5,2.6-4.3,2.9c-0.5,0.1-0.9,0.1-1.4,0.1c-1,0-2-0.3-2.8-0.9c-0.4-0.3-0.8-0.6-1.2-0.9c-0.2-0.2-0.3-0.3-0.5-0.5 c-5.8-6.1-11.7-12.3-17.6-18.5c-1.8-1.9-3.7-3.8-5.5-5.8c-0.4-0.4-0.8-0.7-1.2-1.1h-0.1l0,0v0.1c0,0.1,0,0.2,0,0.4 c0,5.3,0,10.7,0,16.1c0,2.7,0,5.4,0,8.1c0,0.2,0,0.5,0,0.7c0,0.2-0.1,0.3-0.1,0.5c-0.1,0.4-0.4,0.6-0.8,0.7 c-0.3,0.1-0.6,0.1-0.9,0.1c-1.8-0.1-3.5-0.1-5.3-0.1c-0.9,0-1.7,0-2.6,0c-0.2,0-0.4,0-0.7,0c-0.1,0-0.2,0-0.3-0.1 c-0.2-0.1-0.4-0.2-0.5-0.5c-0.1-0.2-0.1-0.3-0.1-0.5c0-0.2,0-0.4,0-0.6c0-7.7,0-15.4,0-23.1c0-3.1,0-6.2,0-9.2c0-1.6,0-3.2,0-4.8 c0-1.2,0.1-2.3,0.5-3.4c0.2-0.7,0.5-1.4,0.9-2c0.9-1.3,2-2.2,3.5-2.6c0.8-0.2,1.5-0.3,2.3-0.2c0.6,0.1,1.2,0.2,1.7,0.5 c0.5,0.2,1.1,0.6,1.5,0.9c0.5,0.4,1,0.8,1.4,1.3c0.8,0.9,1.7,1.8,2.5,2.7c4.6,4.8,9.2,9.7,13.9,14.6c2,2.1,4.1,4.3,6.1,6.4 c0.3,0.3,0.6,0.6,0.9,0.9c0,0,0.1,0,0.2,0c0.2-0.2,0.3-0.5,0.3-0.9c-0.1-1.2,0-2.3,0-3.5s0-2.3,0-3.5c0-3.7,0-7.4,0-11.2 c0-1.9,0-3.7,0-5.6c0-0.2,0-0.4,0-0.6c0-0.2,0.1-0.3,0.1-0.4c0.1-0.3,0.3-0.5,0.7-0.6c0.2-0.1,0.5-0.1,0.7-0.1c0.4,0,0.8,0,1.2,0 c1.2,0.1,2.3,0.1,3.5,0c1.1,0,2.1,0,3.2-0.1c0.2,0,0.4,0,0.6,0c0.2,0,0.4,0,0.6,0.1s0.4,0.2,0.5,0.4c0.1,0.1,0.1,0.3,0.1,0.4 c0,0.2,0,0.4,0,0.7c0,3.4,0,6.8,0,10.2C194.5,42.4,194.5,45.4,194.5,48.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st292",
    d: "M239.8,63.7c0,0.2-0.1,0.3-0.2,0.5c-0.4,0.9-0.9,1.8-1.4,2.6c-0.5,0.9-1.1,1.8-1.7,2.7 c-0.4,0.7-0.9,1.4-1.3,2.1c-0.1,0.2-0.3,0.5-0.5,0.7c-0.1,0.1-0.1,0.2-0.2,0.3c-0.2,0.4-0.4,0.8-0.5,1.2c-0.2,0-0.4,0-0.6,0 c-1.1,0-2.2,0-3.3,0c-0.5,0-0.9,0-1.4,0.1c-0.3,0-0.6,0-0.9-0.1c-0.5-0.1-0.8-0.4-0.9-0.9c-0.1-0.3-0.1-0.5-0.1-0.8 c0-0.5,0-1,0-1.5c0-4.2,0-8.4,0-12.8c0-4.1,0-8.1,0-12.3c0-1.1,0-2.2,0.1-3.3c0-0.3,0-0.5,0-0.8c0-0.4-0.1-0.7-0.2-1.1 c-0.1-0.2-0.2-0.4-0.3-0.5c-0.1-0.1-0.2-0.2-0.4-0.3c-0.3-0.1-0.6-0.2-0.8-0.2c-0.5,0-1,0-1.4,0c-0.3,0-0.6,0-0.9,0 c-1.7,0-3.4,0-5.1,0c-1,0-2.1,0-3.1,0c-0.3,0-0.5,0-0.8-0.1c-0.4-0.1-0.6-0.3-0.7-0.7c0-0.2-0.1-0.4-0.1-0.7c0-0.5,0-1,0-1.5 c0-0.6,0-1.3,0-1.9c0-1.5,0-3,0-4.5c0-0.4,0-0.9,0-1.3c0-0.2,0-0.5,0.1-0.7c0.1-0.3,0.3-0.5,0.6-0.6c0.2-0.1,0.4-0.1,0.6-0.1 c0.5,0,0.9,0,1.4,0c3.1,0,6.2,0,9.3,0c5.2,0,10.4,0,15.7,0c2.1,0.1,4.2,0,6.2,0c2.1,0,4.1,0,6.2,0c0.8,0,1.6,0,2.3,0 c0.3,0,0.5,0,0.8,0.1c0.1,0,0.1,0.1,0.1,0.2c0,0,0,0.1-0.1,0.1c-1.3,2.4-2.5,4.8-3.8,7.2c-0.5,1-1.1,2.1-1.6,3.1 c-0.1,0.3-0.3,0.5-0.4,0.8c-0.2,0.3-0.4,0.5-0.7,0.5c-0.2,0-0.4,0.1-0.6,0.1c0,0,0,0-0.1,0c-1.8,0-3.6,0-5.4,0c-0.7,0-1.3,0-2,0 c-0.3,0-0.7,0-1,0s-0.5,0-0.8,0.1c-0.4,0.1-0.6,0.3-0.7,0.7c0,0.2,0,0.3,0,0.5c0,1.8,0,3.6,0,5.5c0,1.4,0,2.8,0,4.2 c0,3.9,0,7.9,0,11.9c0,0.1,0,0.2,0,0.3C239.5,63.3,239.5,63.3,239.8,63.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st292",
    d: "M211.3,50.9c0,4.5,0,9,0,13.6c0,2.6,0,5.2,0,7.9c0,0.3,0,0.6,0,0.9c0,0.2,0,0.3-0.1,0.5 c-0.1,0.3-0.3,0.5-0.6,0.6c-0.2,0.1-0.4,0.1-0.7,0.1s-0.6,0-0.9,0c-0.3,0-0.6,0-0.9,0c-2.1,0-4.3,0-6.4,0c-0.5,0-1,0-1.5,0.1 c-0.2,0-0.5,0-0.7-0.1c-0.4-0.1-0.6-0.3-0.7-0.7c-0.1-0.2-0.1-0.5-0.1-0.7c0-0.6,0-1.3,0-1.9c0-1.4,0-2.8,0-4.2c0-2.9,0-5.9,0-8.8 c0-3,0-6,0-9c0-3.8,0-7.5,0-11.4c0-2.8,0-5.5,0-8.3c0-0.3,0-0.6,0.1-0.9c0.1-0.3,0.3-0.5,0.6-0.6c0.2-0.1,0.4-0.1,0.6-0.1 c0.7,0,1.4,0,2.1,0.1c0.3,0,0.7,0,1,0c1.5,0,3.1,0,4.6,0c0.7,0,1.4,0,2.1-0.1c0.2,0,0.4,0,0.7,0.1c0.1,0,0.1,0,0.2,0.1 c0.2,0.1,0.3,0.2,0.4,0.4c0.1,0.2,0.1,0.3,0.1,0.5c0,0.3,0,0.5,0,0.8c0,2.3,0,4.6,0,6.9C211.3,41.2,211.3,46.1,211.3,50.9 L211.3,50.9z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st291",
    d: "M92.6,110.3h3.8c0.9,0,1.5,0.1,2,0.2c0.6,0.2,1.1,0.5,1.5,0.9c0.4,0.5,0.8,1,1,1.7s0.3,1.5,0.3,2.4 c0,0.8-0.1,1.6-0.3,2.2c-0.3,0.7-0.6,1.4-1.1,1.8c-0.4,0.4-0.8,0.6-1.5,0.8c-0.5,0.1-1.1,0.2-1.8,0.2h-3.9V110.3z M94.7,112v6.8 h1.5c0.6,0,1,0,1.3-0.1c0.3-0.1,0.6-0.2,0.8-0.4c0.2-0.2,0.4-0.5,0.5-1s0.2-1.1,0.2-1.9c0-0.8-0.1-1.4-0.2-1.8 c-0.1-0.4-0.3-0.8-0.6-1s-0.6-0.4-1-0.5c-0.3-0.1-0.9-0.1-1.7-0.1H94.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st291",
    d: "M104.8,120.5h-2v-7.4h1.8v1.1c0.3-0.5,0.6-0.8,0.8-1c0.2-0.2,0.5-0.2,0.9-0.2c0.4,0,0.9,0.1,1.3,0.4 l-0.6,1.7c-0.3-0.2-0.6-0.3-0.9-0.3s-0.5,0.1-0.7,0.2c-0.2,0.2-0.3,0.4-0.5,0.8c-0.1,0.4-0.2,1.2-0.2,2.5v2.2H104.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st291",
    d: "M108.6,112.1v-1.8h2v1.8H108.6z M108.6,120.5v-7.4h2v7.4H108.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st291",
    d: "M114.7,120.5l-3-7.4h2.1l1.4,3.8l0.4,1.3c0.1-0.3,0.2-0.5,0.2-0.6c0.1-0.2,0.1-0.4,0.2-0.6l1.4-3.8h2 l-3,7.4h-1.7V120.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st291",
    d: "M120.6,112.1v-1.8h2v1.8H120.6z M120.6,120.5v-7.4h2v7.4H120.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st291",
    d: "M131.5,120.5h-2v-3.8c0-0.8,0-1.3-0.1-1.6c-0.1-0.2-0.2-0.4-0.4-0.6c-0.2-0.1-0.4-0.2-0.7-0.2 c-0.3,0-0.6,0.1-0.9,0.3c-0.3,0.2-0.5,0.4-0.6,0.7c-0.1,0.3-0.2,0.9-0.2,1.7v3.4h-2V113h1.8v1.1c0.6-0.8,1.5-1.3,2.5-1.3 c0.4,0,0.8,0.1,1.2,0.2c0.4,0.2,0.6,0.4,0.8,0.6c0.2,0.2,0.3,0.5,0.4,0.8c0.1,0.3,0.1,0.7,0.1,1.3v4.8H131.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st291",
    d: "M133.3,121l2.3,0.3c0,0.3,0.1,0.4,0.3,0.5s0.5,0.2,0.9,0.2c0.5,0,0.9-0.1,1.2-0.2c0.2-0.1,0.3-0.3,0.4-0.5 c0.1-0.2,0.1-0.5,0.1-0.9v-1.1c-0.6,0.8-1.3,1.2-2.2,1.2c-1,0-1.8-0.4-2.4-1.3c-0.5-0.7-0.7-1.5-0.7-2.5c0-1.2,0.3-2.2,0.9-2.9 c0.6-0.7,1.3-1,2.2-1c0.9,0,1.7,0.4,2.3,1.2v-1h1.8v6.7c0,0.9-0.1,1.5-0.2,2c-0.1,0.4-0.3,0.8-0.6,1c-0.3,0.2-0.6,0.4-1,0.6 c-0.4,0.1-1,0.2-1.7,0.2c-1.3,0-2.2-0.2-2.7-0.6s-0.8-1-0.8-1.6C133.3,121.2,133.3,121.1,133.3,121z M135.1,116.7 c0,0.8,0.2,1.4,0.5,1.7c0.3,0.4,0.7,0.6,1.1,0.6c0.5,0,0.9-0.2,1.2-0.6c0.3-0.4,0.5-0.9,0.5-1.7s-0.2-1.3-0.5-1.7 c-0.3-0.4-0.7-0.6-1.2-0.6s-0.9,0.2-1.2,0.6C135.2,115.4,135.1,115.9,135.1,116.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st291",
    d: "M149.7,113.1v1.6h-1.3v3c0,0.6,0,1,0,1.1s0.1,0.2,0.2,0.2c0.1,0.1,0.2,0.1,0.3,0.1c0.2,0,0.4-0.1,0.8-0.2 l0.2,1.5c-0.5,0.2-1,0.3-1.6,0.3c-0.4,0-0.7-0.1-1-0.2c-0.3-0.1-0.5-0.3-0.6-0.5c-0.1-0.2-0.2-0.4-0.3-0.8c0-0.2-0.1-0.7-0.1-1.4 v-3.2h-0.9V113h0.9v-1.5l2-1.1v2.6h1.4V113.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st291",
    d: "M153.1,110.3v3.8c0.6-0.7,1.4-1.1,2.3-1.1c0.5,0,0.9,0.1,1.2,0.3c0.4,0.2,0.6,0.4,0.8,0.6 c0.2,0.3,0.3,0.6,0.4,0.9c0.1,0.3,0.1,0.8,0.1,1.5v4.4h-2v-3.9c0-0.8,0-1.3-0.1-1.5c-0.1-0.2-0.2-0.4-0.4-0.5 c-0.2-0.1-0.4-0.2-0.7-0.2c-0.3,0-0.6,0.1-0.9,0.2c-0.3,0.2-0.4,0.4-0.6,0.7c-0.1,0.3-0.2,0.8-0.2,1.4v3.7h-2v-10.3L153.1,110.3 L153.1,110.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st291",
    d: "M164.2,118.2l2,0.3c-0.3,0.7-0.7,1.3-1.2,1.6c-0.5,0.4-1.2,0.6-2,0.6c-1.3,0-2.3-0.4-2.9-1.3 c-0.5-0.7-0.7-1.5-0.7-2.6c0-1.2,0.3-2.2,1-2.9c0.6-0.7,1.5-1,2.4-1c1.1,0,2,0.4,2.6,1.1c0.6,0.7,0.9,1.9,0.9,3.4h-4.9 c0,0.6,0.2,1,0.5,1.4c0.3,0.3,0.7,0.5,1.1,0.5c0.3,0,0.6-0.1,0.8-0.3C163.9,118.8,164.1,118.6,164.2,118.2z M164.3,116.2 c0-0.6-0.2-1-0.4-1.3c-0.3-0.3-0.6-0.4-1-0.4c-0.4,0-0.8,0.2-1.1,0.5c-0.3,0.3-0.4,0.7-0.4,1.3h2.9V116.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st291",
    d: "M171.8,120.5v-10.3h2.1v10.3H171.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st291",
    d: "M178.3,120.5V112h-3v-1.7h8.2v1.7h-3v8.5H178.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st291",
    d: "M188.7,120.5v-10.3h4.4c1.1,0,1.9,0.1,2.4,0.3s0.9,0.5,1.2,1s0.4,1,0.4,1.6c0,0.8-0.2,1.4-0.7,1.9 s-1.1,0.8-2,0.9c0.4,0.3,0.8,0.5,1.1,0.9c0.3,0.3,0.7,0.9,1.2,1.7l1.3,2h-2.5l-1.5-2.2c-0.5-0.8-0.9-1.3-1.1-1.5 c-0.2-0.2-0.4-0.4-0.6-0.4c-0.2-0.1-0.6-0.1-1-0.1h-0.4v4.3h-2.2V120.5z M190.8,114.6h1.5c1,0,1.6,0,1.9-0.1 c0.2-0.1,0.4-0.2,0.6-0.4c0.1-0.2,0.2-0.5,0.2-0.8c0-0.3-0.1-0.6-0.3-0.8s-0.4-0.3-0.8-0.4c-0.2,0-0.7,0-1.5,0h-1.6L190.8,114.6 L190.8,114.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st291",
    d: "M203.5,118.2l2,0.3c-0.3,0.7-0.7,1.3-1.2,1.6c-0.5,0.4-1.2,0.6-2,0.6c-1.3,0-2.3-0.4-2.9-1.3 c-0.5-0.7-0.7-1.5-0.7-2.6c0-1.2,0.3-2.2,1-2.9c0.6-0.7,1.5-1,2.4-1c1.1,0,2,0.4,2.6,1.1c0.6,0.7,0.9,1.9,0.9,3.4h-4.9 c0,0.6,0.2,1,0.5,1.4c0.3,0.3,0.7,0.5,1.1,0.5c0.3,0,0.6-0.1,0.8-0.3C203.2,118.8,203.4,118.6,203.5,118.2z M203.6,116.2 c0-0.6-0.2-1-0.4-1.3c-0.3-0.3-0.6-0.4-1-0.4c-0.4,0-0.8,0.2-1.1,0.5c-0.3,0.3-0.4,0.7-0.4,1.3h2.9V116.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st291",
    d: "M209.2,120.5l-3-7.4h2.1l1.4,3.8l0.4,1.3c0.1-0.3,0.2-0.5,0.2-0.6c0.1-0.2,0.1-0.4,0.2-0.6l1.4-3.8h2 l-3,7.4h-1.7V120.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st291",
    d: "M214.7,116.7c0-0.7,0.2-1.3,0.5-1.9c0.3-0.6,0.8-1.1,1.4-1.4c0.6-0.3,1.3-0.5,2-0.5c1.1,0,2,0.4,2.8,1.1 c0.7,0.7,1.1,1.7,1.1,2.8s-0.4,2.1-1.1,2.8c-0.7,0.7-1.6,1.1-2.7,1.1c-0.7,0-1.3-0.2-2-0.5c-0.6-0.3-1.1-0.8-1.4-1.4 C214.9,118.3,214.7,117.6,214.7,116.7z M216.8,116.8c0,0.7,0.2,1.3,0.5,1.7c0.4,0.4,0.8,0.6,1.3,0.6s0.9-0.2,1.3-0.6 c0.3-0.4,0.5-1,0.5-1.7c0-0.7-0.2-1.3-0.5-1.7s-0.8-0.6-1.3-0.6s-0.9,0.2-1.3,0.6C217,115.5,216.8,116.1,216.8,116.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st291",
    d: "M224,120.5v-10.3h2v10.3H224z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st291",
    d: "M232.9,120.5v-1.1c-0.3,0.4-0.6,0.7-1.1,0.9c-0.4,0.2-0.9,0.3-1.4,0.3s-0.9-0.1-1.3-0.3 c-0.4-0.2-0.7-0.5-0.9-0.9c-0.2-0.4-0.3-0.9-0.3-1.6v-4.7h2v3.4c0,1,0,1.7,0.1,1.9c0.1,0.2,0.2,0.4,0.4,0.6 c0.2,0.1,0.4,0.2,0.7,0.2s0.6-0.1,0.9-0.3c0.3-0.2,0.4-0.4,0.5-0.7c0.1-0.3,0.1-0.9,0.1-2v-3.1h2v7.4L232.9,120.5L232.9,120.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st291",
    d: "M240.3,113.1v1.6h-1.4v3c0,0.6,0,1,0,1.1s0.1,0.2,0.2,0.2c0.1,0.1,0.2,0.1,0.3,0.1c0.2,0,0.4-0.1,0.8-0.2 l0.2,1.5c-0.5,0.2-1,0.3-1.6,0.3c-0.4,0-0.7-0.1-1-0.2c-0.3-0.1-0.5-0.3-0.6-0.5c-0.1-0.2-0.2-0.4-0.3-0.8c0-0.2-0.1-0.7-0.1-1.4 v-3.2h-0.9V113h0.9v-1.5l2-1.1v2.6h1.5V113.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st291",
    d: "M241.7,112.1v-1.8h2v1.8H241.7z M241.7,120.5v-7.4h2v7.4H241.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st291",
    d: "M245.2,116.7c0-0.7,0.2-1.3,0.5-1.9c0.3-0.6,0.8-1.1,1.4-1.4c0.6-0.3,1.3-0.5,2-0.5c1.1,0,2,0.4,2.8,1.1 c0.7,0.7,1.1,1.7,1.1,2.8s-0.4,2.1-1.1,2.8c-0.7,0.7-1.6,1.1-2.7,1.1c-0.7,0-1.3-0.2-2-0.5c-0.6-0.3-1.1-0.8-1.4-1.4 C245.4,118.3,245.2,117.6,245.2,116.7z M247.2,116.8c0,0.7,0.2,1.3,0.5,1.7c0.4,0.4,0.8,0.6,1.3,0.6s0.9-0.2,1.3-0.6 c0.3-0.4,0.5-1,0.5-1.7c0-0.7-0.2-1.3-0.5-1.7s-0.8-0.6-1.3-0.6s-0.9,0.2-1.3,0.6C247.4,115.5,247.2,116.1,247.2,116.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st291",
    d: "M261.3,120.5h-2v-3.8c0-0.8,0-1.3-0.1-1.6c-0.1-0.2-0.2-0.4-0.4-0.6c-0.2-0.1-0.4-0.2-0.7-0.2 s-0.6,0.1-0.9,0.3c-0.3,0.2-0.5,0.4-0.6,0.7c-0.1,0.3-0.2,0.9-0.2,1.7v3.4h-2V113h1.8v1.1c0.6-0.8,1.5-1.3,2.5-1.3 c0.4,0,0.8,0.1,1.2,0.2c0.4,0.2,0.6,0.4,0.8,0.6c0.2,0.2,0.3,0.5,0.4,0.8c0.1,0.3,0.1,0.7,0.1,1.3v4.8H261.3z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 82.9,
    y: 115.4,
    className: "st291",
    width: 3.6,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 265.5,
    y: 115.4,
    className: "st291",
    width: 5.7,
    height: 2.3
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 444.5,
    y: 26,
    style: {
      clipPath: "url(#SVGID_2_)",
      fill: "#B5C334"
    },
    width: 4.3,
    height: 93.5
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_2_)",
      enableBackground: "new"
    }
  }, _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    className: "st291",
    d: "M595,81.8l5.4,0l0,3l-7.4,0V57.1l2,0L595,81.8z"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    className: "st291",
    d: "M602.7,58.6c-0.3-0.5-0.4-1.1-0.4-1.8c0-0.7,0.1-1.3,0.4-1.8c0.3-0.5,0.6-0.7,1-0.7c0.4,0,0.7,0.2,1,0.7 c0.3,0.5,0.4,1.1,0.4,1.8c0,0.7-0.1,1.3-0.4,1.8c-0.3,0.5-0.6,0.7-1,0.7C603.3,59.3,603,59.1,602.7,58.6z M604.7,62.9l0,21.9l-2,0 l0-21.9L604.7,62.9z"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    className: "st291",
    d: "M612.8,81.5l3.9-18.8l2.2,0L614,84.9l-2.4,0l-4.9-22l2.2,0L612.8,81.5z"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    className: "st291",
    d: "M632.6,75.1l-10.2,0c0.1,2.2,0.5,3.9,1.3,5.1c0.8,1.2,1.7,1.9,2.8,1.9c0.9,0,1.7-0.4,2.3-1.1 c0.6-0.7,1.1-1.8,1.3-3l2.3,0c-0.3,2.2-1,3.9-2.1,5.3c-1,1.3-2.3,2-3.8,2c-1.2,0-2.3-0.5-3.2-1.4c-0.9-1-1.7-2.3-2.2-4.1 c-0.5-1.7-0.8-3.8-0.8-6.1c0-2.3,0.3-4.3,0.8-6.1c0.5-1.7,1.3-3.1,2.2-4c1-0.9,2-1.4,3.3-1.4c1.2,0,2.3,0.4,3.2,1.3 c0.9,0.9,1.7,2.2,2.2,3.8c0.5,1.6,0.8,3.5,0.8,5.5C632.6,73.6,632.6,74.3,632.6,75.1z M629.9,68.5c-0.4-1-0.8-1.8-1.5-2.3 c-0.6-0.5-1.3-0.8-2-0.8c-1.1,0-2,0.6-2.7,1.8c-0.8,1.2-1.2,2.9-1.3,5l8.1,0C630.4,70.7,630.2,69.5,629.9,68.5z"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    className: "st291",
    d: "M637.4,84.5c-0.8-0.6-1.4-1.4-1.9-2.5c-0.5-1.1-0.7-2.3-0.8-3.6l2.2,0c0.1,1.1,0.4,2,0.9,2.8 c0.5,0.7,1.3,1.1,2.2,1.1c0.8,0,1.5-0.3,2-0.9c0.5-0.6,0.7-1.4,0.7-2.4c0-1-0.3-1.7-0.8-2.2c-0.5-0.5-1.3-1-2.4-1.4 c-1-0.4-1.8-0.9-2.4-1.3c-0.6-0.5-1.1-1.1-1.6-2c-0.4-0.9-0.7-2.1-0.6-3.5c0-1.2,0.2-2.2,0.6-3.2c0.4-1,1-1.7,1.7-2.3 c0.7-0.6,1.6-0.9,2.5-0.9c1.4,0,2.6,0.6,3.5,1.9c0.9,1.3,1.4,3,1.4,5.2l-2.2,0c0-1.2-0.3-2.1-0.8-2.8c-0.5-0.7-1.2-1.1-2-1.1 c-0.8,0-1.4,0.3-1.9,0.9c-0.5,0.6-0.7,1.3-0.7,2.3c0,0.7,0.1,1.4,0.4,1.8c0.3,0.5,0.6,0.9,1,1.1c0.4,0.3,1,0.6,1.8,1 c0.9,0.4,1.7,0.9,2.3,1.3c0.6,0.4,1.1,1.1,1.5,1.9c0.4,0.9,0.6,2,0.7,3.4c0,1.2-0.2,2.4-0.6,3.4c-0.4,1-1,1.8-1.7,2.3 c-0.7,0.6-1.6,0.8-2.5,0.8C639.1,85.4,638.2,85.1,637.4,84.5z"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    className: "st291",
    d: "M657.2,65.3l0,13.5c0,1.1,0.1,1.9,0.4,2.4c0.3,0.5,0.8,0.7,1.5,0.7l1.7,0l0,3.2l-2,0 c-1.2,0-2.2-0.5-2.8-1.5c-0.6-1-0.9-2.6-0.9-4.8l0-13.5l-1.7,0l0-3.1l1.7,0l0-5.8l2.2,0l0,5.8l3.5,0l0,3.2L657.2,65.3z"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    className: "st291",
    d: "M667.4,62.7c0.7-0.7,1.6-1.1,2.7-1.1l0,4l-0.6,0c-2.6,0-3.8,2.4-3.8,7l0,12.6l-2.3,0l0-23.1l2.3,0l0,3.8 C666.1,64.5,666.7,63.5,667.4,62.7z"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    className: "st291",
    d: "M672.8,67.2c0.6-1.8,1.4-3.2,2.4-4.2c1-1,2.1-1.5,3.4-1.5c1.2,0,2.3,0.4,3.2,1.3c0.9,0.9,1.6,2,2,3.3l0-4.3 l2.4,0l0,23.5l-2.4,0l0-4.4c-0.5,1.4-1.2,2.5-2.1,3.4c-0.9,0.9-2,1.3-3.2,1.3c-1.2,0-2.4-0.5-3.4-1.6c-1-1-1.8-2.5-2.3-4.3 c-0.6-1.8-0.9-3.9-0.9-6.3C671.9,71.1,672.2,69,672.8,67.2z M683.1,68.9c-0.4-1.3-1-2.3-1.7-3c-0.7-0.7-1.5-1-2.4-1 c-0.9,0-1.7,0.4-2.4,1c-0.7,0.7-1.3,1.7-1.7,3c-0.4,1.3-0.6,2.8-0.6,4.6c0,1.8,0.2,3.3,0.6,4.7c0.4,1.3,1,2.3,1.7,3 c0.7,0.7,1.5,1,2.4,1.1c0.9,0,1.7-0.3,2.4-1c0.7-0.7,1.3-1.7,1.7-3c0.4-1.3,0.6-2.9,0.6-4.6C683.7,71.7,683.5,70.2,683.1,68.9z"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    className: "st291",
    d: "M701.3,63.8c1.1,1.7,1.6,4.3,1.6,7.6l0,14.1l-2.4,0l0-13.5c0-2.4-0.4-4.2-1.1-5.4c-0.7-1.3-1.7-1.9-2.9-1.9 c-1.3,0-2.3,0.7-3,2c-0.7,1.3-1.1,3.2-1.1,5.7l0,13.1l-2.4,0l0-23.6l2.4,0l0,3.4c0.5-1.2,1.1-2.2,1.9-2.8c0.8-0.7,1.7-1,2.7-1 C698.8,61.2,700.2,62,701.3,63.8z"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    className: "st291",
    d: "M709.1,84.9c-0.9-0.6-1.6-1.5-2.1-2.6c-0.5-1.1-0.8-2.4-0.8-3.9l2.5,0c0.1,1.2,0.4,2.2,1,2.9 c0.6,0.8,1.4,1.1,2.4,1.1c0.9,0,1.7-0.3,2.2-1c0.5-0.7,0.8-1.5,0.8-2.5c0-1.1-0.3-1.8-0.9-2.3c-0.6-0.5-1.5-1-2.7-1.5 c-1.1-0.5-2-0.9-2.7-1.4c-0.7-0.5-1.3-1.2-1.8-2.1c-0.5-0.9-0.7-2.2-0.7-3.7c0-1.2,0.2-2.3,0.7-3.4c0.4-1,1.1-1.8,1.9-2.4 c0.8-0.6,1.8-0.9,2.8-0.9c1.6,0,3,0.6,4,2c1,1.3,1.5,3.2,1.6,5.5l-2.5,0c-0.1-1.3-0.4-2.3-0.9-3c-0.6-0.8-1.3-1.1-2.3-1.1 c-0.9,0-1.6,0.3-2.1,0.9c-0.5,0.6-0.8,1.4-0.8,2.4c0,0.8,0.2,1.4,0.5,1.9c0.3,0.5,0.7,0.9,1.2,1.2c0.5,0.3,1.1,0.6,2,1 c1.1,0.5,1.9,0.9,2.6,1.4c0.7,0.5,1.2,1.1,1.7,2c0.5,0.9,0.7,2.1,0.7,3.6c0,1.3-0.2,2.5-0.7,3.6c-0.5,1.1-1.1,1.9-1.9,2.5 c-0.8,0.6-1.8,0.9-2.8,0.9C711,85.8,710,85.5,709.1,84.9z"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    className: "st291",
    d: "M727.1,64.6l-3.2,0l0,20.9l-2.5,0l0-20.9l-1.9,0l0-3.3l1.9,0l0-1.7c0-2.7,0.4-4.7,1.3-6 c0.9-1.3,2.3-1.9,4.2-2l0,3.4c-1.1,0-1.9,0.4-2.3,1.1c-0.4,0.7-0.7,1.8-0.7,3.4l0,1.7l3.2,0L727.1,64.6z"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    className: "st291",
    d: "M732.8,84.4c-1.2-1-2.1-2.5-2.7-4.4c-0.7-1.9-1-4.1-1-6.6c0-2.5,0.3-4.7,1-6.6c0.7-1.9,1.6-3.4,2.8-4.4 c1.2-1,2.5-1.6,3.9-1.6c1.5,0,2.8,0.5,4,1.5c1.2,1,2.1,2.5,2.8,4.4c0.7,1.9,1,4.1,1,6.7c0,2.5-0.4,4.8-1.1,6.7 c-0.7,1.9-1.7,3.4-2.9,4.5c-1.2,1-2.5,1.6-4,1.5C735.3,86,734,85.5,732.8,84.4z M739.3,81.4c0.8-0.7,1.5-1.7,2-3.1 c0.5-1.4,0.8-3.1,0.8-5c0-2-0.2-3.6-0.7-5c-0.5-1.4-1.1-2.4-1.9-3.1c-0.8-0.7-1.6-1-2.6-1c-0.9,0-1.8,0.4-2.6,1 c-0.8,0.7-1.4,1.7-1.9,3.1c-0.5,1.4-0.7,3-0.7,5c0,2,0.2,3.7,0.7,5c0.5,1.4,1.1,2.4,1.8,3.1c0.8,0.7,1.6,1,2.5,1 C737.6,82.4,738.5,82.1,739.3,81.4z"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    className: "st291",
    d: "M752.6,61.6c0.9-0.8,1.9-1.2,3.1-1.2l0,4.3l-0.7,0c-2.9,0-4.4,2.5-4.4,7.5l0,13.5l-2.6,0l0-24.7l2.6,0l0,4 C751.1,63.5,751.8,62.4,752.6,61.6z"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    className: "st291",
    d: "M781.6,61.3c1,0.8,1.8,2,2.4,3.7c0.6,1.6,0.9,3.6,0.9,6l0,15l-2.7,0l0-14.4c0-2.5-0.4-4.5-1.2-5.8 c-0.8-1.3-1.9-2-3.3-2c-1.4,0-2.5,0.7-3.4,2.1c-0.8,1.4-1.3,3.4-1.3,6.1l0,13.9l-2.7,0l0-14.2c0-2.5-0.4-4.4-1.2-5.7 c-0.8-1.3-1.9-2-3.2-2c-1.4,0-2.5,0.7-3.3,2.1c-0.8,1.4-1.2,3.4-1.2,6l0,13.8l-2.6,0l0.1-24.9l2.6,0l0,3.6c0.5-1.3,1.2-2.3,2.1-3 c0.9-0.7,1.9-1.1,2.9-1.1c1.4,0,2.5,0.4,3.6,1.4c1,0.9,1.8,2.3,2.3,4.2c0.5-1.8,1.2-3.2,2.3-4.2c1.1-1,2.2-1.5,3.5-1.5 C779.5,60.1,780.6,60.5,781.6,61.3z"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    className: "st291",
    d: "M804.6,74.7l-13.5,0c0.1,2.5,0.7,4.5,1.7,5.9c1,1.4,2.3,2.1,3.7,2.1c1.2,0,2.2-0.4,3-1.3 c0.8-0.9,1.4-2,1.7-3.4l3,0c-0.5,2.5-1.4,4.5-2.7,6c-1.4,1.5-3.1,2.3-5.1,2.3c-1.6,0-3-0.6-4.3-1.7c-1.2-1.1-2.2-2.6-2.9-4.6 c-0.7-2-1.1-4.3-1-7c0-2.6,0.4-4.9,1-6.9c0.7-2,1.7-3.5,2.9-4.6c1.3-1.1,2.7-1.6,4.3-1.7c1.6,0,3,0.5,4.2,1.5 c1.2,1.1,2.2,2.5,2.9,4.4c0.7,1.9,1,4,1,6.3C804.7,72.9,804.6,73.8,804.6,74.7z M801.1,67c-0.5-1.2-1.1-2.1-1.9-2.7 c-0.8-0.6-1.7-0.9-2.7-0.9c-1.4,0-2.6,0.7-3.6,2.1c-1,1.4-1.6,3.3-1.7,5.7l10.6-0.1C801.8,69.6,801.5,68.2,801.1,67z"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    className: "st291",
    d: "M808.4,66c0.7-2,1.7-3.6,2.9-4.7c1.2-1.1,2.7-1.7,4.2-1.7c1.3,0,2.6,0.4,3.8,1.4c1.2,0.9,2.1,2.1,2.7,3.7 l0-13.8l2.9-0.1l-0.1,35.4l-2.9,0l0-4.9c-0.6,1.6-1.4,2.8-2.6,3.8c-1.1,1-2.4,1.5-3.9,1.5c-1.5,0-2.9-0.6-4.2-1.7 c-1.2-1.1-2.2-2.7-2.9-4.8c-0.7-2-1-4.4-1-7C807.4,70.3,807.7,68,808.4,66z M821.2,67.8c-0.5-1.5-1.2-2.6-2.1-3.3 c-0.9-0.8-1.9-1.1-3-1.1c-1.1,0-2.1,0.4-2.9,1.2c-0.9,0.8-1.6,1.9-2.1,3.3c-0.5,1.5-0.8,3.2-0.8,5.1c0,2,0.3,3.7,0.8,5.2 c0.5,1.5,1.2,2.6,2.1,3.4c0.9,0.8,1.9,1.2,2.9,1.2c1.1,0,2.1-0.4,3-1.2c0.9-0.8,1.6-1.9,2.2-3.4c0.5-1.5,0.8-3.2,0.8-5.2 C822,71,821.7,69.3,821.2,67.8z"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    className: "st291",
    d: "M842.2,63.3l0,15.6c0,1.3,0.2,2.2,0.6,2.7c0.4,0.5,1,0.8,1.9,0.8l2.2,0l0,3.7l-2.7,0 c-1.7,0-2.9-0.6-3.7-1.7c-0.8-1.1-1.2-3-1.2-5.6l0-15.6l-2.3,0l0-3.6l2.3,0l0-6.7l3-0.1l0,6.7l4.7-0.1l0,3.6L842.2,63.3z"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    className: "st291",
    d: "M863.5,60.2c1.1,0.9,2,2.2,2.7,3.9c0.6,1.7,1,3.9,0.9,6.4l-0.1,15.9l-3.1,0l0.1-15.3c0-2.7-0.4-4.7-1.4-6.2 c-0.9-1.4-2.2-2.1-3.8-2.1c-1.6,0-2.9,0.8-3.9,2.2c-1,1.5-1.4,3.6-1.4,6.4l0,14.8l-3,0l0.1-36.1l3-0.1l0,13.2 c0.6-1.4,1.4-2.4,2.5-3.2c1.1-0.8,2.3-1.2,3.6-1.2C861.1,58.9,862.4,59.4,863.5,60.2z"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    className: "st291",
    d: "M877.7,60c1-0.9,2.3-1.3,3.8-1.3l0,4.7l-0.8,0c-3.5,0-5.3,2.8-5.3,8.3l-0.1,14.8l-3.1,0l0.1-27.1l3.1,0 l0,4.4C875.9,62.1,876.7,60.9,877.7,60z"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    className: "st291",
    d: "M888.6,85.2c-1.5-1.2-2.6-2.8-3.4-5c-0.8-2.1-1.2-4.6-1.2-7.5c0-2.8,0.4-5.3,1.3-7.4c0.9-2.2,2-3.8,3.5-5 c1.5-1.2,3.1-1.8,5-1.8c1.8,0,3.5,0.5,5,1.7c1.5,1.1,2.7,2.8,3.5,4.9c0.9,2.2,1.3,4.7,1.3,7.5c0,2.9-0.5,5.4-1.4,7.6 c-0.9,2.2-2.1,3.8-3.6,5c-1.5,1.2-3.2,1.7-5,1.7C891.7,87,890,86.4,888.6,85.2z M896.7,81.8c1-0.8,1.9-1.9,2.5-3.5 c0.6-1.5,1-3.4,1-5.7c0-2.2-0.3-4.1-0.9-5.6c-0.6-1.5-1.4-2.7-2.4-3.4c-1-0.7-2.1-1.1-3.2-1.1c-1.2,0-2.3,0.4-3.2,1.2 c-1,0.8-1.8,1.9-2.4,3.5c-0.6,1.5-0.9,3.4-0.9,5.6c0,2.2,0.3,4.1,0.8,5.7c0.6,1.5,1.3,2.7,2.3,3.4c1,0.8,2,1.1,3.2,1.1 C894.6,83,895.7,82.6,896.7,81.8z"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    className: "st291",
    d: "M925.7,58.6l-0.1,28.2l-3.4,0l0-4.2c-0.6,1.4-1.5,2.5-2.7,3.3c-1.1,0.8-2.4,1.2-3.8,1.2 c-1.6,0-2.9-0.5-4.2-1.4c-1.2-0.9-2.2-2.3-2.9-4.1c-0.7-1.8-1-4-1-6.5l0.1-16.3l3.3,0l-0.1,15.7c0,2.7,0.5,4.9,1.5,6.3 c1,1.5,2.3,2.2,4.1,2.2c1.8,0,3.2-0.8,4.2-2.3c1-1.5,1.6-3.8,1.6-6.7l0.1-15.4L925.7,58.6z"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    className: "st291",
    d: "M944.6,59.5c1.3,1.1,2.4,2.4,3,4l0-5.2l3.5,0L951,87.5c0,2.6-0.4,4.9-1.3,7c-0.8,2-2,3.6-3.5,4.7 c-1.5,1.1-3.3,1.7-5.3,1.6c-2.7,0-5-1-6.8-2.7c-1.8-1.8-2.8-4.2-3.1-7.2l3.4,0c0.4,1.7,1.1,3.1,2.3,4.2c1.2,1.1,2.6,1.6,4.2,1.6 c1.9,0,3.4-0.8,4.7-2.4c1.2-1.6,1.8-3.9,1.8-6.9l0-6c-0.7,1.7-1.7,3.1-3.1,4.2c-1.3,1.1-2.9,1.6-4.7,1.6c-1.8,0-3.5-0.6-5-1.9 c-1.5-1.2-2.6-3-3.5-5.2c-0.8-2.2-1.2-4.8-1.2-7.6c0-2.9,0.4-5.4,1.3-7.6c0.9-2.2,2-3.9,3.5-5.1c1.5-1.2,3.2-1.9,5-1.9 C941.7,57.9,943.2,58.4,944.6,59.5z M946.6,66.9c-0.6-1.6-1.5-2.8-2.5-3.6c-1.1-0.8-2.2-1.3-3.5-1.2c-1.3,0-2.5,0.4-3.5,1.3 c-1.1,0.8-1.9,2.1-2.5,3.6c-0.6,1.6-1,3.5-1,5.6c0,2.2,0.3,4.1,0.9,5.7c0.6,1.6,1.4,2.8,2.5,3.7c1,0.8,2.2,1.3,3.5,1.3 c1.3,0,2.5-0.4,3.5-1.3c1.1-0.8,1.9-2.1,2.6-3.7c0.6-1.6,1-3.5,1-5.7C947.5,70.4,947.2,68.5,946.6,66.9z"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    className: "st291",
    d: "M972,58.8c1.3,0.9,2.3,2.3,3.1,4.2c0.7,1.9,1.1,4.2,1.1,6.9L976.1,87l-3.6,0l0.1-16.4 c0-2.9-0.5-5.1-1.6-6.6c-1.1-1.5-2.5-2.3-4.4-2.3c-1.9,0-3.4,0.8-4.5,2.4c-1.1,1.6-1.7,3.9-1.7,6.9l-0.1,15.9l-3.5,0l0.2-38.9 l3.5-0.1l-0.1,14.2c0.7-1.5,1.7-2.6,2.9-3.5c1.2-0.8,2.6-1.2,4.2-1.3C969.2,57.4,970.7,57.9,972,58.8z"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    className: "st291",
    d: "M1013.7,74.3l-15.9,0c0.1,1.9,0.5,3.3,1.3,4.3c0.8,1,1.8,1.5,3,1.5c1.8,0,3-1,3.7-2.9l7.5,0 c-0.4,2-1.1,3.8-2.1,5.4c-1,1.6-2.3,2.8-3.8,3.7c-1.5,0.9-3.2,1.3-5.1,1.3c-2.2,0-4.2-0.7-6-1.9c-1.7-1.3-3.1-3.1-4-5.4 c-1-2.3-1.4-5-1.4-8.2c0-3.1,0.5-5.8,1.5-8.2c1-2.3,2.3-4.1,4.1-5.4c1.7-1.3,3.7-1.9,6-2c2.2,0,4.2,0.6,5.9,1.8 c1.7,1.2,3.1,3,4.1,5.2c1,2.3,1.4,4.9,1.4,8C1013.8,72.4,1013.8,73.3,1013.7,74.3z M1006.6,69.1c0-1.6-0.4-2.9-1.2-3.8 c-0.8-0.9-1.8-1.4-3.1-1.4c-1.2,0-2.2,0.5-3,1.4c-0.8,0.9-1.3,2.2-1.5,3.8L1006.6,69.1z"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    className: "st291",
    d: "M1022.4,86.3c-1.7-0.9-3.1-2.3-4.1-4.1c-1-1.8-1.5-3.9-1.6-6.4l7.6,0c0.1,1.4,0.5,2.5,1.1,3.3 c0.6,0.8,1.5,1.1,2.5,1.1c1.1,0,1.9-0.3,2.6-1c0.6-0.6,0.9-1.5,1-2.7c0-1-0.2-1.7-0.7-2.4c-0.5-0.6-1.1-1.1-1.8-1.5 c-0.7-0.4-1.7-0.9-3.1-1.4c-1.9-0.8-3.5-1.5-4.7-2.3c-1.2-0.8-2.2-1.9-3.1-3.4c-0.9-1.5-1.3-3.4-1.3-5.8c0-3.6,1-6.4,3-8.4 c2-2.1,4.6-3.1,7.8-3.2c3.3-0.1,5.9,0.9,7.9,2.9c2,2,3.1,4.8,3.2,8.5l-7.9,0.1c0-1.2-0.4-2.2-1-2.9c-0.6-0.7-1.5-1.1-2.5-1 c-0.9,0-1.6,0.3-2.1,0.9c-0.5,0.6-0.8,1.5-0.8,2.6c0,1.2,0.4,2.2,1.3,2.9c0.9,0.7,2.3,1.4,4.2,2.2c1.9,0.8,3.5,1.6,4.7,2.4 c1.2,0.8,2.3,1.9,3.1,3.4c0.9,1.5,1.3,3.4,1.3,5.7c0,2.2-0.5,4.2-1.3,6c-0.9,1.8-2.2,3.2-3.8,4.3c-1.7,1.1-3.6,1.6-5.8,1.6 C1026,87.7,1024.1,87.2,1022.4,86.3z"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    className: "st291",
    d: "M1066.7,74.1l-17,0c0.1,1.9,0.6,3.4,1.4,4.4c0.9,1,1.9,1.5,3.2,1.5c1.9,0,3.2-1,3.9-3l8.1,0 c-0.4,2.1-1.2,3.9-2.3,5.6c-1.1,1.6-2.4,2.9-4.1,3.9c-1.6,0.9-3.4,1.4-5.4,1.4c-2.4,0-4.5-0.7-6.4-2c-1.8-1.3-3.3-3.2-4.3-5.6 c-1-2.4-1.5-5.2-1.5-8.4c0-3.2,0.5-6,1.6-8.5c1-2.4,2.5-4.3,4.3-5.6c1.9-1.3,4-2,6.4-2c2.4,0,4.5,0.6,6.3,1.8 c1.9,1.3,3.3,3.1,4.3,5.4c1,2.4,1.5,5.1,1.5,8.3C1066.8,72.2,1066.8,73.2,1066.7,74.1z M1059.1,68.8c0-1.6-0.4-3-1.3-3.9 c-0.9-1-2-1.4-3.3-1.4c-1.3,0-2.3,0.5-3.2,1.4c-0.9,0.9-1.4,2.3-1.6,4L1059.1,68.8z"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    className: "st291",
    d: "M1082,57.1c1.4-1,2.9-1.5,4.6-1.6l-0.1,10.3l-2.1,0c-1.9,0-3.4,0.5-4.4,1.6c-1,1-1.5,2.9-1.5,5.5l-0.1,14.7 l-7.7,0l0.2-31.5l7.7-0.1l0,5.3C1079.5,59.5,1080.6,58.1,1082,57.1z"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    className: "st291",
    d: "M1101.8,78.6l5.8-23l8.6-0.1l-9.5,32.4l-9.8-0.1l-8.9-31.9l8.4-0.1L1101.8,78.6z"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    className: "st291",
    d: "M1120.2,50.4c-0.9-1-1.3-2.3-1.3-3.8c0-1.6,0.5-2.9,1.4-3.9c0.9-1,2.1-1.6,3.5-1.6c1.4,0,2.6,0.5,3.5,1.5 c0.9,1,1.4,2.3,1.3,3.9c0,1.5-0.5,2.8-1.4,3.9c-0.9,1-2.1,1.6-3.5,1.6C1122.2,51.9,1121.1,51.5,1120.2,50.4z M1127.7,55.3 l-0.2,32.7l-8.2,0l0.2-32.5L1127.7,55.3z"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    className: "st291",
    d: "M1133.7,62.6c1.2-2.6,2.8-4.5,4.8-5.9c2.1-1.4,4.4-2.1,7.1-2.2c3.4,0,6.3,1,8.6,3.2 c2.3,2.2,3.8,5.2,4.5,9.2l-9,0.1c-0.7-2.5-2.2-3.8-4.3-3.8c-1.5,0-2.8,0.7-3.7,2.2c-0.9,1.4-1.4,3.5-1.4,6.2 c0,2.7,0.4,4.7,1.3,6.2c0.9,1.4,2.1,2.2,3.7,2.2c2.2,0,3.6-1.3,4.4-3.8l9,0c-0.8,3.9-2.3,6.9-4.7,9.2c-2.4,2.2-5.2,3.3-8.6,3.3 c-2.7,0-5-0.7-7.1-2.1c-2-1.4-3.6-3.3-4.8-5.9c-1.1-2.5-1.7-5.5-1.7-8.9C1132,68.2,1132.6,65.2,1133.7,62.6z"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    className: "st291",
    d: "M1190,73.8l-19.8,0c0.1,2.1,0.7,3.7,1.7,4.8c1,1.1,2.2,1.7,3.7,1.7c2.2,0,3.7-1.1,4.6-3.3l9.3,0 c-0.5,2.2-1.4,4.2-2.7,6c-1.3,1.8-2.8,3.2-4.7,4.2c-1.9,1-4,1.5-6.3,1.5c-2.8,0-5.2-0.7-7.4-2.1c-2.1-1.4-3.8-3.4-5-6 c-1.2-2.6-1.8-5.6-1.7-9.1c0-3.5,0.6-6.5,1.8-9.1c1.2-2.6,2.9-4.6,5-6c2.2-1.4,4.6-2.2,7.5-2.2c2.7,0,5.2,0.6,7.3,2 c2.1,1.3,3.8,3.3,5,5.8c1.2,2.5,1.8,5.5,1.8,8.9C1190.1,71.8,1190.1,72.8,1190,73.8z M1181.2,68.1c0-1.8-0.5-3.2-1.5-4.2 c-1-1-2.3-1.5-3.8-1.5c-1.5,0-2.7,0.5-3.7,1.5c-1,1-1.6,2.4-1.9,4.3L1181.2,68.1z"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    className: "st291",
    d: "M1199.7,87.3c-2-1-3.5-2.4-4.7-4.2c-1.1-1.8-1.8-3.7-1.9-5.9l8.8,0c0.1,1.2,0.6,2.1,1.4,2.9 c0.8,0.7,1.9,1.1,3.1,1.1c1.1,0,2-0.3,2.6-0.8c0.6-0.5,0.9-1.2,0.9-2c0-1-0.4-1.7-1.3-2.2c-0.9-0.5-2.3-1-4.3-1.6 c-2.1-0.6-3.8-1.2-5.2-1.8c-1.4-0.6-2.6-1.6-3.6-3c-1-1.4-1.5-3.2-1.5-5.5c0-1.9,0.5-3.7,1.4-5.3c0.9-1.6,2.3-2.9,4.1-3.9 c1.8-1,3.9-1.5,6.4-1.5c3.7-0.1,6.6,1,8.7,3.1c2.1,2.1,3.3,4.9,3.6,8.5l-8.4,0.1c-0.1-1.2-0.6-2.1-1.3-2.8c-0.8-0.7-1.7-1-3-1 c-1.1,0-1.9,0.3-2.4,0.7c-0.6,0.5-0.8,1.1-0.9,1.9c0,1,0.4,1.7,1.3,2.2c0.9,0.5,2.3,1,4.2,1.4c2.2,0.6,4,1.3,5.3,1.9 c1.4,0.6,2.6,1.7,3.6,3.1c1,1.4,1.6,3.3,1.6,5.7c0,2-0.5,3.8-1.5,5.4c-1,1.6-2.4,2.8-4.2,3.7c-1.8,0.9-3.9,1.3-6.3,1.3 C1204,88.9,1201.7,88.3,1199.7,87.3z"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    className: "st291",
    d: "M1261.2,47.1c3.1,1.8,5.5,4.4,7.2,7.7c1.7,3.3,2.5,7.2,2.5,11.6c0,4.4-0.9,8.3-2.7,11.6 c-1.7,3.4-4.2,6-7.3,7.8c-3.1,1.8-6.7,2.7-10.8,2.7l-14.4-0.1l0.4-43.8l14.5-0.3C1254.5,44.4,1258.1,45.3,1261.2,47.1z M1258,76 c2-2.2,3.1-5.4,3.1-9.5c0-4.1-0.9-7.3-2.9-9.5c-2-2.2-4.8-3.3-8.4-3.3l-4.5,0.1l-0.2,25.6l4.5,0C1253.1,79.3,1255.9,78.2,1258,76z "
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    className: "st291",
    d: "M1306.6,73.5l-22.5,0.1c0.1,2.2,0.8,3.9,1.9,5.1c1.1,1.2,2.5,1.8,4.2,1.8c2.5,0,4.2-1.2,5.2-3.5l10.7,0 c-0.6,2.4-1.6,4.5-3,6.4c-1.4,1.9-3.2,3.4-5.4,4.4c-2.1,1.1-4.5,1.6-7.2,1.6c-3.2,0-6-0.8-8.4-2.3c-2.4-1.5-4.3-3.6-5.7-6.4 c-1.3-2.8-2-6-2-9.7c0-3.7,0.7-6.9,2.1-9.7c1.4-2.8,3.3-4.9,5.7-6.5c2.5-1.5,5.3-2.3,8.5-2.4c3.1,0,5.9,0.6,8.4,2.1 c2.4,1.4,4.4,3.5,5.7,6.2c1.4,2.7,2,5.9,2,9.5C1306.8,71.3,1306.7,72.4,1306.6,73.5z M1296.6,67.4c0-1.9-0.6-3.4-1.7-4.5 c-1.2-1.1-2.6-1.7-4.3-1.6c-1.7,0-3.1,0.6-4.2,1.6c-1.1,1.1-1.9,2.6-2.1,4.6L1296.6,67.4z"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    className: "st291",
    d: "M1322.6,40.7l-0.5,48.4l-10.2-0.1l0.4-48.2L1322.6,40.7z"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    className: "st291",
    d: "M1330.7,46.9c-1.1-1.1-1.7-2.6-1.7-4.3c0-1.8,0.6-3.2,1.8-4.4c1.2-1.2,2.7-1.8,4.5-1.8 c1.8,0,3.3,0.5,4.4,1.7c1.1,1.1,1.7,2.6,1.7,4.4c0,1.7-0.6,3.2-1.8,4.4c-1.2,1.2-2.7,1.8-4.4,1.8 C1333.4,48.6,1331.9,48,1330.7,46.9z M1340.3,52.3l-0.4,36.9l-10.4-0.1l0.3-36.7L1340.3,52.3z"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    className: "st291",
    d: "M1363.3,78.6l7.9-26.7l11.6-0.2l-13,37.6l-13.2-0.1l-11.9-37l11.3-0.2L1363.3,78.6z"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    className: "st291",
    d: "M1421.3,73.3l-25.4,0.1c0.1,2.4,0.9,4.2,2.1,5.4c1.3,1.3,2.8,1.9,4.7,1.9c2.8,0,4.7-1.2,5.9-3.7l12,0 c-0.6,2.5-1.8,4.8-3.4,6.8c-1.6,2-3.7,3.6-6.1,4.7c-2.4,1.1-5.1,1.7-8.1,1.7c-3.6,0-6.7-0.8-9.5-2.4c-2.7-1.6-4.9-3.9-6.4-6.8 c-1.5-2.9-2.2-6.4-2.2-10.3c0-3.9,0.8-7.4,2.4-10.3c1.6-3,3.7-5.2,6.5-6.9c2.8-1.6,6-2.5,9.6-2.5c3.5,0,6.7,0.7,9.4,2.2 c2.8,1.5,4.9,3.7,6.5,6.6c1.5,2.9,2.3,6.3,2.3,10.1C1421.6,70.9,1421.5,72.1,1421.3,73.3z M1410,66.8c0-2-0.6-3.6-1.9-4.8 c-1.3-1.2-2.9-1.8-4.9-1.7c-1.9,0-3.5,0.6-4.7,1.7c-1.3,1.1-2.1,2.8-2.4,4.9L1410,66.8z"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    className: "st291",
    d: "M1444.4,52.3c2.1-1.3,4.3-1.9,6.9-1.9l-0.1,12.7l-3.2,0c-2.9,0-5.1,0.7-6.6,2c-1.5,1.3-2.2,3.5-2.2,6.7 l-0.2,18l-11.5-0.1l0.4-38.6l11.5-0.2l-0.1,6.5C1440.6,55.3,1442.3,53.6,1444.4,52.3z"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    className: "st291",
    d: "M1497,50.2l-25.5,58.5l-12.8-0.2l9.1-19.9l-15.3-37.8l13.2-0.2l8.7,24.6l9.3-24.8L1497,50.2z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNitaLogo);
export default __webpack_public_path__ + "static/media/nita_logo.125f40afb1b3193bb392cd9865c42a32.svg";
export { ForwardRef as ReactComponent };